const messages = {
  de: {
    translations: {
      seller_queue: {
        modal: {
          sale_outcome: {
            completed: 'Verkauf abgeschlossen',
            not_completed: 'Verkauf nicht abgeschlossen',
          },
          reasons: {
            label: 'Grund für den Nichtverkauf:',
            loading: 'Lade Gründe...',
            load_error: 'Fehler beim Laden der Gründe. Bitte versuchen Sie es erneut.',
            retry: 'Erneut versuchen',
            placeholder: 'Wählen Sie einen Grund...',
          },
          buttons: {
            cancel: 'Abbrechen',
            next: 'Weiter →',
          },
        },
        "seller_queue":"Verkäuferwarteschlange",
        "queue_status":"Status der Warteschlange",
        "queue_position":"Position in der Warteschlange",
        "queue_duration":"Dauer",
        "queue_seller_status":"Status des Verkäufers",
        "queue_in_service":"In Bearbeitung",
        "queue_not_in_service":"Nicht in Bearbeitung",
        "queue_no_entry":"Sie sind nicht in der Warteschlange",
        "queue_loading":"Lädt...",
        "queue_error":"Fehler: {{error}}",
        "queue_view_details":"Details anzeigen",
      },
      gridHotelFeedback: {
        dashboard: 'Dashboard',
        service_grid: 'Umfrage- und Zufriedenheitsraster',
        service_grid_single: 'Umfrage- und Zufriedenheitsraster',
        listed_grids: 'Die Umfrage- und Zufriedenheitsraster sind unten aufgeführt',
        create_service_grid: 'Umfrage- und Zufriedenheitsraster erstellen',
        title: 'Titel',
        status: 'Status',
        grid_deleted: 'Raster gelöscht!',
        grid_deleted_message: 'Das Umfrage- und Zufriedenheitsraster wurde erfolgreich gelöscht.',
        error: 'Fehler',
        error_delete_message:
          'Beim Löschen des Umfrage- und Zufriedenheitsrasters ist ein Fehler aufgetreten.',
        service_grid_name: 'Titel',
        service_grid_name_placeholder: 'Bsp.: Zufriedenheitsumfrage',
        fill_information_create:
          'Füllen Sie die folgenden Informationen aus und klicken Sie auf die Schaltfläche "Erstellen", um die Änderungen zu speichern',
        missing_fields: 'Pflichtfelder',
        missing_fields_message: 'Das Feld "Titel" und die "Artikelliste" sind Pflichtfelder!',
        grid_created: 'Raster erstellt',
        grid_created_message: 'Erstellung erfolgreich abgeschlossen!',
        error_create_message: 'Fehler beim Erstellen des Rasters!',
        service_list: 'Artikelliste',
        service_placeholder: 'Artikel hinzufügen (Bsp.: Zimmerqualität)',

        // CHAVES ADICIONADAS/MIGRADAS PARA A PÁGINA DE EDIÇÃO (UPDATE)
        edit_service_grid: 'Umfrage- und Zufriedenheitsraster bearbeiten',
        save_changes_edit:
          'Füllen Sie die folgenden Informationen aus und klicken Sie auf die Schaltfläche "Speichern", um die Änderungen zu bestätigen',
        grid_updated: 'Raster geändert',
        grid_updated_message: 'Bearbeitung erfolgreich abgeschlossen!',
        error_update_message: 'Fehler beim Ändern des Rasters!',

        general: {
          actions: 'Aktionen',
          edit: 'Bearbeiten',
          delete: 'Löschen',
          active: 'Aktiv',
          inactive: 'Inaktiv',
          select: 'Auswählen',
          back: 'Zurück',
        },
        buttons: {
          create: 'Erstellen',
          back: 'Zurück',
          save: 'Speichern',
        },
      },
      // Übersetzungen für die Sprachen- und Beziehungsverwaltungsseite der Geschäfte
      translate_stores: {
        page_title: 'Verwaltung von Sprachen und Store-Beziehungen',
        page_subtitle:
          'Verwalten Sie die Übersetzungssprachen und die Beziehungen jedes Stores im System.',
        page_title_relationships: 'Verwaltung von Store-Beziehungen',
        page_subtitle_relationships: 'Verwalten Sie die Beziehungen zwischen den Stores im System.',
        tab_translations: 'Sprachen verwalten',
        tab_relations: 'Store-Beziehungen',
        breadcrumb: {
          dashboard: 'Dashboard',
          translate_stores: 'Sprachen verwalten',
        },
        filters: {
          status: 'Status',
          type: 'Typ',
          active: 'Aktiv',
          inactive: 'Inaktiv',
          both: 'Beide',
          all_types: 'Alle',
          status_placeholder: 'Store-Status',
          type_placeholder: 'Store-Typ',
          filter_button: 'Filtern',
        },
        status_options: {
          active: 'Aktiv',
          inactive: 'Inaktiv',
          both: 'Beide',
          all_types: 'Alle',
        },
        languages: {
          portuguese: 'Portugiesisch',
          spanish: 'Spanisch',
          english: 'Englisch',
          french: 'Französisch',
          german: 'Deutsch',
          italian: 'Italienisch',
          japanese: 'Japanisch',
          korean: 'Koreanisch',
          chinese: 'Mandarin',
        },
        table: {
          headers: {
            type: 'Typ',
            id: 'ID',
            name: 'Name',
            subdomain: 'Subdomain',
            status: 'Status',
            created: 'Erstellt am',
            cnpj: 'CNPJ',
            actions: 'Aktionen',
          },
          type: 'Typ',
          id: 'ID',
          name: 'Name',
          subdomain: 'Subdomain',
          status: {
            active: 'Aktiv',
            inactive: 'Inaktiv',
          },
          created: 'Erstellt am',
          cnpj: 'CNPJ',
          actions: 'Aktionen',
        },
        statusLabels: {
          true: 'Aktiv',
          false: 'Inaktiv',
        },
        actions: {
          manage_languages: 'Sprachen verwalten',
          edit: 'Bearbeiten',
        },
        messages: {
          success: {
            title: 'Erfolg',
            save: 'Sprachen erfolgreich gespeichert!',
          },
          error: {
            title: 'Fehler',
            load_data: 'Fehler beim Laden der Store-Daten!',
            save_languages: 'Fehler beim Speichern der Sprachen!',
          },
        },
        modal: {
          title: 'Sprachen verwalten',
          description:
            'Wählen Sie die Sprachen, die für die Übersetzung in diesem Store verfügbar sein sollen:',
          alert: {
            title: 'Achtung',
            message:
              'Aktivieren oder deaktivieren Sie die Sprachen, die für die Übersetzung in diesem Store verwendet werden sollen.',
          },
          buttons: {
            cancel: 'Abbrechen',
            save: 'Speichern',
          },
        },
        relations: {
          no_relations: 'Keine Beziehung gefunden',
          create_title: 'Beziehung erstellen',
          edit_title: 'Beziehung bearbeiten',
          parent_label: 'Übergeordneter Store',
          child_label: 'Untergeordneter Store',
          parent_missing: 'Übergeordneten Store auswählen',
          child_missing: 'Untergeordneten Store auswählen',
          same_store_error:
            'Der übergeordnete Store darf nicht mit dem untergeordneten Store identisch sein',
          created_success: 'Beziehung erfolgreich erstellt',
          updated_success: 'Beziehung erfolgreich aktualisiert',
          deleted_success: 'Beziehung erfolgreich gelöscht',
          error_create: 'Fehler beim Erstellen der Beziehung',
          error_update: 'Fehler beim Aktualisieren der Beziehung',
          error_delete: 'Fehler beim Löschen der Beziehung',
          store_not_found: 'Store nicht gefunden',
          all_option: 'Alle',
          cancel: 'Abbrechen',
          save: 'Speichern',
          delete_confirm: 'Ja, löschen',
          create_button: 'Beziehung erstellen',
          save_changes: 'Änderungen speichern',
          create_description:
            'Definieren Sie, welcher Store der übergeordnete Store und welcher der untergeordnete Store sein soll. Ein übergeordneter Store kann mehrere untergeordnete Stores haben und deren Konfigurationen verwalten.',
          edit_description:
            'Bearbeiten Sie die Beziehung zwischen den ausgewählten Stores. Die Änderungen werden sofort angewendet.',
          summary_title: 'Zusammenfassung der Beziehung:',
          tips_title: 'Wichtige Hinweise:',
          tip_parent_multiple: 'Ein übergeordneter Store kann mehrere untergeordnete Stores haben',
          tip_child_single: 'Ein untergeordneter Store kann mehrere übergeordnete Stores haben',
          tip_all_available: 'Alle Stores (aktiv und inaktiv) stehen zur Auswahl',
          click_new: 'Klicken Sie auf "Neue Beziehung", um zu beginnen',
          message_delete:
            'Sind Sie sicher, dass Sie diese Beziehung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        },
      },
      hospitality_review: {
        page_title: 'Hotelbewertungen',
        page_subtitle:
          'Verwalten und überwachen Sie die Bewertungen und Einstufungen der Hotelgäste.',
        breadcrumb: {
          dashboard: 'Dashboard',
          hospitality: 'Hospitalität',
          reviews: 'Bewertungen',
        },
        statistics: {
          total_reviews: 'Gesamtanzahl Bewertungen',
          average_rating: 'Gesamtdurchschnitt',
        },
        filters: {
          filter_by_type: 'Nach Typ filtern',
          filter_by_rating: 'Nach Bewertung filtern',
        },
        type_options: {
          all_types: 'Alle',
          general: 'Allgemein',
          room: 'Zimmer',
          food: 'Essen',
          service: 'Service',
          cleanliness: 'Sauberkeit',
          activities: 'Aktivitäten',
        },
        rating_options: {
          all_ratings: 'Alle Bewertungen',
          five_stars: '5 Sterne',
          four_stars: '4 Sterne',
          three_stars: '3 Sterne',
          two_stars: '2 Sterne',
          one_star: '1 Stern',
        },
        table: {
          headers: {
            rating: 'Bewertung',
            type: 'Typ',
            comment: 'Kommentar',
            date: 'Datum',
            actions: 'Aktionen',
          },
          actions: {
            view_full_review: 'Vollständige Bewertung anzeigen',
          },
          status: {
            approved: 'Genehmigt',
            pending: 'Ausstehend',
          },
        },
        modal: {
          review_title: 'Bewertung von',
          fields: {
            rating: 'Bewertung',
            type: 'Typ',
            status: 'Status',
            date: 'Datum',
            comment: 'Kommentar',
            email: 'E-Mail',
          },
          guest_anonymous: 'Anonym',
        },
        messages: {
          success: {
            review_deleted: 'Bewertung gelöscht',
            delete_success: 'Löschung erfolgreich durchgeführt!',
            status_updated: 'Status aktualisiert',
            approved_success: 'Bewertung erfolgreich genehmigt!',
            suspended_success: 'Bewertung erfolgreich ausgesetzt!',
          },
          error: {
            title: 'Fehler',
            load_reviews: 'Fehler beim Laden der Hotelbewertungen!',
            invalid_id: 'Ungültige ID zum Löschen!',
            delete_error: 'Fehler beim Löschen der Bewertung!',
            status_error: 'Fehler beim Ändern des Bewertungsstatus!',
          },
          confirm: {
            delete_title: 'Löschung bestätigen',
            delete_text: 'Sind Sie sicher, dass Sie diese Bewertung löschen möchten?',
            delete_confirm: 'Ja, löschen',
            delete_cancel: 'Abbrechen',
          },
        },
      },
      hospitality_info: {
        page_title: 'Hotelinformationen',
        page_subtitle: 'Verwalten Sie Kontakt, Öffnungszeiten und Services des Hotels.',
        tabs: {
          contact: 'Kontakt',
          hours: 'Öffnungszeiten & Informationen',
          services: 'Services',
          ramal: 'Durchwahl',
          about: 'Über uns',
        },
        contact: {
          phone_label: 'Telefon',
          phone_placeholder: '(11) 99999-9999',
          whatsapp_label: 'WhatsApp',
          whatsapp_placeholder: '(11) 99999-9999',
          email_label: 'E-Mail',
          email_placeholder: 'hotel@email.com',
        },
        hours: {
          title: 'Öffnungszeiten & Informationen des Hotels',
          add_button: 'Öffnungszeit/Information hinzufügen',
          remove_button: 'Entfernen',
          hour_number: 'Element',
          title_label: 'Titel',
          title_placeholder: 'Beispiel: Rezeption, Pool, Restaurant',
          description_label: 'Öffnungszeiten & Informationen',
          description_placeholder:
            'Beschreiben Sie die Öffnungszeiten und zusätzliche Informationen (z.B.: 08:00 - 22:00, am Wochenende geschlossen)',
        },
        services: {
          title: 'Hotel-Services',
          add_button: 'Service hinzufügen',
          remove_button: 'Entfernen',
          service_number: 'Service',
          service_title_label: 'Service-Titel',
          service_title_placeholder: 'Beispiel: Zimmerservice',
          service_description_label: 'Beschreibung',
          service_description_placeholder: 'Beschreiben Sie den Service',
        },
        ramal: {
          title: 'Hotel-Durchwahlnummern',
          add_button: 'Durchwahl hinzufügen',
          remove_button: 'Entfernen',
          ramal_number: 'Durchwahl',
          ramal_title_label: 'Durchwahl-Titel',
          ramal_title_placeholder: 'Beispiel: 504',
          ramal_description_label: 'Beschreibung',
          ramal_description_placeholder: 'Beschreiben Sie die Durchwahl',
        },
        about: {
          description_label: 'Über das Hotel',
          description_placeholder:
            'Beschreiben Sie allgemeine Informationen über das Hotel, Geschichte, einzigartige Merkmale und besondere Eigenschaften',
        },
        actions: {
          save_button: 'Speichern',
        },
        messages: {
          error_title: 'Fehler',
          error_text: 'Die Hotelinformationen konnten nicht gespeichert werden.',
          success_title: 'Gespeichert!',
          success_text: 'Hotelinformationen erfolgreich gespeichert.',
          required_phone: 'Telefon ist obligatorisch.',
          required_email: 'E-Mail ist obligatorisch.',
          required_hours: 'Alle Elemente müssen Titel und Beschreibung haben.',
          required_service: 'Alle Services müssen Titel und Beschreibung haben.',
          required_ramal: 'Alle Durchwahlnummern müssen Titel und Beschreibung haben.',
        },
      },
      hospitality_schedules: {
        page_title: 'Hotelprogramm',
        page_subtitle: 'Verwalten Sie Veranstaltungen und Programme des Hotels.',
        new_button: 'Neues Programm',
        edit_button: 'Programm bearbeiten',
        delete_button: 'Programm löschen',
        delete_confirm:
          'Sind Sie sicher, dass Sie dieses Programm löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        table: {
          title: 'Titel',
          type: 'Typ',
          location: 'Ort',
          time: 'Uhrzeit',
          recurrence: 'Wiederholung',
          period: 'Zeitraum',
          status: 'Status',
          actions: 'Aktionen',
          active: 'Aktiv',
          inactive: 'Inaktiv',
          single_event: 'Einmaliges Ereignis',
          all_types: 'Alle',
          all_status: 'Alle Status',
          age_group: 'Altersgruppe',
        },
        filters: {
          type: 'Typ',
          type_placeholder: 'Typ auswählen',
          status: 'Status',
          status_placeholder: 'Status auswählen',
          date_init: 'Startdatum',
          date_init_placeholder: 'Startdatum',
          date_end: 'Enddatum',
          date_end_placeholder: 'Enddatum',
          search: 'Suchen',
          clear: 'Filter löschen',
        },
        messages: {
          load_error: 'Fehler beim Laden der Programme!',
          delete_success: 'Programm erfolgreich gelöscht!',
          delete_error: 'Fehler beim Löschen des Programms!',
        },
        types: {
          activity: 'Unterhaltung',
          food: 'Gastronomie',
          event: 'Veranstaltung',
          tour: 'Ausflug',
        },
        singleEvent: 'Einmaliges Ereignis',
      },
      hospitality_schedule_edit: {
        page_title: 'Programm bearbeiten',
        page_subtitle: 'Bearbeiten: {{title}}',
        not_found: {
          title: 'Programm nicht gefunden',
          description: 'Das Programm, das Sie bearbeiten möchten, wurde nicht gefunden.',
          back_button: 'Zurück zur Liste',
        },
        form: {
          type_label: 'Typ',
          type_placeholder: 'Typ auswählen',
          type_sports: 'Sport',
          type_wellness: 'Wellness',
          type_other: 'Andere',
          title_label: 'Titel',
          title_placeholder: 'Titel des Programms eingeben',
          description_label: 'Beschreibung',
          description_placeholder: 'Programm beschreiben',
          location_label: 'Ort',
          location_placeholder: 'Ort des Programms',
          time_label: 'Uhrzeit',
          time_placeholder: 'Beispiel: 14:00 - 16:00 oder 14:00',
          time_smalltext: 'Format: "HH:MM - HH:MM" oder "HH:MM"',
          recurrence_config: 'Wiederholungskonfiguration',
          single_event_radio: 'Einmaliges Ereignis - Ereignis, das an bestimmten Daten stattfindet',
          recurring_event_radio:
            'Wiederkehrendes Ereignis - Ereignis, das sich an bestimmten Wochentagen wiederholt',
          day_within_date_range_radio:
            'Ereignis innerhalb eines Datumsbereichs - Ereignis, das innerhalb eines bestimmten Datumsbereichs stattfindet',
          days_of_week_label: 'Wochentage',
          selected_days: 'Ausgewählt: {{days}}',
          date_init_label: 'Startdatum',
          date_init_placeholder: 'Startdatum',
          date_end_label: 'Enddatum',
          date_end_placeholder: 'Enddatum (optional)',
          status_label: 'Status',
          back_button: 'Zurück',
          save_button: 'Änderungen speichern',
        },
      },
      hospitality_schedule_create: {
        page_title: 'Neues Programm',
        page_subtitle: 'Ein neues Programm für das Hotel erstellen',
        success: {
          title: 'Erfolg!',
          text: 'Programm erfolgreich erstellt!',
        },
        error: {
          title: 'Fehler',
          text: 'Fehler beim Erstellen des Programms!',
        },
        form: {
          title_label: 'Titel *',
          title_placeholder: 'Titel des Programms eingeben',
          title_required: 'Titel ist obligatorisch',
          type_label: 'Typ *',
          type_placeholder: 'Typ auswählen',
          type_sports: 'Sport',
          type_wellness: 'Wellness',
          type_other: 'Andere',
          description_label: 'Beschreibung *',
          description_placeholder: 'Programm beschreiben',
          description_required: 'Beschreibung ist obligatorisch',
          location_label: 'Ort *',
          location_placeholder: 'Ort des Programms',
          location_required: 'Ort ist obligatorisch',
          time_label: 'Uhrzeit *',
          time_placeholder: 'Beispiel: 14:00 - 16:00 oder 14:00',
          time_smalltext: 'Format: "HH:MM - HH:MM" oder "HH:MM"',
          time_required: 'Uhrzeit ist obligatorisch',
          recurrence_config: 'Wiederholungskonfiguration',
          single_event_radio: 'Einmaliges Ereignis - Ereignis, das an bestimmten Daten stattfindet',
          recurring_event_radio:
            'Wiederkehrendes Ereignis - Ereignis, das sich an bestimmten Wochentagen wiederholt',
          day_within_date_range_radio:
            'Ereignis innerhalb eines Datumsbereichs - Ereignis, das innerhalb eines bestimmten Datumsbereichs stattfindet',
          days_of_week_label: 'Wochentage',
          selected_days: 'Ausgewählt: {{days}}',
          date_init_label: 'Startdatum',
          date_init_placeholder: 'Startdatum',
          date_end_label: 'Enddatum',
          date_end_placeholder: 'Enddatum (optional)',
          status_label: 'Status',
          back_button: 'Zurück',
          save_button: 'Speichern',
        },
      },
      hospitality_banner: {
        page_title: 'Hotel-Banner',
        page_subtitle:
          'Verwalten Sie die Banner Ihres Hotels. Kontrollieren Sie den Anzeigezeitraum, die Reihenfolge und den Status.',
        breadcrumb: {
          hospitality: 'Hospitalität',
          publicity: 'Werbung',
        },
        new_button: 'Neue Werbung',
        table: {
          title: 'Titel',
          image: 'Bild',
          order: 'Reihenfolge',
          period: 'Zeitraum',
          created_date: 'Erstellungsdatum',
          status: 'Status',
          actions: 'Aktionen',
        },
        actions: {
          edit: 'Werbung bearbeiten',
          view: 'Details anzeigen',
          delete: 'Werbung löschen',
        },
        modal: {
          title: 'Werbung #{{id}}',
          order: 'Reihenfolge',
          status: 'Status',
          active: 'Aktiv',
          inactive: 'Inaktiv',
          period: 'Zeitraum',
          created: 'Erstellt am',
          updated: 'Letzte Aktualisierung',
          image: 'Bild',
          no_image: 'Kein Bild',
        },
        delete: {
          confirm_title: 'Löschung bestätigen',
          confirm_text: 'Sind Sie sicher, dass Sie diese Werbung löschen möchten?',
          confirm_button: 'Ja, löschen',
          cancel_button: 'Abbrechen',
          success_title: 'Werbung gelöscht',
          success_text: 'Löschung erfolgreich durchgeführt!',
        },
        status: {
          success_title: 'Status aktualisiert',
          success_text: 'Werbung erfolgreich {{action}}!',
          activated: 'aktiviert',
          deactivated: 'deaktiviert',
        },
        error: {
          title: 'Fehler',
          load_data: 'Fehler beim Laden der Werbedaten!',
          invalid_id: 'Ungültige ID zum Löschen!',
          delete: 'Fehler beim Löschen der Werbung!',
          status_change: 'Fehler beim Ändern des Werbestatus!',
        },
      },
      hospitality_banner_create: {
        page_title: 'Neues Hotel-Banner erstellen',
        page_subtitle:
          'Füllen Sie die folgenden Informationen aus, um ein neues Banner zu erstellen.',
        breadcrumb: {
          hospitality: 'Hospitalität',
          publicity: 'Werbung',
          create: 'Werbung erstellen',
        },
        form: {
          title_label: 'Banner-Titel *',
          title_placeholder: 'Beispiel: Wanderungen...',
          order_label: 'Anzeigereihenfolge *',
          order_placeholder: 'Beispiel: 1, 2, 3...',
          order_smalltext: 'Prioritätsreihenfolge der Werbung (kleinere Zahlen erscheinen zuerst)',
          status_label: 'Werbung aktiv',
          status_smalltext: 'Ankreuzen, um die Werbung zu aktivieren',
          start_date_label: 'Startdatum *',
          start_time_label: 'Startzeit *',
          end_date_label: 'Enddatum *',
          end_time_label: 'Endzeit *',
          image_label: 'Bild der Werbung',
          image_select: 'Ein Bild auswählen',
          image_formats: 'Akzeptierte Formate: JPG, PNG, GIF',
          image_optional:
            'Optional - Ein Standardbild wird verwendet, wenn keines bereitgestellt wird',
          image_preview: 'Bildvorschau',
          image_remove: 'Bild entfernen',
        },
        preview: {
          period_title: 'Zeitraum der Werbung:',
          start: 'Start',
          end: 'Ende',
        },
        validation: {
          title: 'Validierungsfehler',
          order_positive: 'Die Reihenfolge muss eine Zahl größer als Null sein!',
          start_date_required: 'Startdatum ist obligatorisch!',
          end_date_required: 'Enddatum ist obligatorisch!',
          dates_required: 'Datum und Uhrzeit sind obligatorisch!',
          start_before_end: 'Startdatum muss vor dem Enddatum liegen!',
        },
        success: {
          title: 'Werbung erstellt',
          text: 'Werbung erfolgreich erstellt!',
        },
        error: {
          title: 'Fehler',
          text: 'Fehler beim Erstellen der Werbung!',
        },
      },
      hospitality_banner_update: {
        page_title: 'Hotel-Werbung bearbeiten',
        page_subtitle: 'Werbung #{{id}} bearbeiten',
        breadcrumb: {
          edit: 'Werbung bearbeiten',
        },
        current_image: 'Aktuelles Bild',
        save_button: 'Änderungen speichern',
        not_found: {
          title: 'Werbung nicht gefunden',
          text: 'Die Werbung, die Sie bearbeiten möchten, wurde nicht gefunden.',
          back_button: 'Zurück zur Liste',
        },
        no_changes: {
          title: 'Keine Änderungen',
          text: 'Es wurden keine Felder geändert!',
        },
        success: {
          title: 'Werbung aktualisiert',
          text: 'Werbung erfolgreich aktualisiert!',
        },
        error: {
          title: 'Fehler',
          text: 'Fehler beim Aktualisieren der Werbung',
          load_data: 'Fehler beim Laden der Werbedaten!',
          update: 'Fehler beim Aktualisieren der Werbung!',
        },
      },
      hospitality_publicity: {
        page_title: 'Hotel-Highlight-Banner',
        page_subtitle:
          'Verwalten Sie die Highlight-Banner Ihres Hotels. Kontrollieren Sie den Anzeigezeitraum, die Reihenfolge und den Status.',
        breadcrumb: {
          hospitality: 'Hospitalität',
          publicity: 'Werbung',
        },
        new_button: 'Neues Banner',
        table: {
          image: 'Bild',
          order: 'Reihenfolge',
          period: 'Zeitraum',
          created_date: 'Erstellungsdatum',
          status: 'Status',
          actions: 'Aktionen',
        },
        actions: {
          edit: 'Werbung bearbeiten',
          view: 'Details anzeigen',
          delete: 'Werbung löschen',
        },
        modal: {
          title: 'Werbung #{{id}}',
          order: 'Reihenfolge',
          status: 'Status',
          active: 'Aktiv',
          inactive: 'Inaktiv',
          period: 'Zeitraum',
          created: 'Erstellt am',
          updated: 'Letzte Aktualisierung',
          image: 'Bild',
          no_image: 'Kein Bild',
        },
        delete: {
          confirm_title: 'Löschung bestätigen',
          confirm_text: 'Sind Sie sicher, dass Sie diese Werbung löschen möchten?',
          confirm_button: 'Ja, löschen',
          cancel_button: 'Abbrechen',
          success_title: 'Werbung gelöscht',
          success_text: 'Löschung erfolgreich durchgeführt!',
        },
        status: {
          success_title: 'Status aktualisiert',
          success_text: 'Werbung erfolgreich {{action}}!',
          activated: 'aktiviert',
          deactivated: 'deaktiviert',
        },
        error: {
          title: 'Fehler',
          load_data: 'Fehler beim Laden der Werbedaten!',
          invalid_id: 'Ungültige ID zum Löschen!',
          delete: 'Fehler beim Löschen der Werbung!',
          status_change: 'Fehler beim Ändern des Werbestatus!',
        },
      },
      hospitality_publicity_create: {
        page_title: 'Hotel-Werbung erstellen',
        page_title_edit: 'Hotel-Werbung bearbeiten',
        page_subtitle:
          'Füllen Sie die folgenden Informationen aus, um eine neue Werbung zu erstellen.',
        breadcrumb: {
          hospitality: 'Hospitalität',
          publicity: 'Werbung',
          create: 'Werbung erstellen',
        },
        form: {
          order_label: 'Anzeigereihenfolge *',
          order_placeholder: 'Beispiel: 1, 2, 3...',
          order_smalltext: 'Prioritätsreihenfolge der Werbung (kleinere Zahlen erscheinen zuerst)',
          status_label: 'Werbung aktiv',
          status_smalltext: 'Ankreuzen, um die Werbung zu aktivieren',
          start_date_label: 'Startdatum *',
          start_time_label: 'Startzeit *',
          end_date_label: 'Enddatum *',
          end_time_label: 'Endzeit *',
          image_label: 'Bild der Werbung',
          image_select: 'Ein Bild auswählen',
          image_formats:
            'Akzeptierte Formate: JPG, PNG, GIF | Abmessungen: ~200x112px | Max. Größe: 2MB',
          image_optional:
            'Optional - Ein Standardbild wird verwendet, wenn keines bereitgestellt wird',
          image_preview: 'Bildvorschau',
          image_remove: 'Bild entfernen',
          external_link_checkbox: 'Externen Link einfügen',
          external_link_label: 'Externer Link',
          external_link_placeholder: 'https://beispiel.com',
          description_label: 'Beschreibung des Banners',
          description_smalltext: '* Maximal {qtd} Zeichen',
          title_label: 'Banner-Titel',
          title_placeholder: 'Beispiel: Wanderungen...',
          title_smalltext: '* Maximal {qtd} Zeichen',
        },
        preview: {
          period_title: 'Zeitraum der Werbung:',
          start: 'Start',
          end: 'Ende',
        },
        validation: {
          title: 'Validierungsfehler',
          order_positive: 'Die Reihenfolge muss eine Zahl größer als Null sein!',
          start_date_required: 'Startdatum ist obligatorisch!',
          end_date_required: 'Enddatum ist obligatorisch!',
          dates_required: 'Datum und Uhrzeit sind obligatorisch!',
          start_before_end: 'Startdatum muss vor dem Enddatum liegen!',
          external_link_required:
            'Externer Link ist obligatorisch, wenn die Option ausgewählt ist!',
          image_size_error: 'Das Bild darf maximal 2MB groß sein!',
          image_dimensions_error:
            'Die Bildabmessungen sollten etwa 200x112 Pixel betragen! Aktuell: {{current}}',
          image_invalid: 'Ungültige Bilddatei! Bitte wählen Sie ein gültiges Bild aus.',
        },
        success: {
          title: 'Werbung erstellt',
          text: 'Werbung erfolgreich erstellt!',
        },
        error: {
          title: 'Fehler',
          text: 'Fehler beim Erstellen der Werbung!',
          update: 'Fehler beim Aktualisieren der Werbung!',
        },
        not_found: {
          title: 'Werbung nicht gefunden',
          text: 'Die Werbung, die Sie bearbeiten möchten, wurde nicht gefunden.',
          back_button: 'Zurück zur Liste',
        },
        no_changes: {
          title: 'Keine Änderungen',
          text: 'Es wurden keine Felder geändert!',
        },
        current_image: 'Aktuelles Bild',
      },
      // Zum File hinzufügen
      service_list: {
        filters: {
          categories: 'Kategorien',
          category_placeholder: 'Kategorie',
          filter_button: 'Filtern',
          all_categories: 'ALLE',
        },
        table: {
          schedule: 'Zeitplan',
          extension: 'Durchwahl',
        },
        actions: {
          delete_service: 'Service löschen',
        },
      },
      // Zum File hinzufügen
      service_create: {
        page_title: 'Service registrieren',
        breadcrumb: {
          services: 'Services',
          create: 'Erstellen',
        },
        form: {
          classification_placeholder: 'Eine Klassifizierung auswählen',
          name_label: 'Name',
          name_placeholder: 'Name des Services',
          description_label: 'Beschreibung',
          description_placeholder: 'Beschreibung des Services',
          schedule_label: 'Betriebszeit',
          schedule_placeholder: 'Beispiel: 24h, 08:00-18:00, Auf Anfrage',
          schedule_smalltext: 'Maximal 50 Zeichen',
          extension_label: 'Durchwahl',
          extension_placeholder: 'Beispiel: 1001, 2050',
          extension_smalltext: 'Maximal 10 Zeichen',
          code_label: 'Code',
          code_placeholder: 'Code des Services',
          order_label: 'Reihenfolge',
          order_placeholder: 'Anzeigereihenfolge',
          status_label: 'Status',
          status_active: 'Aktiv',
          status_inactive: 'Inaktiv',
          external_link_label: 'Externer Link',
          external_link_placeholder: 'https://beispiel.com',
          priority_label: 'Priorität',
          priority_low: 'Niedrig',
          priority_normal: 'Normal',
          priority_high: 'Hoch',
          priority_critical: 'Kritisch',
        },
        icons: {
          title: 'Symbole',
          category_label: 'Symbolkategorie',
          all_categories: 'Alle',
          selected_icon: 'Ausgewähltes Symbol',
        },
        validation: {
          missing_fields_title: 'Fehlende Felder',
          missing_fields_text:
            'Überprüfen Sie, ob Sie alle Pflichtfelder ausgefüllt haben: Name, Klassifizierung und Symbol!',
        },
        success: {
          title: 'Service registriert',
          text: 'Registrierung erfolgreich durchgeführt!',
        },
        error: {
          title: 'Fehler',
          text: 'Fehler beim Registrieren des Services!',
          icons_load: 'Fehler beim Finden der Typen',
        },
      }, // Zum File hinzufügen
      service_update: {
        page_title: 'Service bearbeiten',
        page_title_full: 'Service aktualisieren',
        breadcrumb: {
          edit: 'Bearbeiten',
        },
        error: {
          title: 'Fehler',
          load_data: 'Fehler beim Laden der Service-Daten!',
          text: 'Fehler beim Aktualisieren des Services!',
        },
        success: {
          title: 'Service aktualisiert',
          text: 'Bearbeitung erfolgreich durchgeführt!',
        },
      },
      // Zum File hinzufügen
      service_category_create: {
        validation: {
          missing_fields_title: 'Fehlende Felder',
          missing_fields_text: 'Überprüfen Sie, ob Sie alle Felder ausgefüllt haben!',
        },
        success: {
          title: 'Klassifizierung registriert',
          text: 'Registrierung erfolgreich durchgeführt!',
        },
        error: {
          title: 'Fehler',
          text: 'Fehler beim Registrieren der Klassifizierung!',
          create: 'Fehler beim Erstellen der Klassifizierung!',
        },
      },

      // Zum File hinzufügen
      service_category_list: {
        page_title: 'Inhaltskategorien',
        page_subtitle:
          'Hier sind die Inhaltskategorien zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        breadcrumb: {
          categories: 'Kategorien',
        },
        add_button: 'Hinzufügen',
        table: {
          name: 'Name',
          status: 'Status',
          actions: 'Aktionen',
        },
        actions: {
          edit_category: 'Kategorie bearbeiten',
          delete_category: 'Kategorie löschen',
        },
        delete: {
          error_title: 'Fehler',
          error_text: 'Fehler beim Löschen der Kategorie!',
          success_title: 'Kategorie gelöscht',
          success_text: 'Löschung erfolgreich durchgeführt!',
          confirm_title: 'Sind Sie sicher?',
          confirm_text: 'Die Kategorie wird gelöscht und kann nicht wiederhergestellt werden!',
          cancel_button: 'Schließen!',
          confirm_button: 'Löschen!',
        },
      },
      service_category_update: {
        error: {
          title: 'Fehler',
          load_data: 'Fehler beim Laden der Klassifizierungsdaten!',
          text: 'Fehler beim Aktualisieren der Klassifizierung!',
          update: 'Fehler beim Aktualisieren der Klassifizierung!',
        },
        success: {
          title: 'Klassifizierung aktualisiert',
          text: 'Bearbeitung erfolgreich durchgeführt!',
        },
      },
      hotelRoom: {
        status: {
          available: 'Verfügbar',
          reserved: 'Reserviert',
          maintenance: 'In Wartung',
          occupied: 'Belegt',
          being_cleaning: 'Wird gereinigt',
        },
        type: {
          single: 'Einzelzimmer',
          double: 'Doppelzimmer',
          twin: 'Zweibettzimmer',
          queen: 'Queen-Bett',
          king: 'King-Bett',
          suite: 'Suite',
          junior_suite: 'Junior Suite',
          master_suite: 'Master Suite',
          presidential: 'Präsidenten-Suite',
          family: 'Familienzimmer',
          accessible: 'Barrierefreies Zimmer',
        },
      },
      hospitality_room_reservation: {
        create: {
          wizard_step_customer: 'Kunde',
          wizard_step_reservation: 'Buchung',
          wizard_step_confirmation: 'Bestätigung',
          wizard_step1: 'Schritt 1',
          wizard_step2: 'Schritt 2',
          wizard_step3: 'Schritt 3',
          wizard_customer_title: 'Kunden auswählen oder registrieren',
          wizard_customer_search_placeholder: 'Nach Name, E-Mail oder Telefon suchen...',
          wizard_customer_search_button: 'Bestehenden Kunden suchen',
          wizard_customer_new_button: 'Neuen Kunden registrieren',
          wizard_customer_none_found: 'Kein Kunde gefunden',
          wizard_customer_showing_first:
            'Anzeige der ersten 20 Ergebnisse. Verfeinern Sie Ihre Suche, um andere Kunden zu finden.',
          wizard_reservation_title: 'Buchungsdaten',
          wizard_reservation_room_label: 'Zimmer *',
          wizard_reservation_room_subtitle:
            'Klicken Sie auf die Zimmer, um sie auszuwählen. Sie können mehrere Zimmer auswählen.',
          wizard_reservation_room_placeholder: 'Ein Zimmer auswählen',
          wizard_reservation_status_label: 'Buchungsstatus',
          wizard_reservation_status_placeholder: 'Status auswählen',
          wizard_reservation_checkin_label: 'Datum und Uhrzeit des Check-in *',
          wizard_reservation_checkout_label: 'Datum und Uhrzeit des Check-out *',
          wizard_reservation_password_label: 'Kundenpasswort',
          wizard_reservation_password_placeholder: 'Kundenpasswort eingeben',
          wizard_reservation_generate_password: 'Passwort generieren',
          wizard_confirmation_title: 'Buchung bestätigen',
          wizard_confirmation_customer_data: 'Kundendaten',
          wizard_confirmation_reservation_data: 'Buchungsdaten',
          wizard_confirmation_room: 'Zimmer',
          wizard_confirmation_capacity: 'Kapazität',
          wizard_confirmation_price: 'Preis',
          wizard_confirmation_checkin: 'Check-in',
          wizard_confirmation_checkout: 'Check-out',
          wizard_confirmation_status: 'Status',
          wizard_confirmation_password: 'Passwort',
          wizard_confirmation_address: 'Adresse',
          wizard_confirmation_zipcode: 'Postleitzahl',
          wizard_confirmation_gender_male: 'Männlich',
          wizard_confirmation_gender_female: 'Weiblich',
          wizard_confirmation_gender_other: 'Andere',
          wizard_confirmation_gender_not_informed: 'Möchte nicht informieren',
          wizard_buttons_back: 'Zurück',
          wizard_buttons_cancel: 'Abbrechen',
          wizard_buttons_next: 'Weiter',
          wizard_buttons_create: 'Erstellen',
          wizard_page_title: 'Neue Zimmerbuchung',
          wizard_page_subtitle: 'Neue Buchung für das Hotel erstellen',
          legend: {
            title: 'Zimmer-Statuslegende',
            available: 'Verfügbar',
            selected: 'Ausgewählt',
            unavailable: 'Nicht verfügbar',
            occupied: 'Belegt',
            reserved: 'Reserviert',
            being_cleaning: 'In Reinigung',
            maintenance: 'In Wartung',
            no_info: 'Ohne Information',
          },
        },
        customer_form: {
          title: 'Kundendaten',
          personal_info_title: 'Persönliche Informationen',
          cpf_label: 'CPF *',
          cpf_placeholder: '000.000.000-00',
          name_label: 'Vollständiger Name *',
          name_placeholder: 'Vollständigen Namen eingeben',
          email_label: 'E-Mail *',
          email_placeholder: 'E-Mail eingeben',
          birthdate_label: 'Geburtsdatum *',
          gender_label: 'Geschlecht',
          gender_placeholder: 'Geschlecht auswählen',
          gender_male: 'Männlich',
          gender_female: 'Weiblich',
          gender_other: 'Andere',
          contact_info_title: 'Kontaktinformationen',
          phone_label: 'Telefon *',
          phone_placeholder: '(11) 99999-9999',
          phone_type_label: 'Telefon-Typ',
          phone_type_cell: 'Mobil',
          phone_type_landline: 'Festnetz',
          whatsapp_optin: 'Akzeptiert, Nachrichten auf WhatsApp zu erhalten',
          address_title: 'Wohnadresse',
          cep_label: 'Postleitzahl *',
          cep_placeholder: '00000-000',
          street_label: 'Straße *',
          street_placeholder: 'Straße, Allee, etc.',
          number_label: 'Nummer *',
          number_placeholder: '123',
          extra_label: 'Ergänzung',
          extra_placeholder: 'Wohnung, Block, etc.',
          district_label: 'Bezirk *',
          district_placeholder: 'Name des Bezirks',
          city_label: 'Stadt *',
          city_placeholder: 'Name der Stadt',
          state_label: 'Bundesland *',
          state_placeholder: 'SP',
          reference_label: 'Referenzpunkt',
          reference_placeholder: 'In der Nähe des Einkaufszentrums, gegenüber dem Platz, etc.',
          terms_title: 'Geschäftsbedingungen',
          accept_terms: 'Ich akzeptiere die Nutzungsbedingungen *',
          lgpd_consent: 'Ich stimme der Verarbeitung meiner personenbezogenen Daten zu (LGPD) *',
        },
        title: 'Zimmerbuchungen',
        subtitle: 'Hotelbuchungsverwaltung',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_reservation: 'Buchungen',
        btn_new_reservation: 'Neue Buchung',
        btn_confirm: 'Buchung bestätigen',
        btn_checkin: 'Check-in durchführen',
        btn_checkout: 'Check-out durchführen',
        btn_cancel: 'Buchung stornieren',
        btn_no_show: 'Als Nichterscheinen markieren',
        btn_delete: 'Buchung löschen',
        btn_details: 'Buchungsdetails',
        filter_status_label: 'Buchungsstatus',
        filter_status_placeholder: 'Einen Status auswählen',
        filter_status_all: 'Alle Status',
        table_reservation: 'Buchung',
        table_room: 'Zimmer',
        table_customer: 'Kunde',
        table_checkin: 'Check-in',
        table_checkout: 'Check-out',
        table_status: 'Status',
        table_price: 'Wert',
        table_actions: 'Aktionen',
        status_confirmed: 'Bestätigt',
        status_in_progress: 'Im Gange',
        status_completed: 'Abgeschlossen',
        status_cancelled: 'Storniert',
        status_no_show: 'Nicht erschienen',
        status_pending: 'Ausstehend',
        msg_success_delete: 'Löschung erfolgreich durchgeführt!',
        msg_success_update: 'Buchungsstatus erfolgreich aktualisiert!',
        msg_error_delete: 'Fehler beim Löschen der Buchung!',
        msg_error_update: 'Fehler beim Aktualisieren des Buchungsstatus!',
        msg_confirm_status_change: 'Möchten Sie den Buchungsstatus auf "{status}" ändern?',
        msg_confirm_checkin: 'Möchten Sie den Check-in für diese Buchung durchführen?',
        msg_confirm_checkout:
          'Möchten Sie den Check-out abschließen? Diese Aktion kann nicht rückgängig gemacht werden.',
        msg_checkout_attention: '⚠️ ACHTUNG - SORGFÄLTIG LESEN:',
        msg_checkout_list: [
          'Der Kunde hat die Zahlung bereits getätigt',
          'Es gibt keine finanziellen Rückstände',
          'Alle Services wurden ordnungsgemäß bezahlt',
        ],
        msg_checkout_confirm_read:
          'Ich habe gelesen und bestätige, dass alle Validierungen überprüft wurden',
        msg_checkout_validation:
          'Sie müssen bestätigen, dass Sie alle Validierungen gelesen und überprüft haben, bevor Sie fortfahren.',
        msg_confirm_delete: 'Buchung löschen',
        tab_basic: 'Basisinformationen',
        tab_summary: 'Zusammenfassung',
        tab_activities: 'Aktivitäten',
        tab_tours: 'Ausflüge',
        tab_experiences: 'Erlebnisse',
        tab_services: 'Service-Reservierungen',
        tab_services_list: 'Service-Liste',
        tab_orders: 'Hotelbestellungen',
        label_loading: 'Wird geladen...',
        label_loading_orders: 'Bestellungen werden geladen...',
        label_order_details: 'Bestelldetails',
        label_no_data: 'Keine Bestellung gefunden',
        label_pending: 'Derzeit ist keine Bestellung reserviert.',
        tab_title: 'Hotelbestellungen',
        label_order: 'Bestellung',
        label_orders: 'Bestellungen',
        label_total_spent: 'Gesamtausgaben: {value}',
        label_total_orders: 'Gesamtanzahl Bestellungen',
        label_total_spent_label: 'Gesamtausgaben',
        label_total_paid_label: 'Gesamtzahlung',
        label_products: 'Produkte',
        label_quantity: 'Menge',
        label_sku: 'SKU',
        label_delivery: 'Lieferung',
        label_delivery_address: 'Lieferadresse',
        label_withdraw_address: 'Abholadresse',
        label_financial_summary: 'Finanzielle Zusammenfassung',
        label_products_label: 'Produkte',
        label_delivery_fee: 'Liefergebühr',
        label_discount: 'Rabatt',
        label_total: 'Gesamt',
        label_payment_na: 'Zahlung N/A',
        label_payment_offline: 'Offline-Zahlung',
        label_payment_card: 'Kartenzahlung',
        label_payment_credit: 'Kredit',
      },
      hospitality_room_reservation_tabs: {
        basic_info: {
          tab_title: 'Basisinformationen',
          label_customer: 'Kunde',
          label_room: 'Zimmer',
          label_checkin: 'Check-in',
          label_checkout: 'Check-out',
          label_status: 'Status',
          label_price: 'Wert',
          label_notes: 'Anmerkungen',
          placeholder_notes: 'Anmerkungen zur Buchung hinzufügen',
          status_edit_warning:
            'Der Buchungsstatus kann nach Bestätigung oder Stornierung nicht mehr bearbeitet werden.',
          selected_room_details:
            'Zimmer {roomNumber} - {type} (Kapazität: {capacity}) - R$ {price}',
          selected_customer_details: 'Kunde: {name} | E-Mail: {email} | Telefon: {phone}',
          optional_checkout: 'Der Check-out ist optional und kann später ausgefüllt werden.',
          status_pending: 'Ausstehend',
          status_confirmed: 'Bestätigt',
          status_in_progress: 'Im Gange',
          status_completed: 'Abgeschlossen',
          status_cancelled: 'Storniert',
          summary_capacity: 'Kapazität',
          summary_people: 'Personen',
          btn_change_password: 'Passwort ändern',
        },
        summary: {
          tab_title: 'Zusammenfassung',
          room_details: 'Zimmerdetails',
          label_total: 'Gesamt',
          label_paid: 'Bezahlt',
          label_pending: 'Ausstehend',
          label_services: 'Services',
          label_products: 'Produkte',
          label_activities: 'Aktivitäten',
          label_experiences: 'Erlebnisse',
          label_tours: 'Ausflüge',
          label_room: 'Zimmer',
          label_customer: 'Kunde',
          label_checkin: 'Check-in',
          label_checkout: 'Check-out',
          label_status: 'Status',
          label_price: 'Wert',
          label_notes: 'Anmerkungen',
          label_capacity: 'Kapazität',
          label_people: 'Personen',
          label_orders: 'Hotelbestellungen',
          label_payment_method: 'Zahlungsmethode',
          label_discount: 'Rabatt',
          label_tax: 'Steuer',
          label_total_with_tax: 'Gesamt inkl. Steuer',
          label_total_with_discount: 'Gesamt inkl. Rabatt',
          label_total_paid: 'Gesamtzahlung',
          label_total_pending: 'Gesamt ausstehend',
          label_summary: 'Buchungszusammenfassung',
          label_details: 'Details',
          label_edit: 'Bearbeiten',
          label_delete: 'Löschen',
          label_confirm: 'Bestätigen',
          label_cancel: 'Stornieren',
          label_no_data: 'Keine Daten verfügbar',
          label_success: 'Operation erfolgreich durchgeführt!',
          label_error: 'Fehler bei der Operation!',
          label_warning: 'Achtung',
          label_info: 'Information',
          label_actions: 'Aktionen',
          label_service: 'Service',
          label_product: 'Produkt',
          label_activity: 'Aktivität',
          label_experience: 'Erlebnis',
          label_tour: 'Ausflug',
          label_order: 'Bestellung',
          label_date: 'Datum',
          label_time: 'Uhrzeit',
          label_type: 'Typ',
          label_edit_reservation: 'Buchung bearbeiten',
          label_delete_reservation: 'Buchung löschen',
          label_confirm_reservation: 'Buchung bestätigen',
          label_cancel_reservation: 'Buchung stornieren',
          label_status_confirmed: 'Bestätigt',
          label_status_in_progress: 'Im Gange',
          label_status_completed: 'Abgeschlossen',
          label_status_cancelled: 'Storniert',
          label_status_no_show: 'Nicht erschienen',
          label_status_pending: 'Ausstehend',
        },
        activities: {
          tab_title: 'Aktivitäten',
          label_activity: 'Aktivität',
          label_activities: 'Aktivitäten',
          label_no_data: 'Keine Aktivität gefunden',
          label_pending: 'Derzeit ist keine Aktivität reserviert.',
          label_people: 'Teilnehmer',
          label_category: 'Kategorie',
          label_location: 'Standort',
          label_session_time: 'Sitzungszeit',
          label_skill_level: 'Schwierigkeitsgrad',
          label_special_requests: 'Sonderwünsche',
          label_price: 'Wert',
          label_date: 'Datum',
          label_time: 'Uhrzeit',
          label_status: 'Status',
          label_actions: 'Aktionen',
          label_description: 'Beschreibung',
          status_confirmed: 'Bestätigt',
          status_pending: 'Ausstehend',
          status_cancelled: 'Storniert',
          status_completed: 'Abgeschlossen',
          btn_add_activity: 'Aktivität hinzufügen',
        },
        experiences: {
          tab_title: 'Erlebnisse',
          label_experience: 'Erlebnis',
          label_experiences: 'Erlebnisse',
          label_no_data: 'Kein Erlebnis gefunden',
          label_pending: 'Derzeit ist kein Erlebnis reserviert.',
          label_people: 'Teilnehmer',
          label_category: 'Kategorie',
          label_location: 'Standort',
          label_session_time: 'Sitzungszeit',
          label_skill_level: 'Schwierigkeitsgrad',
          label_special_requests: 'Sonderwünsche',
          label_price: 'Wert',
          label_date: 'Datum',
          label_time: 'Uhrzeit',
          label_status: 'Status',
          label_actions: 'Aktionen',
          label_description: 'Beschreibung',
          status_confirmed: 'Bestätigt',
          status_pending: 'Ausstehend',
          status_cancelled: 'Storniert',
          status_completed: 'Abgeschlossen',
          btn_add_experience: 'Erlebnis hinzufügen',
          label_duration: 'Dauer',
          label_rating: 'Bewertung',
          label_special_occasion: 'Besonderer Anlass',
          label_includes: 'Beinhaltet',
        },
        hotel_orders: {
          tab_title: 'Hotelbestellungen',
          label_order: 'Bestellung',
          label_orders: 'Bestellungen',
          label_no_data: 'Keine Bestellung gefunden',
          label_pending: 'Derzeit ist keine Bestellung reserviert.',
          label_delivery: 'Lieferung',
          label_quantity: 'Menge',
          label_sku: 'SKU',
          label_delivery_address: 'Lieferadresse',
          label_withdraw_address: 'Abholadresse',
          label_financial_summary: 'Finanzielle Zusammenfassung',
          label_products: 'Produkte',
          label_products_label: 'Produkte',
          label_total_spent: 'Gesamtausgaben: {value}',
          label_total_orders: 'Gesamtanzahl Bestellungen',
          label_total_spent_label: 'Gesamtausgaben',
          label_total_paid_label: 'Gesamtzahlung',
          label_discount: 'Rabatt',
          label_total: 'Gesamt',
          label_payment_na: 'Zahlung N/A',
          label_payment_offline: 'Offline-Zahlung',
          label_payment_card: 'Kartenzahlung',
          label_payment_credit: 'Kredit',
          label_delivery_fee: 'Liefergebühr',
          no_order_title: 'Keine Bestellung gefunden',
        },
        tours: {
          tab_title: 'Ausflüge',
          label_tour: 'Ausflug',
          label_tours: 'Ausflüge',
          label_no_data: 'Kein Ausflug gefunden',
          label_pending: 'Derzeit ist kein Ausflug reserviert.',
          label_people: 'Teilnehmer',
          label_duration: 'Dauer',
          label_difficulty: 'Schwierigkeit',
          label_rating: 'Bewertung',
          label_transfer_included: 'Transfer inbegriffen',
          label_transfer_yes: 'Transfer Inbegriffen',
          label_transfer_no: 'Kein Transfer',
          label_schedule: 'Zeitplan',
          label_weather_concerns: 'Wetterbedenken',
          label_physical_requirements: 'Physische Anforderungen',
          label_special_requests: 'Sonderwünsche',
          label_price: 'Wert',
          label_date: 'Datum',
          label_time: 'Uhrzeit',
          label_status: 'Status',
          label_actions: 'Aktionen',
          label_description: 'Beschreibung',
          status_confirmed: 'Bestätigt',
          status_pending: 'Ausstehend',
          status_cancelled: 'Storniert',
          status_completed: 'Abgeschlossen',
          btn_add_tour: 'Ausflug hinzufügen',
        },
        services: {
          title: 'Service-Reservierungen',
          subtitle: 'Details der reservierten Services',
          no_services: 'Keine Services reserviert',
          service_info: 'Service-Informationen',
          service_name: 'Service-Name',
          service_type: 'Service-Typ',
          description: 'Beschreibung',
          room_info: 'Zimmerinformationen',
          room_number: 'Zimmer',
          booking_details: 'Buchungsdetails',
          status: 'Status',
          check_in: 'Check-in',
          check_out: 'Check-out',
          guest_name: 'Gastname',
          reservation_name: 'Reservierungsname',
          number_of_rooms: 'Anzahl Zimmer',
          number_of_guests: 'Anzahl Gäste',
          adults: 'Erwachsene',
          children: 'Kinder',
          total_price: 'Gesamtpreis',
          price_per_night: 'Preis pro Nacht',
          nights: 'Nächte',
          additional_info: 'Zusätzliche Informationen',
          booking_date: 'Buchungsdatum',
          reservation_code: 'Reservierungscode',
          payment_status: 'Zahlungsstatus',
          special_requests: 'Besondere Wünsche',
          service_details: 'Service-Details',
          view_details: 'Details anzeigen',
          total_services: 'Gesamt Services',
          active_services: 'Aktive Services',
          pending_services: 'Ausstehende Services',
          completed_services: 'Abgeschlossene Services',
          service_image: 'Service-Bild',
          no_image: 'Kein Bild verfügbar',
        },
        services_list: {
          title: 'Service-Liste',
          subtitle: 'Alle reservierten Services',
          search_placeholder: 'Suche nach Name, Zimmer oder Gast...',
          filter_all: 'Alle',
          filter_active: 'Aktiv',
          filter_pending: 'Ausstehend',
          filter_completed: 'Abgeschlossen',
          table_service_name: 'Service',
          table_service_type: 'Typ',
          table_room: 'Zimmer',
          table_guest: 'Gast',
          table_checkin: 'Check-in',
          table_checkout: 'Check-out',
          table_status: 'Status',
          table_price: 'Preis',
          table_actions: 'Aktionen',
          status_active: 'Aktiv',
          status_pending: 'Ausstehend',
          status_completed: 'Abgeschlossen',
          status_cancelled: 'Storniert',
          no_services: 'Keine Services gefunden',
          no_services_desc: 'Keine Services entsprechen Ihren Kriterien',
          showing: 'Anzeige',
          of: 'von',
          services: 'Services',
          items_per_page: 'Elemente pro Seite',
          page: 'Seite',
          previous: 'Zurück',
          next: 'Weiter',
          view_details: 'Details anzeigen',
          total_found: 'Gesamt gefunden',
          active_filters: 'Aktive Filter',
          clear_filters: 'Filter löschen',
          filter_by_status: 'Nach Status filtern',
          search_active: 'Suche aktiv',
          rooms: 'Zimmer',
          guests: 'Gäste',
          nights: 'Nächte',
          loading: 'Services werden geladen...',
          error: 'Fehler beim Laden der Services',
          retry: 'Wiederholen',
          export: 'Exportieren',
          refresh: 'Aktualisieren',
        },
      },
      hospitality_hotel_room: {
        label_room_number: 'Zimmernummer *',
        image: 'Bild des Zimmers',
        placeholder_room_number: 'Beispiel: 101, A201, Präsidentensuite',
        max_20_chars: 'Maximal 20 Zeichen',
        label_status: 'Status',
        label_capacity: 'Kapazität (Personen)',
        placeholder_capacity: 'Beispiel: 2',
        label_price: 'Preis (R$)',
        placeholder_price: 'Beispiel: 150.00',
        label_type: 'Zimmertyp',
        title: 'Hotelzimmer',
        subtitle: 'Hotelzimmerverwaltung',
        create_multiples: 'Mehrere Zimmer erstellen',
        add_room: 'Zimmer hinzufügen',
        header_number: 'Nummer',
        header_status: 'Status',
        header_type: 'Typ',
        header_capacity: 'Kapazität',
        header_price: 'Preis',
        header_actions: 'Aktionen',
        action_edit: 'Zimmer bearbeiten',
        action_delete: 'Zimmer löschen',
        modal_bulk_title: 'Mehrere Zimmer erstellen',
        modal_bulk_prefix: 'Präfix (optional)',
        modal_bulk_prefix_placeholder: 'Beispiel: A, B, 1.',
        modal_bulk_start: 'Anfangsnummer *',
        modal_bulk_start_placeholder: '101',
        modal_bulk_end: 'Endnummer *',
        modal_bulk_end_placeholder: '110',
        modal_bulk_capacity: 'Kapazität',
        modal_bulk_capacity_placeholder: '2',
        modal_bulk_price: 'Preis',
        modal_bulk_price_placeholder: '150.00',
        modal_bulk_type: 'Typ',
        type_single: 'Einzelzimmer',
        type_double: 'Doppelzimmer',
        type_twin: 'Zweibettzimmer',
        type_queen: 'Queen-Size-Zimmer',
        type_king: 'King-Size-Zimmer',
        type_suite: 'Suite',
        type_junior_suite: 'Junior Suite',
        type_master_suite: 'Master Suite',
        type_presidential: 'Präsidentensuite',
        type_family: 'Familienzimmer',
        type_accessible: 'Barrierefrei',
        modal_bulk_cancel: 'Abbrechen',
        modal_bulk_create: 'Zimmer erstellen',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_hotel_room: 'Hotelzimmer',
        create_title: 'Hotelzimmer erstellen',
        create_subtitle: 'Neues Zimmer zum Hotel hinzufügen',
        edit_title: 'Hotelzimmer bearbeiten',
        edit_subtitle: 'Informationen zu Zimmer #{room} bearbeiten',
        breadcrumb_create: 'Zimmer erstellen',
        breadcrumb_edit: 'Zimmer bearbeiten',
      },
      hospitality_experiences: {
        tab_basic: 'Basisinformationen',
        edit: 'Erlebnis bearbeiten',
        edit_subtitle: 'Erlebnisinformationen aktualisieren',
        create: 'Erlebnis erstellen',
        create_subtitle: 'Details ausfüllen, um ein neues Erlebnis zu erstellen',
        tab_details: 'Detaillierte Elemente',
        tab_image: 'Bild',
        tab_schedules: 'Zeitpläne',
        list_title: 'Hotel-Erlebnisse',
        list_subtitle: 'Alle Hotel-Erlebnisse verwalten',
        field_title: 'Titel',
        field_title_placeholder: 'Beispiel: Exklusives romantisches Abendessen',
        field_description: 'Beschreibung',
        field_description_placeholder: 'Beschreiben Sie das angebotene Erlebnis im Detail...',
        field_image: 'Neues Bild',
        field_price: 'Preis (R$)',
        field_price_placeholder: '0.00',
        field_duration: 'Dauer',
        field_duration_placeholder: 'Beispiel: 2 Stunden',
        field_type: 'Erlebnis-Typ',
        field_rating: 'Bewertung (0-5)',
        field_rating_placeholder: '0',
        field_status: 'Aktiver Status',
        field_includes: 'Inbegriffene Elemente',
        field_includes_placeholder: 'Beispiel: Champagner, besondere Dekoration...',
        field_show_additional_services: 'Vordefinierte Serviceoptionen anzeigen',
        field_actions: 'Aktionen',
        status_active: 'Aktiv',
        status_inactive: 'Inaktiv',
        no_rating: 'Keine Bewertung',
        no_includes: 'Keine Elemente inbegriffen',
        currency: 'R$',
        btn_add: 'Erlebnis hinzufügen',
        btn_edit: 'Bearbeiten',
        btn_delete: 'Entfernen',
        btn_update: 'Erlebnis aktualisieren',
        btn_create: 'Erlebnis erstellen',
        btn_remove: 'Entfernen',
        btn_add_item: 'Element hinzufügen',
        edit_title: 'Erlebnis bearbeiten',
        create_title: 'Erlebnis erstellen',
        msg_success_create: 'Erlebnis erfolgreich erstellt!',
        msg_success_update: 'Erlebnis erfolgreich aktualisiert!',
        msg_success_delete: 'Erlebnis entfernt',
        msg_success_delete_text: 'Erlebnis erfolgreich entfernt!',
        msg_error_create: 'Fehler beim Erstellen des Erlebnisses',
        msg_error_update: 'Fehler beim Aktualisieren des Erlebnisses',
        msg_error_delete: 'Fehler beim Entfernen des Erlebnisses',
        msg_error_delete_text: 'Das Erlebnis konnte nicht entfernt werden!',
        msg_error_load: 'Fehler beim Laden des Erlebnisses',
        msg_error_load_text: 'Die Erlebnisdaten konnten nicht geladen werden!',
        msg_error_required_title: 'Titel ist obligatorisch!',
        msg_error_title_length: 'Titel darf maximal 255 Zeichen lang sein!',
        msg_error_required_description: 'Beschreibung ist obligatorisch!',
        msg_error_required_price: 'Preis ist obligatorisch!',
        msg_error_price_negative: 'Preis muss größer oder gleich Null sein!',
        msg_error_required_duration: 'Dauer ist obligatorisch!',
        msg_error_duration_length: 'Dauer darf maximal 100 Zeichen lang sein!',
        msg_error_required_includes: 'Mindestens ein Element muss enthalten sein!',
        msg_error_rating_range: 'Bewertung muss zwischen 0 und 5 liegen!',
        field_order: 'Reihenfolge',
        field_order_placeholder: 'Z.B.: 1, 2, 3...',
        header_order: 'Reihenfolge',
        msg_error_order_negative: 'Die Reihenfolge muss größer oder gleich Null sein!',
      },
      entertainment_services: {
        list_title: 'Unterhaltungsdienste',
        list_subtitle: 'Verfügbare Unterhaltungsdienste verwalten',
        create: 'Unterhaltungsdienst Erstellen',
        create_subtitle: 'Füllen Sie die Details aus, um einen neuen Service zu erstellen',
        create_title: 'Unterhaltungsdienst Erstellen',
        edit: 'Unterhaltungsdienst Bearbeiten',
        edit_subtitle: 'Service-Informationen aktualisieren',
        edit_title: 'Unterhaltungsdienst Bearbeiten',
        field_title: 'Titel',
        field_title_placeholder: 'Z.B: Spa und Massage',
        field_type: 'Service-Typ',
        field_status: 'Aktiver Status',
        field_actions: 'Aktionen',
        type_experience: 'Unterhaltungserlebnis',
        type_activity: 'Unterhaltungsaktivität',
        type_tour: 'Unterhaltungstour',
        status_active: 'Aktiv',
        status_inactive: 'Inaktiv',
        btn_add: 'Service Hinzufügen',
        btn_edit: 'Bearbeiten',
        btn_delete: 'Entfernen',
        btn_update: 'Service Aktualisieren',
        btn_create: 'Service Erstellen',
        btn_search: 'Suchen',
        btn_clear: 'Löschen',
        search_placeholder: 'Nach Titel suchen...',
        msg_success_create: 'Service erfolgreich erstellt!',
        msg_success_update: 'Service erfolgreich aktualisiert!',
        msg_success_delete: 'Service entfernt',
        msg_success_delete_text: 'Service erfolgreich entfernt!',
        msg_error_create: 'Fehler beim Erstellen des Service',
        msg_error_update: 'Fehler beim Aktualisieren des Service',
        msg_error_delete: 'Fehler beim Entfernen des Service',
        msg_error_delete_text: 'Service konnte nicht entfernt werden!',
        msg_error_load: 'Fehler beim Laden des Service',
        msg_error_load_text: 'Service-Daten konnten nicht geladen werden!',
        msg_error_required_title: 'Titel ist erforderlich!',
        msg_error_title_length: 'Titel darf maximal 255 Zeichen lang sein!',
      },
      hospitality_activities: {
        hotel_reservation: {
          page_title: 'Service-Buchungen',
          details_title: 'Buchungsdetails',
          cancel_title: 'Buchung stornieren',
          cancel_reason_label: 'Stornierungsgrund *',
          cancel_reason_placeholder: 'Stornierungsgrund auswählen',
          cancel_reason_select: 'Einen Grund auswählen',
          type_tour: 'Ausflug',
          type_experience: 'Erlebnis',
          type_activity: 'Aktivität',
          type_room_service: 'Zimmerservice',
          status_pending: 'Ausstehend',
          status_confirmed: 'Bestätigt',
          status_cancelled: 'Storniert',
          status_completed: 'Abgeschlossen',
          error_title: 'Fehler',
          error_load: 'Fehler beim Laden der Buchungen!',
          error_details: 'Fehler beim Laden der Buchungsdetails!',
          error_cancel: 'Fehler beim Stornieren der Buchung!',
          success_title: 'Erfolg',
          success_cancel: 'Buchung erfolgreich storniert!',
          warning_title: 'Achtung',
          warning_cancel_reason: 'Bitte wählen Sie einen Stornierungsgrund aus.',
          no_details: 'Spezifische Details für diesen Buchungstyp nicht verfügbar.',
          reasons_tour: [
            'Planänderung',
            'Wetterprobleme',
            'Terminkonflikt',
            'Gesundheitliche Gründe',
            'Hotelstornierung',
          ],
          reasons_experience: [
            'Änderung des Aufenthaltsdatums',
            'Besonderer Anlass storniert',
            'Terminkonflikt',
            'Persönliche Gründe',
            'Präferenz für einen anderen Service',
          ],
          reasons_activity: [
            'Fühle mich nicht bereit',
            'Terminkonflikt',
            'Gesundheitliche Probleme',
            'Planänderung',
            'Aktivität entspricht nicht der Erwartung',
          ],
          reasons_room_service: [
            'Planänderung',
            'Service nicht benötigt',
            'Terminkonflikt',
            'Persönliche Gründe',
            'Präferenz für einen anderen Service',
          ],
        },
        create_title: 'Hotel-Aktivität erstellen',
        create_subtitle: 'Neue Aktivität zum Hotel hinzufügen',
        edit_title: 'Hotel-Aktivität bearbeiten',
        edit_subtitle: 'Aktivitätsinformationen aktualisieren',
        list_title: 'Hotel-Aktivitäten',
        list_subtitle: 'Verwaltung von Aktivitäten und Unterhaltung',
        field_title: 'Titel der Aktivität *',
        field_title_placeholder: 'Beispiel: Yoga-Kurs, Musik-Show, Kinderbetreuung',
        field_title_hint: 'Maximal 255 Zeichen',
        field_time: 'Uhrzeit *',
        field_time_placeholder: 'Beispiel: 08:00 - 09:00, Täglich um 15 Uhr',
        field_time_hint: 'Maximal 100 Zeichen',
        field_description: 'Beschreibung *',
        field_description_placeholder:
          'Beschreiben Sie die Aktivität im Detail, ihre Vorteile und was die Gäste erwarten können...',
        field_image: 'Bild der Aktivität',
        field_location: 'Standort *',
        field_location_placeholder: 'Beispiel: Hauptpool, Veranstaltungsraum, Strand',
        field_location_hint: 'Maximal 255 Zeichen',
        field_capacity: 'Kapazität *',
        field_capacity_placeholder: 'Z.B.: 20, falls 0 ist unbegrenzt',
        field_capacity_hint: 'Maximal 50 Zeichen',
        field_period: 'Zeitraum*',
        field_period_placeholder: 'z. B.: 00:15 oder 01:00 oder 00:30',
        field_category: 'Kategorie *',
        field_age_group: 'Altersgruppe',
        field_price: 'Preis (R$)',
        field_price_placeholder: '0.00 (leer lassen, wenn kostenlos)',
        field_price_hint: 'Leer lassen für kostenlose Aktivität',
        field_requires_reservation: 'Reservierung erforderlich',
        field_requires_reservation_hint:
          'Ankreuzen, wenn die Aktivität eine vorherige Reservierung erfordert',
        field_is_active: 'Aktivität aktiv',
        field_is_active_hint: 'Deaktivieren, um die Aktivität vorübergehend auszuschalten',
        btn_edit: 'Aktivität bearbeiten',
        btn_delete: 'Aktivität löschen',
        btn_create: 'Aktivität erstellen',
        btn_cancel: 'Abbrechen',
        msg_success_create: 'Aktivität erfolgreich erstellt!',
        msg_success_update: 'Aktivität erfolgreich aktualisiert!',
        msg_success_delete: 'Aktivität erfolgreich gelöscht!',
        msg_error_create: 'Fehler beim Erstellen der Aktivität!',
        msg_error_update: 'Fehler beim Aktualisieren der Aktivität!',
        msg_error_delete: 'Fehler beim Löschen der Aktivität!',
        msg_error_load: 'Fehler beim Laden der Aktivität!',
        msg_error_required_title: 'Titel ist obligatorisch!',
        msg_error_title_length: 'Titel darf maximal 255 Zeichen lang sein!',
        msg_error_required_description: 'Beschreibung ist obligatorisch!',
        msg_error_required_time: 'Uhrzeit ist obligatorisch!',
        msg_error_time_length: 'Uhrzeit darf maximal 100 Zeichen lang sein!',
        msg_error_required_location: 'Standort ist obligatorisch!',
        msg_error_location_length: 'Standort darf maximal 255 Zeichen lang sein!',
        msg_error_required_capacity: 'Kapazität ist obligatorisch!',
        msg_error_capacity_length: 'Kapazität darf maximal 50 Zeichen lang sein!',
        msg_error_price_negative: 'Preis muss größer oder gleich Null sein!',
        remove_schedule: 'Zeitplan entfernen',
        confirm_remove_schedule: 'Sind Sie sicher, dass Sie diesen Zeitplan entfernen möchten?',
        schedule_seasonal_start: 'Saisonstart',
        schedule_seasonal_end: 'Saisonende',
        schedule_start_time: 'Startzeit',
        schedule_end_time: 'Endzeit',
        add_schedule: 'Zeitplan hinzufügen',
        schedule_time: 'Uhrzeit *',
        schedule_time_placeholder: 'Beispiel: 08:00 - 09:00, Täglich um 15 Uhr',
        schedule_description: 'Beschreibung *',
        schedule_days_of_week: 'Wochentage',
        schedule_status: 'Zeitplan aktiv',
        schedule_seasonal_hint: 'Definieren Sie einen saisonalen Zeitraum, falls zutreffend',
        field_duration_hint: 'Dauer in Stunden und Minuten (z.B. 2h30min)',
        field_duration_placeholder: 'Dauer in Stunden und Minuten (z.B. 2h30min)',
        field_order: 'Reihenfolge',
        field_order_placeholder: 'Z.B.: 1, 2, 3...',
        msg_error_order_negative: 'Die Reihenfolge muss größer oder gleich Null sein!',
      },
      hotel_tour: {
        create_title: 'Hotel-Ausflug erstellen',
        create_subtitle: 'Neuen Ausflug zum Hotel hinzufügen',
        edit_title: 'Hotel-Ausflug bearbeiten',
        edit_subtitle: 'Ausflugsinformationen aktualisieren',
        list_title: 'Hotel-Ausflüge',
        list_subtitle: 'Ausflüge und Exkursionen verwalten',
        field_title: 'Titel des Ausflugs *',
        field_difficulty: 'Schwierigkeit',
        field_duration: 'Dauer',
        field_rating: 'Bewertung',
        field_participants: 'Teilnehmer',
        field_schedules: 'Zeitpläne',
        field_includes: 'Inklusive',
        field_transfer: 'Transfer',
        field_currency: 'Währung',
        field_currency_hint: 'Währungscode (z.B. BRL, USD)',
        currency_brl: 'Real (BRL)',
        currency_usd: 'Dollar (USD)',
        currency_eur: 'Euro (EUR)',
        field_rating_placeholder: '0.0',
        field_rating_hint: 'Bewertung von 0 bis 5 Sternen',
        field_participants_min: 'Mindestteilnehmer *',
        field_participants_min_hint: 'Minimale Teilnehmerzahl',
        field_participants_max: 'Maximale Teilnehmer',
        field_participants_max_placeholder: 'Leer lassen, wenn unbegrenzt',
        field_participants_max_hint: 'Maximale Teilnehmerzahl (optional)',
        field_age_restriction: 'Altersbeschränkung',
        field_age_restriction_placeholder:
          'Beispiel: Über 12 Jahre, Nicht empfohlen für unter 18-Jährige',
        field_age_restriction_hint: 'Altersbeschränkungen (optional)',
        field_physical_requirements: 'Physische Anforderungen',
        field_physical_requirements_placeholder:
          'Beispiel: Gute körperliche Verfassung, Fähigkeit, lange Strecken zu gehen',
        field_physical_requirements_hint: 'Erforderliche physische Anforderungen (optional)',
        field_cancellation_hours: 'Stornierung (Stunden) *',
        field_cancellation_hours_hint: 'Stunden vorher für Stornierung',
        field_discount_children: 'Kinder-Rabatt (%)',
        field_discount_children_hint: 'Rabatt in Prozent',
        field_weather_dependent: 'Wetterabhängig',
        field_weather_dependent_hint: 'Ankreuzen, wenn es von den Wetterbedingungen abhängt',
        field_is_active: 'Ausflug aktiv',
        field_is_active_hint: 'Deaktivieren, um den Ausflug vorübergehend auszuschalten',
        tab_basic: 'Basisinformationen',
        tab_details: 'Details und Konfigurationen',
        tab_schedules: 'Zeitpläne',
        tab_includes: 'Inbegriffene Elemente',
        tab_image: 'Bild',
        no_schedule_added: 'Kein Zeitplan hinzugefügt',
        click_add_schedule: 'Klicken Sie auf "Zeitplan hinzufügen", um zu beginnen.',
        includes_title: 'Inbegriffene Elemente im Ausflug',
        selected: 'Ausgewählt',
        field_image_hint: 'Wählen Sie ein repräsentatives Bild für den Ausflug aus',
        update_info: 'Ausflugsinformationen aktualisieren',
        field_title_placeholder: 'Beispiel: Stadtrundfahrt, Strandausflug, Historische Wanderung',
        field_title_hint: 'Maximal 255 Zeichen',
        field_time: 'Uhrzeit *',
        field_time_placeholder: 'Beispiel: 08:00 - 09:00, Täglich um 15 Uhr',
        field_time_hint: 'Maximal 100 Zeichen',
        field_description: 'Beschreibung *',
        field_description_placeholder:
          'Beschreiben Sie den Ausflug, Highlights und was die Gäste erwarten können...',
        field_image: 'Bild des Ausflugs',
        field_location: 'Standort *',
        field_location_placeholder: 'Beispiel: Zentrum, Strand, Museum',
        field_location_hint: 'Maximal 255 Zeichen',
        field_capacity: 'Kapazität *',
        field_capacity_placeholder: 'Beispiel: 20 Personen, Unbegrenzt, 10-15 Teilnehmer',
        field_capacity_hint: 'Maximal 50 Zeichen',
        field_category: 'Kategorie *',
        field_price: 'Preis (R$)',
        field_price_placeholder: '0.00 (leer lassen, wenn kostenlos)',
        field_price_hint: 'Leer lassen für kostenlosen Ausflug',
        field_requires_reservation: 'Reservierung erforderlich',
        field_requires_reservation_hint:
          'Ankreuzen, wenn der Ausflug eine vorherige Reservierung erfordert',
        btn_edit: 'Ausflug bearbeiten',
        btn_delete: 'Ausflug löschen',
        btn_create: 'Ausflug erstellen',
        btn_cancel: 'Abbrechen',
        table_title: 'Titel',
        table_time: 'Uhrzeit',
        table_location: 'Standort',
        table_category: 'Kategorie',
        table_price: 'Preis',
        table_capacity: 'Kapazität',
        table_actions: 'Aktionen',
        msg_success_create: 'Ausflug erfolgreich erstellt!',
        msg_success_update: 'Ausflug erfolgreich aktualisiert!',
        msg_success_delete: 'Ausflug erfolgreich gelöscht!',
        msg_error_create: 'Fehler beim Erstellen des Ausflugs!',
        msg_error_update: 'Fehler beim Aktualisieren des Ausflugs!',
        msg_error_delete: 'Fehler beim Löschen des Ausflugs!',
        msg_error_load: 'Fehler beim Laden des Ausflugs!',
        msg_error_required_title: 'Titel ist obligatorisch!',
        msg_error_title_length: 'Titel darf maximal 255 Zeichen lang sein!',
        msg_error_required_description: 'Beschreibung ist obligatorisch!',
        msg_error_required_time: 'Uhrzeit ist obligatorisch!',
        msg_error_time_length: 'Uhrzeit darf maximal 100 Zeichen lang sein!',
        msg_error_required_location: 'Standort ist obligatorisch!',
        msg_error_location_length: 'Standort darf maximal 255 Zeichen lang sein!',
        msg_error_required_capacity: 'Kapazität ist obligatorisch!',
        msg_error_capacity_length: 'Kapazität darf maximal 50 Zeichen lang sein!',
        msg_error_price_negative: 'Preis muss größer oder gleich Null sein!',
        schedule_start_time: 'Startzeit',
        schedule_end_time: 'Endzeit',
        add_schedule: 'Zeitplan hinzufügen',
        schedule_time: 'Uhrzeit *',
        schedule_time_placeholder: 'Beispiel: 08:00 - 09:00, Täglich um 15 Uhr',
        schedule_description: 'Beschreibung *',
        schedule_days_of_week: 'Wochentage',
        schedule_status: 'Zeitplan aktiv',
        schedule_seasonal_hint: 'Definieren Sie einen saisonalen Zeitraum, falls zutreffend',
        field_duration_hint: 'Dauer in Stunden und Minuten (z.B. 2h30min)',
        field_duration_placeholder: 'Dauer in Stunden und Minuten (z.B. 2h30min)',
        schedule_seasonal_start: 'Saisonstart',
        schedule_seasonal_end: 'Saisonende',
        difficult: {
          easy: 'Einfach',
          medium: 'Mäßig',
          hard: 'Schwierig',
          extreme: 'Extrem',
        },
        field_order: 'Reihenfolge',
        field_order_placeholder: 'Z.B.: 1, 2, 3...',
        header_order: 'Reihenfolge',
        msg_error_order_negative: 'Die Reihenfolge muss größer oder gleich Null sein!',
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mär',
        apr: 'Apr',
        may: 'Mai',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Okt',
        nov: 'Nov',
        dec: 'Dez',
      },
      permissions: {
        color_variations: 'Farbvariationen',
        food: 'Smart Order',
        content: 'Webapp-Oberfl\u00e4che',
        buttons: 'Tasten',
        sessions: 'Sitzungen',
        smartorder: 'Produktmanagement',
        category: 'Kategorien',
        subcategory: 'Unterkategorien',
        product: 'Produkte',
        mark: 'Marken',
        grid: 'Grids',
        variation: 'Variationen',
        catalog: 'Kataloge',
        integration: 'Integrationen',
        int_pos: 'POS',
        int_gateway: 'Zahlungsmethode',
        messaging: 'Messaging',
        sms: 'Status und SMS',
        multichannel: 'Multichannel',
        report: 'Berichte',
        saleorder: 'Bestellungen',
        indicators: 'Indikatoren',
        orderReport: 'Bestellungen',
        imports: 'Bildimport',
        importProductImage: 'Produkte',
        importProductImageSKU: 'Variationen',
        importCategoryImage: 'Kategorien',
        customers: 'Kunden',
        customer_report: 'Kundenliste',
        measurement_unit: 'Maßeinheiten',
        logs: 'Logs',
        settings: 'Einstellungen',
        charge_integration: 'Cargas',
        summaryAccess: 'Zugriffe',
        sellerAccess: 'Verkäufer-Dashboard',
        managerAccess: 'Manager-Dashboard',
        managerGroupAccess: 'Gruppenmanager-Dashboard',
        orders: 'Bestellungen',
        support: 'Support',
        translate: 'Sprachen und Beziehungen',
        application: 'Webapp',
        messenger: 'Messaging',
        others: 'Andere',
        settings_store: 'Store-Einstellungen',
        settings_hotel: 'Einstellungen',
        modalities: 'Modalitäten',
        delivery_tax: 'Liefergebühr',
        shifts: 'Schichten',
        whatsappweb: 'WhatsApp Web',
        filemanager: 'Dateimanager',
        payment_plans: 'Zahlungspläne',
        settings_account: 'Kontoeinstellungen',
        account: 'Konto',
        groups: 'Gruppen',
        users: 'Benutzer',
        terms: 'Bedingungen',
        highlights: 'Highlights',
        menu: 'Menü',
        productReport: 'Produkte',
        optional: 'Liste der Zusätze',
        locations: 'Sektoren',
        stores_location: 'Einrichtungen',
        message_hotel: 'Status und Benachrichtigung',
        service: 'Services',
        service_items: 'Services',
        service_category: 'Kategorien',
        feed: 'Feed',
        structured_content: 'Essentielle Services',
        orders_room_service: 'Zimmerbestellungen',
        orders_activities: 'Aktivitätsbestellungen',
        queue: 'Warteschlange',
        queue_config: 'Einstellungen',
        queue_manager: 'Verwaltung',
        checkout: 'Kundendaten',
        booking: 'Buchung',
        booking_management: 'Verwaltung',
        booking_config: 'Einstellungen',
        booking_environment: 'Umgebungen',
        booking_day: 'Tagesbuchungen',
        booking_report: 'Berichte',
        booking_managerday: 'Tagesverwaltung',
        booking_management_dashboard: 'Dashboard der Buchungsverwaltung',
        table_management: 'Tischverwaltung',
        table_allocation_report: 'Bericht zur Tischzuweisung',
        table_management_dashboard: 'Dashboard der Tischverwaltung',
        liveShop: 'Live Commerce',
        icon_library: 'Symbolbibliothek',
        stores: 'Stores/Kunden',
        segments: 'Segmente',
        payment: 'Zahlungen',
        serviceCategory: 'Service-Kategorie',
        SDS: 'KDS',
        sds_manage: 'Meine KDS',
        sds_layout: 'Personalisierung',
        sds_link: 'Einstellungen',
        sds_display: 'Displays',
        /* Aggregator */
        config: 'Einstellungen',
        config_account: 'Kontodaten',
        config_sector: 'Betätigungsfeld',
        config_user: 'Benutzer',
        config_term: 'Bedingungen',
        subCategory: 'Unterkategorie',
        footer: 'Fußzeilen-Ressourcen',
        footerFeature: 'Ressourcen aktivieren',
        footerContent: 'Ressourcen-Feed',
        footerContentAddEdit: 'Ressourcen',
        webapp: 'Personalisieren',
        webapp_qrcode: 'QR-Code generieren',
        ia_menu: 'Künstliche Intelligenz',
        ia_config: 'Einstellungen',
        ia_fit: 'Training',
        ia_file_manager: 'Dateimanager',
        ia_folders: 'Ordner',
        ia_files: 'Dateien',
        ia_settings: 'Einstellungen',
        ia_folders_blank: 'Kein Ordner gefunden',
        ia_filter: 'Filtern',
        ia_recharge: 'Aufladen',
        ia_final_date: 'Enddatum',
        ia_initial_date: 'Startdatum',
        summarize: 'Dashboard',
        consumption: 'KI-Verbrauch',
        ct_account: 'Verbrauch und Wert',
        ct_s3_account: 'S3-Konto',
        ct_data_cost_account: 'Daten und Kosten',
        publication_highlight_banner: 'Highlight-Banner',
        publication: 'Werbung',
        cost: 'Kosten',
        security_settings: 'Sicherheitseinstellungen',
        coupon: 'Gutschein',
        clean_safe: 'Clean & Safe',
        service_requests: 'Service-Formulare',
        grid_hotel: 'Service-Grid',
        /* Hospitalität */
        hotel_maintenance: 'Wartung',
        hotel_room: 'Zimmer',
        hotel_reservation: 'Zimmerbuchungen',
        hotel_activities_experiences: 'Aktivitäten und Erlebnisse',
        hotel_activities: 'Aktivitäten',
        hotel_tour: 'Hotel-Ausflug',
        hotel_tour_schedules: 'Hotel-Ausflug Zeitpläne',
        hotel_tour_reservation: 'Allgemeine Buchungen',
        hotel_experiences: 'Erlebnisse',
        hotel_info: 'Informationen',
        hotel_reservations: 'Buchungen',
        hotel_schedules: 'Hotelprogramm',
        publication_banner: 'Banner',
        feed_back: 'Feedback',
        feedback_satisfaction: 'Umfrage und Zufriedenheit',
        grid_hotel_feedback: 'Noten',
        feedback_list: 'Formular',
        feedback: 'Rückmeldungen',
        post: 'Beitrag',
        post_category: 'Beitragskategorie',
        post_content: 'Beitragsinhalt',
        booking_hotel: 'Reservierungsverwaltung',
        grid_hotel_booking: 'Service-Grids',
        booking_config_hotel: 'Service-Reservierungen',
        page_publications: 'Seite der Veröffentlichungen',
        communication: 'Kommunikation',
        communicationCenter: 'Kommunikationszentrale',
        hotel_management: 'Hotelverwaltung',
        hotel_management_entertainment: 'Unterhaltung',
        product_color_variations: 'Farbvariationen',
        feedback_analytics: 'Feedback-Analyse',
      },
      // Translations for Color Variations Workbench
      workbench: {
        page_title: 'Farbvariationen',
        page_subtitle: 'Verwalten Sie Produktfarbvariationen',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_workbench: 'Farbwerkstatt',

        // Mode Selection
        selectMode: 'Modus auswählen',
        chooseProdutOrVariation: 'Wählen Sie, mit einem Produkt oder einer Variante zu arbeiten',
        product: 'Produkt',
        productDescription: 'Wählen Sie aus registrierten Produkten in Ihrem Geschäft',
        variation: 'Variante',
        variationDescription: 'Wählen Sie aus registrierten Varianten',

        // Product/Variation Selection
        selectProduct: 'Wählen Sie ein Produkt',
        selectVariation: 'Wählen Sie eine Variante',
        searchProduct: 'Produkt nach Name oder Code suchen...',
        searchVariation: 'Variation nach SKU oder Produktname suchen...',
        noProductsFound: 'Keine Produkte gefunden',
        noProductsMatchSearch: 'Keine Produkte gefunden, die den Suchkriterien entsprechen',
        noVariationsFound: 'Keine Varianten gefunden',
        noVariationsMatchSearch: 'Keine Varianten gefunden, die den Suchkriterien entsprechen',
        noImagesFound: 'Keine Bilder für dieses Produkt/diese Variante gefunden',
        description:
          'Wählen Sie ein Produkt oder eine Variante aus, um mit der Erstellung benutzerdefinierter Farbvariationen zu beginnen.',
        showingResults: 'Zeige',
        of: 'von',
        backButton: 'Zurück',

        // Image and Color Selection
        selectImage: 'Bild auswählen',
        selectColor: 'Farbe wählen',
        colorDescription: 'Beschreibung (Optional)',
        descriptionPlaceholder: 'Beschreiben Sie die Änderung, die Sie vornehmen möchten...',
        selectImageFirst: 'Bitte wählen Sie zunächst ein Bild',
        processingError: 'Fehler beim Verarbeiten der Variante',

        // Buttons
        generateVariation: 'Variante generieren',
        processing: 'Verarbeitung läuft...',
        processingTimeSeconds: '{time}s',

        // Preview
        selectedImagePreview: 'Vorschau des ausgewählten Bildes',
        resultPreview: 'Vorschau des Ergebnisses',
        originalImage: 'Originalbild',
        processedImage: 'Bearbeitetes Bild',
        targetColor: 'Zielfarbe',
        processingTime: 'Verarbeitungszeit',

        // Actions
        approveAndApply: 'Genehmigen und anwenden',
        reject: 'Ablehnen',
        applyVariation: 'Variante anwenden',
        applyTarget: 'Wo möchten Sie diese Variante anwenden?',

        // Apply Dialog
        createNewVariation: 'Neue Variante erstellen',
        newVariationInfo: 'Mit diesem Bild wird eine neue Variante erstellt',
        replaceExistingVariation: 'Vorhandene Variante ersetzen',
        selectVariationToReplace: 'Wählen Sie die Variante aus, die Sie ersetzen möchten',
        replaceProductImage: 'Produktbild ersetzen',
        selectProductToReplaceImage: 'Wählen Sie, welches Produktbild ersetzt wird',

        // Messages
        variationSavedSuccess: 'Variante erfolgreich gespeichert!',
        errorSavingVariation: 'Fehler beim Speichern der Variante',
        successTitle: 'Erfolg',
        errorTitle: 'Fehler',
        warningTitle: 'Warnung',

        // Dialog Buttons
        cancel: 'Abbrechen',
        save: 'Speichern',
        confirm: 'Bestätigen',
        close: 'Schließen',
      },
      customer: {
        select_group: 'Eine Gruppe auswählen',
        select: 'Auswählen',
        create: 'Kunden erstellen',
        create_group: 'Gruppe erstellen',
        edit: 'Kunden anzeigen',
        search_custom: 'Suchen...',
        customer: 'Kunden',
      },

      buttons: {
        create: 'Erstellen',
        back: 'Zurück',
        previous: 'Vorherige',
        register_pluginspace: 'Pluginspace registrieren',
        access: 'Zugriff',
        add_modality: 'Modalität hinzufügen',
        add_km: 'Km hinzufügen',
        zip_code_list: 'Postleitzahlenliste',
        add_zip_code: 'Postleitzahl hinzufügen',
        area: 'Lieferbereiche',
        list_of_negative_renge_zip_code: 'Liste negativer Postleitzahlen',
        add_negative_zip_code: 'Negative Postleitzahl hinzufügen',
        add_user: 'Benutzer hinzufügen',
        generate_password: 'Passwort generieren',
        generate_sku: 'SKU generieren',
        add_group: 'Gruppe hinzufügen',
        save: 'Speichern',
        add_term: 'Bedingung hinzufügen',
        add_integration: 'Integration hinzufügen',
        filter: 'Filtern',
        search: 'Suchen',
        register_product: 'Produkt registrieren',
        choose_files: 'Dateien auswählen',
        add_categories: 'Kategorien hinzufügen',
        add_subcategories: 'Unterkategorien hinzufügen',
        add_brand: 'Marke hinzufügen',
        close: 'Schließen',
        add_grade: 'Grid hinzufügen',
        add: 'Hinzufügen',
        add_variation: 'Variation hinzufügen',
        confirm_grades: 'Grids bestätigen',
        add_catalog: 'Katalog hinzufügen',
        generete_qr_code: 'QR-Code generieren',
        personalize: 'Personalisieren',
        settings: 'Einstellungen',
        add_interval: 'Intervall hinzufügen',
        add_gateway: 'Gateway hinzufügen',
        overview: 'Übersicht',
        view: 'Anzeigen',
        load_csv: 'Datei laden',
        download_csv: 'Standard XLSX herunterladen',
        att_page: 'Seite aktualisieren',
        export: 'Exportieren',
        add_service: 'Service registrieren',
        add_environment: 'Umgebung hinzufügen',
        generate_ia: 'Vorschlagen',
        clear_table_card: 'Tisch oder Bestellung löschen',
        propose_image: 'Bild vorschlagen',
        cancel: 'Abbrechen',
        next: 'Weiter',
      },

      global: {
        success: 'Erfolg',
        error: 'Fehler',
        warning: 'Achtung',
        active: 'Aktiv',
        inactive: 'Inaktiv',
      },

      modals: {
        warning_confirm: 'Sind Sie sicher?',
        warning_save: 'Speichern',
        warning_close: 'Schließen',
        text_close: 'Schließen',
      },

      general: {
        delete_item: 'Möchten Sie dieses Element löschen?',
        delete_product_observation:
          'Die Variationen dieses Produkts werden ebenfalls gelöscht. Möchten Sie trotzdem fortfahren?',
        delete_classification_observation:
          'Wenn Sie diese Kategorie löschen, werden alle damit verbundenen Produkte in die Kategorie "Allgemein" verschoben. Möchten Sie fortfahren?',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        duplicate: 'Duplizieren',
        attention: 'Achtung',
        actions: 'Aktionen',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Hier sind die Elemente zusammen mit ihren jeweiligen Aktionen aufgeführt',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Füllen Sie die folgenden Informationen aus und klicken Sie auf die Schaltfläche "Erstellen", um die Änderungen zu speichern',
        save_changes_edit:
          'Füllen Sie die folgenden Informationen aus und klicken Sie auf die Schaltfläche "Speichern", um die Änderungen zu bestätigen',
        save_changes_duplicate:
          'Validieren oder ändern Sie die folgenden Informationen und klicken Sie auf die Schaltfläche "Speichern", um die Änderungen zu bestätigen',
        active: 'Aktiv',
        select: 'Auswählen',
        inactive: 'Inaktiv',
        showing: 'Anzeige',
        of: 'von',
        to: 'bis',
        records: 'Einträge',
        type: 'Typ',
        today: 'Heute',
        copy: 'Kopieren',
        linkS3: 'Link',
        linkedS3: 'Verknüpft',
        downloadS3: 'Download',
        downloadedS3: 'Download gestartet',
        copied: 'Kopiert',
        copy_link: 'Verkäufer-Link kopieren',
        test: 'Testen',
        success: 'Erfolg',
        error: 'Fehler',
        email: 'E-Mail',
        paymentFree: 'Kostenlos',
      },

      pluginspaces: {
        hospitality: 'Hotels',
        food: 'Food',
        healthcare: 'Gesundheitswesen',
        varejo: 'Einzelhandel',
        fashion: 'Mode',
      },

      dashboard: {
        totals_by_products: 'Gesamt nach Produkten',
        totals_by_category: 'Gesamt nach Kategorie',
        last_orders: 'Letzte Bestellungen',
        products: 'Produkte',
        quantity: 'Menge',
        total: 'Gesamt',
        category: 'Kategorie',
        welcome: 'Willkommen bei Ninegrid',
        describe_dashboard:
          'Hier haben Sie alle Tools, um Ihren Store einfach und effizient zu verwalten. Erkunden Sie die Seitenmenüs, um unsere Funktionen zu navigieren. Viel Erfolg!',
      },

      modalities: {
        modalities: 'Modalitäten',
        modalitie: 'Modalität',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Hier sind die Modalitäten zusammen mit ihren jeweiligen Aktionen aufgeführt',
        delivery: 'Lieferung',
        withdraw: 'Abholung',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        name: 'Name',
        code: 'Code',
        actions: 'Aktionen',
        search: 'Suchen',
        type: 'Typ',
        sector_name: 'Name des Sektors',
        table: 'Tisch',
        room: 'Zimmer',
        counter: 'Theke',
        internal: 'Interne Lieferung',
        synkar: 'Synkar',
      },

      delivery_fee: {
        delivery_fee: 'Liefergebühr',
        create_delivery_fee: 'Liefergebühr erstellen',
        edit_delivery_fee: 'Liefergebühr bearbeiten',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Füllen Sie die folgenden Informationen aus und klicken Sie auf die Schaltfläche "Erstellen", um die Änderungen zu speichern',
        save_changes_edit:
          'Füllen Sie die folgenden Informationen aus und klicken Sie auf die Schaltfläche "Speichern", um die Änderungen zu bestätigen',
        km_min: 'Mindest-Km',
        km_max: 'Maximal-Km',
        value: 'Wert',
        actions: 'Aktionen',
        patterns: 'Importmuster',
        import_file:
          'Um die Dateien zu importieren, muss die erste Zelle der Datei einem der folgenden Muster entsprechen:',
        import_delivery: 'Zum Importieren nach Bereich: kmmin, kmmax, Wert',
        import_cep: 'Zum Importieren der Postleitzahl: cep_start, cep_ende, wert',
        import_cep_negative: 'Zum Importieren der negativen Postleitzahl: cep_start, cep_ende',
        model: 'Muster',
        continue_import:
          'Alle Ihre Datensätze werden ersetzt. Sind Sie sicher, dass Sie fortfahren möchten?',
        cep_delivery: 'Liefer-Postleitzahlen',
        cep_info:
          'Hier sind die Liefer-Postleitzahlen zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        cep_start: 'Postleitzahl Start',
        cep_end: 'Postleitzahl Ende',
        create_cep: 'Liefer-Postleitzahlen erstellen',
        edit_cep: 'Liefer-Postleitzahlen bearbeiten',
        cep_delivery_negative: 'Negative Liefer-Postleitzahlen',
        cep_info_negative:
          'Hier sind die negativen Liefer-Postleitzahlen zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        create_cep_negative: 'Negative Postleitzahl erstellen',
        edit_cep_negative: 'Negative Postleitzahl bearbeiten',
        delete_cep_negative: 'Negative Postleitzahl löschen',
      },

      user: {
        user: 'Benutzer',
        here_are_listed_the_users_along_with_their_respective_actions:
          'Hier sind die Benutzer zusammen mit ihren jeweiligen Aktionen aufgeführt',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Füllen Sie die folgenden Informationen aus und klicken Sie auf die Schaltfläche "Erstellen", um die Änderungen zu speichern',
        save_changes_edit:
          'Füllen Sie die folgenden Informationen aus und klicken Sie auf die Schaltfläche "Speichern", um die Änderungen zu bestätigen',
        picture: 'Foto',
        name: 'Name',
        type: 'Typ',
        registration: 'Registrierung',
        create_user: 'Benutzer erstellen',
        edit_user: 'Benutzer bearbeiten',
        profile_picture: 'Profilbild',
        password: 'Passwort',
        generate_pass: 'Passwort generieren',
        access_level: 'Zugriffsgruppe',
        select_a_access_level: 'Eine Zugriffsgruppe auswählen',
        select_type: 'Einen Typ auswählen',
        active: 'Aktiv',
        actions: 'Aktionen',
        discount_permission: 'Berechtigung für Rabatt beim Verkauf',
        discount_value: 'Maximaler Rabattwert (%)',
        phone: 'Telefonnummer',
      },

      groups: {
        groups: 'Gruppen',
        group: 'Gruppe',
        here_are_listed_the_groups_along_with_their_respective_actions:
          'Hier sind die Gruppen zusammen mit ihren jeweiligen Aktionen aufgeführt',
        name: 'Name',
        Integrations: 'Integrationen',
        means_of_payment: 'Zahlungsmethode',
        products: 'Produkte',
        category: 'Kategorien',
        subcategory: 'Unterkategorie',
        indicators: 'Indikatoren',
        requests: 'Bestellungen',
        reports: 'Berichte',
        messenger: 'Messaging',
      },

      shifts: {
        shifts: 'Schichten',
        here_are_listed_the_shifts_for_each_day_of_the_week:
          'Hier sind die Schichten für jeden Wochentag aufgeführt',
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        sunday: 'Sonntag',
        start: 'Start',
        end: 'Ende',
      },

      account: {
        account: 'Konto',
        edit_account: 'Konto bearbeiten',
        registration_number: 'CNPJ',
        corporate_name: 'Firmenname',
        customer_name: 'Name',
        name_of_the_establishment: 'Name der Einrichtung',
        subdomain: 'Subdomain',
        code: 'Code',
        default_language: 'Standardsprache',
        default_currency: 'Standardwährung',
        login_of_person_in_charge: 'Login der verantwortlichen Person',
        name_of_person_in_charge: 'Name der verantwortlichen Person',
        address: 'Adresse',
        zip_code: 'Postleitzahl',
        number: 'Nummer',
        neighbourhood: 'Bezirk',
        city: 'Stadt',
        state: 'Bundesland',
        public_place: 'Straße',
        address_complement: 'Ergänzung',
        info: 'Wenden Sie sich an den Support, um die Subdomain zu ändern',
      },

      terms: {
        terms: 'Bedingungen',
        here_are_the_terms_of_acceptance_of_the_sales_platform:
          'Hier sind die Akzeptanzbedingungen der Verkaufsplattform aufgeführt',
        create_your_term: 'Erstellen Sie Ihre Bedingung',
        term_name: 'Name der Bedingung',
        valid_until: 'Gültig bis',
        name: 'Name',
        expirated: 'Läuft ab',
      },

      payment_plans: {
        payment_plans: 'Zahlungspläne',
        here_are_listed_the_payment_plans_along_with_their_respective_actions:
          'Hier sind die Zahlungspläne zusammen mit ihren jeweiligen Aktionen aufgeführt',
        create_payment_plans: 'Zahlungspläne erstellen',
        fill_the_information_below_and_click_the_create_button_to_save_the_changes:
          'Füllen Sie die folgenden Informationen aus und klicken Sie auf die Schaltfläche "Erstellen", um die Änderungen zu speichern',
        erp_integration: 'ERP-Integration',
        integration_type: 'Integrations-Typ',
        select_an_integration: 'Eine Integration auswählen',
        card_flag: 'Kartenflagge',
        flag: 'Flagge',
        type: 'Typ',
        erp_code: 'ERP-Code',
        card_installment: 'Ratenzahlung',
        payment_plan: 'Zahlungsplan',
        installment: 'Rate',
        time: 'Frist',
        credit: 'Kredit',
        debit: 'Lastschrift',
      },

      indicators: {
        indicators: 'Indikatoren',
        orders: 'Bestellungen',
        filters: 'Filter',
        first: 'Start',
        end: 'Ende',
        total_order: 'Gesamtanzahl Bestellungen',
        revenue: 'Umsatz',
        orders_by_location: 'Bestellungen nach Modalität',
        orders_by_month: 'Bestellungen pro Monat',
        orders_by_day: 'Bestellungen pro Tag',
        orders_by_hour: 'Bestellungen pro Stunde',
        orders_by_month_sector: 'Bestellungen pro Monat und Modalität',
        orders_by_day_sector: 'Bestellungen pro Tag und Modalität',
        orders_by_hour_sector: 'Bestellungen pro Stunde und Modalität',
        product: 'Produkte',
        categories: 'Kategorien',
        sales_by_category: 'Verkäufe nach Kategorie',
        revenue_by_category: 'Umsatz nach Kategorie',
        average_ticket: 'Durchschnittsticket',
        quantity: 'Menge',
        summary: 'Zusammenfassung',
        summaryAccess: 'Zugriffe',
        summaryAccessGroup: 'Zugriffsbereiche pro Zeitraum',
        summaryTimeAccessGroup: 'Gesamt pro Stunde',
        summaryIPAccessGroup: 'Gesamt pro Benutzer',
        summarySellerCart: 'Gesamtanzahl erstellter Warenkörbe pro Verkäufer',
        period: 'Einen Zeitraum auswählen',
        summaryTypeCust: 'Summe nach Kostentyp',
        summaryComposition: 'Kostenstruktur',
        cost: 'Kosten',
        customer: 'Kunden',
        seller_sales_by_category: 'Verkäufer-Verkäufe nach Kategorie',
        summary_seller: 'Verkäufer-Zusammenfassung',
        sellers_invoice: 'Verkäufer-Abrechnung',
        comparative_sales_by_channel: 'Verkaufsvergleich pro Kanal',
        select_view: 'Ansicht auswählen',
        sales: 'Verkäufe',
        attended_customers: 'Bediente Kunden',
        carts: 'Gespeicherte Warenkörbe',
        sales_conversion: 'Verkaufskonvertierung',
        mean_ticket: 'Durchschnittsticket',
        sales_client: 'Verkaufsvergleich/Ranking pro Kunde',
        sellers: 'Verkäufer',
        summary_store: 'Store-Zusammenfassung',
        accesses: 'Besuche',
        active_sellers: 'Aktive Verkäufer',
        revenue_store: 'Store-Abrechnung',
        revenue_group: 'Gruppen-Abrechnung',
        comparative_sales_by_seller: 'Verkaufsvergleich pro Verkäufer',
        comparative_sales_by_store: 'Vergleich der Geschäftseinheiten',
        comparative_by_seller: 'Vertriebskraft - Verkäufervergleich',
        stores: 'Stores',
        invoicing: 'Abrechnung',
        active_stores: 'Aktive Stores',
        summary_group: 'Gruppen-Zusammenfassung',
        invoice_by_store: 'Abrechnung pro Store',
        rank_sellers: 'Verkäufer-Ranking',
        rank_stores: 'Store-Ranking',
      },

      customer_list: {
        customer_list: 'Kundenliste',
        listed_customers: 'Hier sind die Kunden zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        select_time: 'Zeitraum der getätigten Bestellungen',
        name: 'Name',
        first: 'Start',
        end: 'Ende',
        phone: 'Telefon',
        date: 'Datum',
        detail: 'Kundendetails',
        total_profit: 'Gesamtgewinn',
        total_itens: 'Gesamtanzahl Artikel',
        total_orders: 'Gesamtanzahl Bestellungen',
        order_between: 'Bestellungen zwischen',
        order_detail: 'Bestelldetail',
        create: 'Kunden erstellen',
        go_detail: 'Details anzeigen',
        product: 'Produkt',
        value: 'Wert',
        quantity: 'Menge',
        total: 'Gesamt',
        edit: 'Kunden bearbeiten',
      },

      smart_order: {
        smart_order: 'Smart Order',
        message_warning_find_variation:
          'Achtung! Um Variationen zu erstellen, müssen Sie zuerst das Produkt speichern.',
        service_classification: 'Service-Klassifikation',
        product: 'Produkte',
        create_product: 'Produkt erstellen',
        here_are_listed_the_products_along_with_their_respective_actions:
          'Hier sind die Produkte zusammen mit ihren jeweiligen Aktionen aufgeführt',
        name: 'Name',
        code: 'Code',
        color_code: 'Farbcode',
        crop_image: 'Bild zuschneiden',
        use_original_image: 'Originalbild verwenden',
        select_image_format: 'Bildformat auswählen',
        use_selected_size: 'Ausgewählte Größe verwenden',
        format_640x640: '640x640 (Quadratisch)',
        format_600x900: '600x900 (Porträt)',
        product_data: 'Produktdaten',
        mark: 'Marke',
        measurement_unit: 'Maßeinheit',
        description: 'Beschreibung',
        technical_specification: 'Technische Spezifikation',
        from: 'von',
        characters: 'Zeichen',
        order: 'Reihenfolge',
        product_image: 'Produktbilder',
        additional_images: 'Zusätzliche Bilder',
        product_groups: 'Kundengruppen für das Produkt',
        categories: 'Kategorien',
        here_are_listed_the_categories_along_with_their_respective_actions:
          'Hier sind die Kategorien zusammen mit ihren jeweiligen Aktionen aufgeführt',
        image: 'Produktbild',
        image_variation: 'Variationsbild',
        category: 'Kategorie',
        category_parent: 'Übergeordnete Kategorie',
        category_name: 'Name der Kategorie',
        category_code: 'Code der Kategorie',
        perfil_image: 'Profilbild',

        subcategories: 'Unterkategorien',
        subcategory: 'Unterkategorie',
        here_are_listed_the_subcategories_along_with_their_respective_actionsc:
          'Hier sind die Unterkategorien zusammen mit ihren jeweiligen Aktionen aufgeführt',
        select_category: 'Eine Kategorie auswählen',

        marks: 'Marken',
        listened_marks: 'Hier sind die Marken zusammen mit ihren jeweiligen Aktionen aufgeführt',

        measurements_units: 'Maßeinheiten',
        listened_measurement:
          'Hier sind die Maßeinheiten zusammen mit ihren jeweiligen Aktionen aufgeführt',

        grid_products: 'Grids',
        listened_grid:
          'Hier sind die Produkt-Grids zusammen mit ihren jeweiligen Aktionen aufgeführt',
        grid_name: 'Name des Grids',
        grid_code: 'Code',
        variation: 'Variation',
        grid: 'Grid',
        grids: 'Grids',

        variations: 'Variationen',
        listened_variations:
          'Hier sind die Produktvariationen zusammen mit ihren jeweiligen Aktionen aufgeführt',
        modality: 'Modalität',
        select_modality: 'Eine Modalität auswählen',
        prod: 'Produkt',
        select_product: 'Ein Produkt auswählen',
        no_variation: 'Produkt ohne Variation',
        variation_product: 'Produktvariation',
        cost_price: 'Kostenpreis',
        sell_price: 'Verkaufspreis',
        promotional_price: 'Aktionspreis',
        weight: 'Gewicht',
        height: 'Höhe',
        width: 'Breite',
        depth: 'Tiefe',
        availability: 'Wie ist die Produktverfügbarkeit?',
        when_product_stock: 'Wenn das Produkt nicht mehr auf Lager ist?',
        stock: 'Produktmenge auf Lager',
        min_stock: 'Mindestbestand',
        price: 'Preis',

        catalogs: 'Kataloge',
        catalog: 'Katalog',
        create_catalog: 'Katalog erstellen',
        edit_catalog: 'Katalog bearbeiten',
        catalog_link: 'Katalog-Link kopieren',
        listened_catalogs:
          'Hier sind die Produktkataloge zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        validity: 'Gültigkeit',
        first: 'Start',
        end: 'Ende',
        search_products: 'Produktsuche',

        product_status: 'Produktstatus',
        sku: 'SKU/EAN',
        status_variation: 'Variationsstatus',
        specification: 'Spezifikation',
        price_promotional: 'Preis mit Rabatt',
        inventory: 'Inventar',
        preparation_time: 'Vorbereitungszeit',
        service_title: 'Hier sind die Services zusammen mit ihren jeweiligen Aktionen aufgeführt.',

        initial_hour: 'Anfangszeit',
        final_hour: 'Endzeit',

        date_start: 'Startdatum',
        date_end: 'Enddatum',

        add_group: 'Liste der Zusätze',
        no_add: 'Dieses Produkt ist noch keiner Liste von Zusätzen zugeordnet.',
        already_add: 'Dieses Produkt ist mit den folgenden Listen von Zusätzen verbunden.',
        associate_add: 'Einer Liste von Zusätzen zuordnen',
        associate: 'Zuordnen',
        choose_add:
          'Wählen Sie die Listen von Zusätzen, die diesem Produkt zugeordnet werden sollen.',
        no_group_add: 'Es sind keine Listen von Zusätzen zum Zuordnen verfügbar.',
        remove_add: 'Zuordnung entfernen',
        remove_add_text:
          'Möchten Sie die Zuordnung dieses Produkts zur Liste der Zusätze "@" entfernen?',
        limit_range: 'Maximales Intervalllimit erreicht',

        remove_add_soon:
          'Achtung! Dieser Tab wird in Kürze entfernt. Sie können Ihre Zusätze weiterhin normal verwalten. Gehen Sie zum Tab "Basisinformationen" und dann zum Abschnitt "Zusatzgruppe", um die Zusätze dieses Produkts anzuzeigen.',
        create_image_ia: 'KI-Bildvorschlag',
        create_image_ia_text:
          'Geben Sie eine Produktbeschreibung ein, um die Bilder zu generieren.',
        generate_images: 'Bilder generieren',
        generate_description: 'Beschreibung personalisieren',
        generate_new_options: 'Neue Optionen generieren',
        save_image_selected: 'Ausgewähltes Foto speichern',
        reference_image_ia: 'Referenzbild',
        image_qtd_ia: 'Anzahl Bilder',
        save_img_ia: 'Bilder speichern',
        cancel: 'Abbrechen',

        more_category: 'Weitere Konfigurationen dieser Kategorie anzeigen',
        selectAll: 'Alle auswählen',
        alterLot: 'Charge ändern',
        edit_category:
          'Es ist nicht erlaubt, die Kategoriezuordnung zu ändern. Wir empfehlen Ihnen, eine neue Kategorie zu erstellen',

        catalog_image: 'Katalogbild',
      },

      service_grid: {
        service_grid: 'Service-Grids',
        service_grid_single: 'Service-Grid',
        create_service_grid: 'Service-Grid erstellen',
        edit_service_grid: 'Service-Grid bearbeiten',
        service_grid_name: 'Name des Service-Grids',
        service_grid_name_placeholder: 'Name des Service-Grids',
        start_hour: 'Anfangszeit',
        start_hour_placeholder: '00:00',
        end_hour: 'Endzeit',
        end_hour_placeholder: '23:59',
        interval: 'Intervall',
        interval_placeholder: '00:15',
        interval_tooltip: 'Zeitintervall zwischen Bestellungen',
        service_list: 'Service-Liste',
        service_placeholder: 'Services',
        missing_fields: 'Fehlende Felder',
        missing_fields_message: 'Überprüfen Sie, ob Sie alle Felder ausgefüllt haben!',
        grid_created: 'Grid registriert',
        grid_created_message: 'Registrierung erfolgreich durchgeführt!',
        grid_updated: 'Grid geändert',
        grid_updated_message: 'Bearbeitung erfolgreich durchgeführt!',
        error: 'Fehler',
        error_create_message: 'Fehler beim Registrieren des Grids!',
        error_update_message: 'Fehler beim Ändern des Grids!',
        fill_information_create:
          'Füllen Sie die folgenden Informationen aus und klicken Sie auf die Schaltfläche "Erstellen", um die Änderungen zu speichern',
        save_changes_edit:
          'Füllen Sie die folgenden Informationen aus und klicken Sie auf die Schaltfläche "Speichern", um die Änderungen zu bestätigen',
        dashboard: 'Dashboard',
        title: 'Titel',
        listed_grids:
          'Hier sind die Service-Grids zusammen mit ihren jeweiligen Aktionen aufgeführt',
        grid_deleted: 'Grid gelöscht',
        grid_deleted_message: 'Löschung erfolgreich durchgeführt!',
        error_delete_message: 'Fehler beim Löschen des Grids!',
        status: 'Status',
        grid_linked_warning: 'Verknüpftes Grid',
        grid_linked_message:
          'Dieses Grid ist mit {count} Service-Formular(en) verknüpft und kann nicht gelöscht werden.',
      },

      webapp: {
        webapp: 'Webapp',
        generate_qrcode: 'QR-Code generieren',
        personalize: 'Personalisieren',
        settings: 'Einstellungen',
        link: 'Link zur Webapp',

        webapp_data: 'Webapp-Daten',
        name: 'Name',
        place: 'Ort',
        product_pagination: 'Anzahl Produkte in der Paginierung',
        logo_ninegrid: 'Ninegrid-Logo',
        light: 'Hell',
        dark: 'Dunkel',
        logo_totvs: 'TOTVS-Logo',
        use_icon_menu: 'Symbol im Webapp-Menü verwenden',
        description: 'Beschreibung',
        icon: 'Symbol',
        color_setting: 'Farbkonfiguration',
        background_webapp: 'Hintergrund der Webapp',
        background_default_webapp: 'Standardfarbe der Webapp',
        background_header: 'Hintergrund des Headers',
        text_header: 'Text des Headers',
        icon_header: 'Symbole des Headers',
        background_footer: 'Hintergrund der Fußzeile',
        icon_footer: 'Symbole der Fußzeile',
        highlight_footer: 'Highlight der Fußzeile',
        notification_cart: 'Warenkorb-Benachrichtigung',
        notification_text: 'Text der Benachrichtigung',
        home_button: 'Home-Button',
        text_home_button: 'Text des Home-Buttons',
        title_bar: 'Titelleiste',
        text_title_bar: 'Text der Titelleiste',
        icon_title_bar: 'Symbole der Titelleiste',
        text_category: 'Kategorietext',
        webapp_button: 'Webapp-Thema',
        text_button: 'Text der Buttons',
        background_menu: 'Hintergrund des Seitenmenüs',
        text_menu: 'Text des Seitenmenüs',
        price_card_background: 'Hintergrund der Preiskarte',
        price_card_font_color: 'Schriftfarbe der Preiskarte',
        order_status: 'Bestellstatus',
        order_active_status: 'Aktiver Bestellstatus',
        text_order_active_status: 'Text des Bestellstatus',
        info_cart: 'Warenkorb-Information',

        settings_webapp: 'Webapp-Einstellungen',
        type_delivery: 'Art der Lieferbeschränkung',
        integration: 'Integration',
        select_integration: 'Eine Integration auswählen',
        payment_method_card: 'Zahlungsmethode Karte',
        payment_method_pix: 'Zahlungsmethode Pix',
        payment_method_delivery: 'Zahlungsmethode bei Lieferung',
        consent_letter: 'Einwilligungserklärung aktivieren',
        product_no_stock: 'Verkauf von Produkten ohne Lagerbestand',
        show_subcategory: 'Unterkategorie anzeigen',
        show_observation: 'Anmerkung anzeigen',
        use_category_list: 'Unterkategorien und Produkte in Listen anzeigen',
        use_category_list_v2: 'Kategorien und Unterkategorien in Listen anzeigen',
        use_product_list: 'Produkte in Listen anzeigen',
        remove_shadow: 'Keine Schatten zu Kategorien und Katalogen hinzufügen',
        remove_show_mode: 'Anzeigemodus entfernen',
        no_shadow: 'Keine Schatten zu Kategorien hinzufügen',
        is_order_number: 'Kategorie sortieren',
        order_number: 'Nach Reihenfolge',
        order_category: 'Alphabetisch',
        show_layout: 'Layout anzeigen',
        image_type: 'Produktbildstil',

        withdraw_fee: 'Abholgebühr',
        minimum_value: 'Mindestbestellwert',
        seller_checkout: 'Checkout-Modalität',

        no_sales: 'Verkäufe nicht zulassen',
        safe_mode: 'Sicherheitsmodus',
        time_safe_mode: 'Sitzungszeit des Sicherheitsmodus (in Minuten)',
        limit_characteres_explanation:
          'Für Stores mit Wintor- oder Protheus-Integration werden maximal 50 Zeichen empfohlen.',
        limit_characteres: 'Zeichenlimit',

        skip_entry: 'Eingabebildschirm überspringen',
        payment_table: 'Zahlung am Tisch',

        payment_card: 'Zahlung bei Bestellung',

        slides_homePage: 'Highlight-Bilder Startseite',
        slides_initial: 'Anfängliche Highlight-Bilder',

        slides_not_found: 'Keine Slider-Bilder gefunden',

        externalLink: 'Externer Link',
        buttonType: 'Button-Typ',
        ableUserLocation: 'Adresssuche nach Standort erlauben',
        ableWaiter: 'Option zum Rufen des Kellners deaktivieren',
        closeAccountButton: 'Button zum Schließen des Kontos entfernen',
        emitNfChef: 'Rechnung nach Zahlung der Bestellung ausstellen? (Theke/Tisch/Bestellung)',

        seller_cart_limit_time: 'Ablaufzeit des Verkäufer-Warenkorbs pro Stunde',
        seller_cart_limit_time_explanation:
          'Maximale Zeit, die der Kunde den Verkäufer-Warenkorb verwenden kann',
        settings_webapp_aggregator: 'Personalisieren',
        generate_qrcode_webapp_aggregator: 'QR-Code generieren',
        qrcode_webapp_aggregator: 'Web-App',
        security_settings: 'Sicherheitseinstellungen',
        biometric_authentication: 'Biometrische Authentifizierung',
        code_scanner: 'Barcode und QR-Code-Lesegerät zulassen',
        maximus_radius: 'Standort: Maximal zulässiger Radius (in Metern)',
        access_maximus: 'Maximale Anzahl Zugriffe pro Tisch',
        limit_time: 'Zugriffszeit bis zum Ablauf der Bestellung (in Minuten)',
        password: 'Passwort zum Freischalten des Zugriffs',
        flag_discount: 'Format des Rabatt-Flags',
        color_flag_discount: 'Farbe des Tags',

        config_tags: 'Tags konfigurieren',
        promotional_tags: 'Aktionstag',

        pre_created: 'Vorregistrierung',

        show_classification_button: 'Button zum Anzeigen aller Kategorien anzeigen',
        show_catalog_button: 'Button zum Anzeigen aller Kataloge anzeigen',
        show_catalog_name: 'Namen der Kataloge anzeigen',
        show_classification_name: 'Namen der Kategorien anzeigen',
        show_mark_name: 'Marke der Produkte anzeigen',
        show_stock_quantity: 'Lagerbestand der Produkte anzeigen',
        show_promotional_tags: 'Aktions-Etikett anzeigen',
        show_product_sku: 'Produkt-SKU anzeigen',
        tag_display_groups: 'Tag-Gruppen in der Produktliste anzeigen',
        text_free_delivery: 'Benutzerdefinierter Text für kostenlose Lieferung oder Abholung',
        tooltip_free_delivery:
          'Wenn ausgefüllt, wird dieser Text angezeigt, wenn die Lieferung oder Abholung kostenlos ist. Wenn leer, wird der Wert R$ 0,00 angezeigt',
        place_holder_free_delivery: 'Beispiel: Kostenlos',
        no_show_grid: 'Grids mit einzelnen Produktvariationen ausblenden',
        explain_show_grid:
          'Blendet Grids mit einzelnen Variationen aus. Grids mit mehreren Optionen (z. B. Größen L; XL) bleiben in der Produktauswahl sichtbar, an anderer Stelle jedoch ausgeblendet.',

        type_image: 'Bildtyp',
        type_image_square: 'Quadratisch',
        type_image_rectangle: 'Rechteckig',

        directlink: 'Direktlink',
        infoDirectLink:
          'Nicht obligatorisch, nur wenn es notwendig ist, direkt zu einer anderen Seite oder Website zu senden, maximal 350 Zeichen',

        block_add_in_limit: 'Hinzufügen beim Limit blockieren',

        family_fonte: 'Schriftfamilie',
        rounding_images: 'Rundung der Bilder',
        rounding_bars: 'Rundung der Balken',
        color_icons: 'Farbe der Symbole',
        color_icons_header_footer: 'Farbe der Symbole im Header und Footer',
        background_icon_button: 'Hintergrundfarbe der Symbole',
        background_icon_custom: 'Benutzerdefinierte Farbe',
        restaurant_list: 'Restaurants in Listen anzeigen',
        restaurant_display_mode: 'Anzeige-Modus der Restaurants ändern',
        icon_button_size: 'Größe der Schaltflächensymbole',
        shadow_image: 'Bildschatten',
        black_logo_nine: 'Dunkles Ninegrid-Logo',
        skip_loud_screen: 'Ladebildschirm überspringen',
        can_acesse_restaurant: 'Katalogansicht (Shop/Restaurant) ohne Anmeldung erlauben',
        info_acesse_restaurant:
          'Durch Aktivierung dieses Flags kann der Benutzer auf das Menü/den Katalog des Restaurants oder Geschäfts zugreifen, ohne sich anmelden zu müssen. Falls eine aktive Zahlungsintegration vorhanden ist, wird die Anmeldung direkt in der WebApp des Geschäfts oder Restaurants angefordert, vor dem Zahlungsschritt, damit die Bestellung korrekt mit dem Benutzerkontext (Profil/Reservierung) im Hotelsystem verknüpft wird.',
      },

      integration: {
        integration: 'Integration',
        means_of_payment: 'Zahlungsmethode',
        here_are_listed_the_means_of_payment_along_with_their_respective_actions:
          'Hier sind die Zahlungsmethoden zusammen mit ihren jeweiligen Aktionen aufgeführt',
        PDV: 'POS-Integration',
        listed_here_are_the_integrations_along_with_their_respective_actions:
          'Hier sind die Integrationen zusammen mit ihren jeweiligen Aktionen aufgeführt',
        integration_name: 'Name der Integration',
        type_of_integration: 'Integrations-Typ',
        actions: 'Aktionen',
        search: 'Suchen',
        example: 'Payload-Beispiel',

        loads: 'Cargas',
        name: 'Name',
        price: 'Preis',
        stock: 'Lagerbestand',
        measurements_units: 'Maßeinheiten',
        grid: 'Grids',
        classifications: 'Kategorien',
        products: 'Produkte',
        status_sync: 'Status-Synchronisierung',
        marks: 'Marken',
        orders: 'Bestellungen',
        trigger_load: 'Carga auslösen',
        first: 'Start',
        end: 'Ende',
        load: 'Laden',
        messenger: 'Messaging',
        others: 'Andere',
        test: 'Möchten Sie die Integration testen',
        params_test: 'Parameter dieser Integration anzeigen',
        copy_params: 'Parameter kopieren',
        result_test: 'Ergebnisse des Integrationstests',
        success_1: 'Erfolg! Die Integration',
        success_2: 'war erfolgreich.',
        result_log: 'Ergebnis-Log',
        copy_result: 'Ergebnis kopieren',
        search_result: 'In Ergebnissen suchen',
        error_1: 'Die Integration',
        error_2:
          'hat einen Fehler zurückgegeben. Überprüfen Sie das untenstehende Log für weitere Informationen.',

        success_food_1: 'Erfolg! Die Integration',
        success_food_2: 'war erfolgreich.',
        error_food_1: 'Die Integration',
        error_food_2: 'ist offline zurückgekehrt.',

        integrationPrint: 'Verbindung testen',
      },

      reports: {
        orders: 'Bestellungen',
        order_report: 'Bestellbericht',
        order_list: 'Bestellliste',
        first: 'Start',
        end: 'Ende',
        firstTime: 'Anfangszeit',
        endTime: 'Endzeit',
        orders_between: 'Bestellungen zwischen',
        order_number: 'Bestellnummer',
        date: 'Datum',
        consumer: 'Verbraucher',
        modality: 'Modalität',
        total_value: 'Wert',
        cancel_order: 'Bestellung stornieren',

        products: 'Produkte',
        quantity: 'Menge',
        qtt: 'Menge',
        product: 'Produkt',
        value: 'Wert',
        total: 'Gesamt',
        order_status: 'Bestellstatus',
        payment_method: 'Zahlungsmethode',
        billing_address: 'Rechnungsadresse',
        product_value: 'Wert der Produkte',
        discount: 'Rabatt',
        order: 'Bestellung',

        listened_logs: 'Hier sind die Logs zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        methods: 'Methoden',
        log_details: 'Log-Details',

        withdraw: 'Abholung',
        delivery: 'Lieferung',
        table: 'Tisch',
        counter: 'Theke',
        responsible_withdraw: 'Verantwortlicher für die Abholung',
        responsible_delivery: 'Verantwortlicher für den Empfang',
        address_withdraw: 'Abholadresse',
        address_delivery: 'Lieferadresse',
        seller: 'Verkäufer',
        seller_link: 'Verkäufer-Link',
        external_code: 'Externe Nummer',
        payment: 'Zahlung',
        internal_delivery: 'Interne Lieferung',
        origin: 'Ursprung',
        historial: 'Bestellverlauf',
        approval_moment: 'Datum und Uhrzeit der Genehmigung',
        id: 'Buchungscode',
        pluginspace: 'Hotel',
        hotel: 'Mit Hotel verbundene Bestellung',
        document: 'Buchungsdokument',
        room: 'Zimmercode',
        status_payment: 'Zahlungsstatus',
        authorization_code: 'Autorisierungscode',
        transaction: 'Transaktions-ID',
        made_in: 'Ausgeführt am',
        send_method: 'Versandmethode',
        send_date: 'Versanddatum',
        estimated_delivery: 'Voraussichtliche Lieferung',
        freight: 'Fracht',
        tracking_code: 'Sendungsverfolgungsnummer',
        website: 'Sendungsverfolgungs-Website öffnen',
        label: 'Versandetikett drucken',
        payment_delivery: 'Zahlung bei Lieferung',
        payment_money: 'Barzahlung',
        change_money: 'Wechselgeld',
        label_code: 'Etikett',
        label_website: 'Etiketten-Website öffnen',
        declaration_code: 'Erklärung',
        declaration_website: 'Erklärungs-Website öffnen',
        height: 'Höhe (cm)',
        width: 'Breite (cm)',
        length: 'Länge (cm)',
        weight: 'Gewicht (kg)',
        send_text: 'Vom Kunden gewählte Versandart: ',
        success_label: 'Ihr Versandetikett wurde erfolgreich generiert.',
        continue: 'Weiter',
        confirm: 'Bestätigen',
        change_multiple_status: 'Status mehrerer Bestellungen ändern',
        change_status_text: 'Möchten Sie den Status der folgenden Bestellungen ändern?',
        new_status: 'Neuer Status',
        change_status: 'Status ändern',

        synkar: 'Automatisierung',
        invalid_data: 'Bitte wählen Sie das Start- und Enddatum aus.',

        details: 'Details',
      },

      imports: {
        imports: 'Importe',
        import_image_product: 'Bildimport für Produkte',
        import_image_category: 'Bildimport für Kategorien',
        listened_import_product:
          'Hier sind die Bildimporte für Produkte zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        no_upload_images: 'Kein Bild-Upload durchführen',
        first: 'Start',
        end: 'Ende',
        total_products: 'Gesamtanzahl Produkte',
        sync_products: 'Synchronisierte Produkte',
        import_image_sku: 'Bildimport für Variationen',
        listened_import_sku:
          'Hier sind die Bildimporte für Variationen zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        verify_verification: 'Variationsüberprüfung',
        product_code: 'Produktcode',
        code: 'Code',
        total_variations: 'Gesamtanzahl Variationen',
        sync_variations: 'Synchronisierte Variationen',
        total_categories: 'Gesamtanzahl Kategorien',
        sync_categories: 'Synchronisierte Kategorien',
        problem_title: 'Bilder mit Problem',
        images_success: 'Bilder wurden erfolgreich gesendet.',
        images_error: 'Bilder wiesen ein Problem auf und wurden nicht gesendet.',
        file: 'Datei',
        status: 'Importstatus',
        new_import: 'Neuen Import durchführen',
        import_xls: 'Bilder mit XLS-Datei importieren',
        import_repo: 'Bilder von Google Drive oder Dropbox importieren',
        steps: 'Schritt-für-Schritt-Anleitung für den Import',
        step_1: '1. Legen Sie alle Bilder auf einem öffentlichen Webserver ab.',
        step_2: '2. Überprüfen Sie, ob der Server öffentlich und über das Web zugänglich ist.',
        step_3: '3. Laden Sie unsere leere XLSX-Datei herunter.',
        step_4: '4. Füllen Sie die Daten Ihrer Bilddatenbank aus.',
        step_5: '5. Laden Sie die ausgefüllte Datei hoch.',
        step_1_repo:
          '1. Überprüfen Sie, ob der Store-Ordner als "fotos_loja_<store-id>" erstellt wurde.',
        step_2_repo: '2. Erstellen Sie den Ordner "produkte" im Ordner Ihres Stores.',
        step_2_repo_sku: '2. Erstellen Sie den Ordner "variationen" im Ordner Ihres Stores.',
        step_2_repo_category: '2. Erstellen Sie den Ordner "kategorien" im Ordner Ihres Stores.',
        step_3_repo:
          '3. Bestätigen Sie, dass die Dateien im Format "<produktcode>.<erweiterung>" vorliegen.',
        step_3_repo_sku:
          '3. Bestätigen Sie, dass die Dateien im Format "<sku>.<erweiterung>" vorliegen.',
        step_3_repo_category:
          '3. Bestätigen Sie, dass die Dateien im Format "<kategoriecode>.<erweiterung>" vorliegen.',
        step_4_repo:
          '4. Wenn es sich um ein zusätzliches Produkt handelt, prüfen Sie, ob es "_<nummer>" enthält.',
        step_4_repo_sku:
          '4. Bestätigen Sie, dass die Variation ein Bild ist und im Format JPG oder PNG vorliegt.',
        step_4_repo_category:
          '4. Bestätigen Sie, dass die Kategorie ein Bild ist und im Format JPG oder PNG vorliegt.',
        step_5_repo:
          '5. Bestätigen Sie, dass das Produkt ein Bild ist und im Format JPG oder PNG vorliegt.',
        download: 'Leere XLSX-Datei herunterladen',
        download_problems: 'Bericht exportieren',
        upload: 'Datei senden',
        upload_anex: 'Datei anhängen',
        import_dropbox: 'Mit Dropbox importieren',
        import_drive: 'Mit Google Drive importieren',
        spreadsheet: 'Tabelle',
        gdrive: 'Google Drive',
        dropbox: 'Dropbox',
        type: 'Typ',
        type_resize: 'Typ der Größenänderung',
        agroup_color: 'Fotos nach Farbe gruppieren',
        banner_size: 'Kategorie N1 als Banner behandeln',
        select_dimensions: 'Dimensionen auswählen',
        square: 'Als 640x640 behandeln',
        vertical: 'Als 600x900 behandeln',
      },

      sms: {
        sms: 'SMS',
        listened_sms:
          'Hier sind die Nachrichten (SMS) zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        order: 'Bestellung',
        name: 'Name',
        message: 'Nachricht',
        markers: 'Die Platzhalter [Bestellung] und [Status] müssen in der Nachricht enthalten sein',
        waiting: 'Warten',
        opened: 'Offen',
        ready: 'Fertig',
        refused: 'Abgelehnt',
        message_hotel: 'Hotel-SMS',
        listened_sms_hotel:
          'Hier sind die Hotelnachrichten zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        status_hotel: 'Hotelstatus',
        listened_status_hotel:
          'Hier sind die Hotelstatus und Nachrichten zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        edit_status: 'Status bearbeiten',
        edit_status_hotel: 'Hotelstatus bearbeiten',
        notification: 'Benachrichtigung',
        email_group_status: 'Status',
        email_group_service_forms: 'Serviceformulare',
        email_group_services: 'Dienste',
        email_group_services_booking: 'Dienste - Booking',
        send_email_simple: 'E-Mail senden',
        status_label: 'Status',
        write_message_status: 'Schreiben Sie hier eine Nachricht für diesen Status',
        markers_hotel:
          'Die Platzhalter [pedido], [status], [cliente], [quarto], [hotel] müssen in der Nachricht enthalten sein',
        status_updated: 'Status aktualisiert',
        status_update_success: 'Aktualisierung erfolgreich durchgeführt!',
        status_update_error_title: 'Fehler',
        status_update_error: 'Fehler beim Aktualisieren des Status!',
      },

      multichannel: {
        multichannel: 'Multichannel',
        listened_multichannel:
          'Hier sind die Multichannel-Konfigurationen zusammen mit ihren jeweiligen Aktionen aufgeführt.',
      },

      feed: {
        content: 'Inhalt',
        title: 'Titel',
        fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes:
          'Füllen Sie die folgenden Informationen aus und klicken Sie auf die Schaltfläche "Erstellen", um die Änderungen zu speichern',
      },
      feedCategory: {
        feedCategory: 'Inhaltskategorie',
      },

      structured_content: {},

      queue: {
        index: 'Warteschlange',
        menage: 'Verwaltung',
        config: 'Warteschlangen-Einstellungen',
        able: 'Warteschlange erlauben',
        link: 'Link zur Warteschlange:',
        limit_people: 'Maximale Anzahl Personen',
        limit_people_text: 'Warteschlangenlimit',
        limit_time: 'Zeitlimit für Alarm-Anzeige',
        limit_time_text: 'Maximale Zeit in Minuten, um als verspätet zu gelten',
        image_title: 'Bilddefinition',
        image_text:
          'Das Warteschlangensystem zeigt 2 Bilder an. Laden Sie Fotos Ihres Restaurants hoch oder wählen Sie unten Standardfotos aus. Die hochgeladenen Fotos werden auf die Größe 350x250 Pixel angepasst.',
        image: 'Bild',
        position: 'Position',
        time: 'Wartezeit',
        people: 'Personen',
        cancel: 'Stornierung',
        cancel_text: 'Möchten Sie diese Person aus der Warteschlange entfernen?',
        cancel_button: 'Entfernen',
        confirm: 'Bestätigung',
        confirm_text: 'Möchten Sie die Ankunft des Reservierenden bestätigen?',
        confirm_button: 'Ankunft bestätigen',
        empty: 'Derzeit keine Warteliste',
        confirm_all: 'Alle bestätigen',
        cancel_all: 'Alle stornieren',
        observation: 'Anmerkung',
        use_terms: 'Einwilligungsbedingungen aktivieren',
        total_people: 'Gesamtanzahl Personen pro Gruppe',
        total_people_text: 'Warteschlangenlimit pro Gruppe',
        all: 'Alle',
        in_queue: 'In der Warteschlange',
        preferential: 'Bevorzugt',
        confirmed: 'Bestätigt',
        removed: 'Abgelehnt',
        show: 'Anzeigen',
        show_text: 'Letzte @ Stunden',
        yes: 'Ja',
        no: 'Nein',
        add: 'Kunden zur Warteschlange hinzufügen',
        use_location: 'Standort erlauben?',
        use_menu: 'Möchten Sie ein Menü verwenden?',
        use_ninegrid_menu: 'Ninegrid-Menü verwenden?',
        external_menu_link: 'Link zum Menü eingeben',
        edit: 'Kunden in der Warteschlange bearbeiten',
      },
      booking: {
        index: 'Buchung',
        config: 'Buchungs-Einstellungen',
        able: 'Buchung erlauben',
        link: 'Link zur Buchung:',
        image_title: 'Bilddefinition',
        image_text:
          'Das Buchungssystem zeigt 2 Bilder an. Laden Sie Fotos Ihres Restaurants hoch oder wählen Sie unten Standardfotos aus. Die hochgeladenen Fotos werden auf die Größe 350x250 Pixel angepasst.',
        image: 'Bild',
        days_week: 'Wochentage',
        booking_day: 'Buchungen an diesem Tag erlauben?',
        booking_day_text: 'Definieren Sie unten die für Buchungen freigegebenen Zeiten.',
        booking_day_subtext:
          'Beim Auswählen einer Zeit wird ein Fenster von 1 Stunde definiert. Beispiel: Wenn Sie 19:00 Uhr auswählen, können Personen zwischen 19:00 und 20:00 Uhr buchen.',
        max_people: 'Maximale Anzahl Personen pro Buchung',
        max_people_text:
          'Dies ist die maximale Größe einer Personengruppe, die eine Buchung vornehmen kann',
        expiry_time: 'Maximale Zeit bis zum Ablauf der Buchung',
        expiry_time_text: 'Zeit in Minuten, um auf die Ankunft des Reservierenden zu warten',
        day_confirm: 'Bestätigung am Tag erforderlich',
        day_confirm_text: 'Benutzer muss die Buchung am ausgewählten Datum bestätigen',
        payment_confirm: 'Vorauszahlung bei Buchung erforderlich',
        value_payment_confirm: 'Wert der Vorauszahlung',
        week: 'Woche',
        month: 'Monat',
        year: 'Jahr',
        use_terms: 'Einwilligungsbedingungen aktivieren',
        empty: 'Derzeit keine Buchungen',
        use_time: 'Buchung nach Zeitraum erlauben',
        time: 'Buchungsdauer (HH:mm)',
        time_cancel: 'Frist für die Stornierung der Buchung (HH:mm)',
        time_change: 'Frist für die Änderung der Buchung (HH:mm)',
        use_change: 'Änderung der Buchungszeit erlauben',
      },
      booking_day: {
        booking: 'Tagesbuchungen',
        date: 'Datum',
        people: 'Personen',
        expiry: 'Läuft ab in',
        cancel_title: 'Stornierung',
        cancel_subtitle: 'Möchten Sie diese Buchung stornieren?',
        cancel_button: 'Buchung stornieren',
        confirm_title: 'Bestätigung',
        confirm_subtitle: 'Möchten Sie die Ankunft des Reservierenden bestätigen?',
        confirm_button: 'Ankunft bestätigen',
        accessibility_needs: 'Barrierefreiheitsbedarf',
        accessibility_elderly: 'Seniorenunterstützung',
        accessibility_wheelchair: 'Rollstuhlfahrer',
        accessibility_physical: 'Körperbehinderung',
        filter_accessibility: 'Nach Barrierefreiheit filtern',
        all_accessibility: 'Alle Bedürfnisse',
      },
      booking_report: {
        report: 'Berichte',
        search: 'Buchungssuche',
        time: 'Zeitraum auswählen',
        date_start: 'Startdatum',
        date_end: 'Enddatum',
        confirm: 'Bestätigung',
        noShow: 'Nichterscheinen',
        confirmed: 'Bestätigte Buchungen',
        canceled: 'Stornierte Buchungen',
        open: 'Offen',
        map: 'Buchungskarte',
        booking: 'Buchungen',
        accessibility_stats: 'Barrierefreiheitsstatistiken',
        accessibility_total: 'Gesamt mit Bedürfnissen',
        accessibility_percentage: 'Prozentsatz',
      },
      booking_report_management: {
        management: 'Buchungsverwaltung',
        search: 'Buchungssuche',
        phone: 'Telefon',
        date_start: 'Startdatum',
        date_end: 'Enddatum',
        today: 'Heute',
        tomorrow: 'Morgen',
        calendar: 'Kalender',
        see_all: 'Alle anzeigen',
        people: 'Personen',
        noShow: 'Nichterscheinen',
        confirmed: 'Bestätigt',
        canceled: 'Storniert',
        open: 'Offen',
        search_text: 'Ergebnisse der Telefonsuche oder Datumsauswahl',
      },
      environment: {
        map: 'Umgebungs-Karte',
        environment: 'Umgebung',
        index: 'Umgebungen',
        name: 'Name der Umgebung',
        tables: 'Anzahl Tische',
        seats_available: 'Gesamtanzahl verfügbarer Plätze',
        actions: 'Aktionen',
      },
      week_day: {
        sun: 'So',
        mon: 'Mo',
        tue: 'Di',
        wed: 'Mi',
        thur: 'Do',
        fri: 'Fr',
        sat: 'Sa',
      },
      week_day_full: {
        sun: 'Sonntag',
        mon: 'Montag',
        tue: 'Dienstag',
        wed: 'Mittwoch',
        thur: 'Donnerstag',
        fri: 'Freitag',
        sat: 'Samstag',
      },
      checkout: {
        title: 'Kundendaten',
        here_are_listed_the_modalities_along_with_their_respective_actions:
          'Hier sind die für die Kundenerstellung erforderlichen Felder aufgeführt.',
        active_mandatory: 'Obligatorisches Feld',
        active_visibility: 'Sichtbares Feld',
      },

      liveShop: {
        liveShop: 'Live Commerce',
        liveShop_list:
          'Hier sind die Live Commerce-Events zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        create: 'Live Commerce erstellen',
        edit: 'Live Commerce bearbeiten',
        dateInit: 'Start',
        hourInit: 'Startzeit',
        dateEnd: 'Ende',
        hourEnd: 'Endzeit',
        status: 'Status',
        initDate: 'Startdatum und -zeit',
        fimDate: 'Enddatum und -zeit',
        name: 'Name',
        variations: 'Produktvariationen',
        search_products_Attentions:
          'Die zurückgegebenen Produkte und Variationen müssen den Status "aktiviert" haben sowie einen Preis, Lagerbestand und ein Bild besitzen',
        alert_delete:
          'Eine Live-Veranstaltung kann nicht entfernt werden, wenn sie begonnen hat oder beendet wurde!',
        alert_Edit:
          'Eine Live-Veranstaltung kann nicht bearbeitet werden, wenn sie begonnen hat oder beendet wurde!',
        delete: 'Live Commerce löschen',
      },

      logs: {
        //PagSeguro
        pagseguroPaymentCodePhone: 'Fehler Telefoncode Pagseguro',
        pagseguroPaymentErrorCountry: 'Fehler Ländercode Pagseguro',
        pagseguroPaymentErrorEmail: 'Fehler E-Mail Pagseguro',
        authenticatePagseguro: 'Authentifizierung Pagseguro',
        pagseguroPayment: 'Zahlung Pagseguro',
        pagseguroPaymentCatch: 'Zahlung Pagseguro',
        pagseguroPaymentResponse: 'Antwort der Zahlung Pagseguro',
        pagseguroPaymentTransactions: 'Transaktion der Zahlung Pagseguro',
        pagseguroReturnPayment: 'Rückgabe der Zahlung Pagseguro',
        paymentPixPagseguro: 'Pix-Zahlung Pagseguro',

        pagseguroPaymentGateway: 'Zahlungs-Gateway Pagseguro',
        getAuthPagseguroEmailSpace: 'Pagseguro-Authentifizierung per E-Mail',
        getOneApplicationClientId: 'Pagseguro-Kundenanwendung abrufen',
        createAuthPagseguro: 'Pagseguro-Authentifizierung erstellen',
        generatePublicKeyPagseguro: 'Öffentlichen Schlüssel Pagseguro generieren',
        updateCodeRedirectApplication: 'Aktualisierung des Pagseguro-Anwendungscodes',
        deleteAuthPagseguroByEmail: 'Pagseguro-Authentifizierung entfernen',
        createPluginconfig: 'Plugin-Konfiguration',

        //Totvs Zahlung HUB
        refundTotvs: 'Rückerstattung über Totvs',
        refundPayCard: 'Rückerstattung über Totvs per Karte',
        paymentTotvs: 'Zahlung über Totvs',
        paymentPixTotvs: 'Pix-Zahlung über Totvs',

        //Kartenstruktur
        sendUnregisteredCardBrands: 'Marke nicht gefunden',
        cardStructure: 'Kartenstruktur',
        cardStructureInvalidPlugin: 'Ungültiges Plugin für das Gateway',
        cardStructureGatewayError: 'Kartenfehler für das Gateway',
        cardStructureData: 'Kartendaten',
        cardStructureError: 'Fehler bei den Kartendaten',
        cardStructureDecrypt: 'Kartenentschlüsselung',
        cardStructureFields: 'Kartenfelder',
        refundCard: 'Kartenrückerstattung',

        //Status
        analysisSatusOrder: 'Bestellstatus zur Analyse',
        statusPayPix: 'Pix-Status',

        //Anti-Betrug
        analyseAntifraud: 'Anti-Betrugs-Analyse',
        dataClearSale: 'ClearSale-Daten',
        statusAnalysis: 'Status der Analyse',

        //Lagerbestand
        addSkuInventory: 'Zum Lagerbestand hinzufügen',
        subtractSku: 'Aus dem Lagerbestand entfernen',
        viewCargoHistory: 'Carga-Verlauf anzeigen',
        viewCargoHistoryBySku: 'Carga-Verlauf nach SKU anzeigen',

        // Bestellung-Pedido
        sendOrderIn: 'Bestellversand',
        cancelOrder: 'Bestellung stornieren',
        sendOrder: 'Bestellung senden',
        sendOrderRefund: 'Bestellrückerstattung',
        sendOrderError: 'Fehler beim Senden der Bestellung',
        sendOrderResultRefund: 'Ergebnis der Bestellrückerstattung',
        sendOrderResultData: 'Ergebnis des Bestellversands',
        sendOrderAntifrud: 'Anti-Betrug beim Bestellversand',
        sendOrderPaymentStruct: 'Zahlungsstruktur der Bestellung',

        sendOrderDescryptor: 'Bestellentschlüsselung',
        sendOrderStatus: 'Bestellstatus',
        sendOrderConfigNotFound: 'Konfiguration des Bestellversands',
        sendOrderMandatoryCustomer: 'Kunde der Bestellung',
        sendOrderMandatory: 'Obligatorische Struktur der Bestellung',
        sendOrderResultGateway: 'Ergebnis des Versands an das Gateway',
        OrderFashionService: 'Fashion-Bestellservice',
        OrderFashionServiceError: 'Fehler im Fashion-Bestellservice',
        cartOrderLive: 'Warenkorb der Live-Bestellung',
        cartOrderLiveError: 'Fehler im Warenkorb der Live-Bestellung',
        sendOrderErrorGeral: 'Fehler bei der Bestellung',
        sendPushNotification: 'Push-Benachrichtigung senden',

        //Vorbestellung
        preOrderStatusPix: 'Status der Vorbestellung über Pix',
        processQueuePreOrder: 'Verarbeitung der Vorbestellungs-Warteschlange',
        getAllPreOrderBySpace: 'Alle Vorbestellungen pro Pluginspace abrufen',
        sendPreOrder: 'Vorbestellung senden',
        makeOrderTransparent: 'Bestellüberprüfung',
        statusPreOrder: 'Aktualisierung des Pix-Status der Vorbestellung',
        preOrderStatusCanceledPix: 'Vorbestellung über Pix stornieren',

        //Totvs Winthor
        buildOrderTotvsWinthor: 'Bestellung erstellen',
        sendOrderWinthor: 'Bestellung an Totvs senden',
        sendCustomerOrderWinthor: 'Kunden an Totvs senden',

        //Totvs Retail
        buildOrderTotvsVarejo: 'Bestellung erstellen',
        setConfimTicket: 'Ticket-Bestätigung',
        SyncOrderLive: 'Bestell-Synchronisierung',
        ObterProdutos: 'Produkte abrufen',
        taskPrice: 'Preis-Carga',
        calculationPromotion: 'Aktionsberechnung',
        PayloadCalcPromotion: 'Payload Aktionsberechnung',

        //Totvs Fashion
        changeStatus: 'Statuswechsel',
        sendOrderFashion: 'Bestellung an Totvs senden',
        sendCustomerFashion: 'Kunden an Totvs senden',
        searchPersonTotvsByCPF: 'Totvs-Kundensuche',
        sendErrorCustomerFashion: 'Fehler beim Senden des Kunden an Fashion',
        buildCustomerTotvsFashion: 'Kundenerstellung bei Totvs',
        ResumeSnyOrderFashion: 'Zusammenfassung der Synchronisierung mit Fashion',
        changeStatusFashion: 'Status wechseln',
        buildOrderTotvsFashion: 'Fashion-Bestellung erstellen',

        //Totvs Food
        updateStatusOrderFoodIntegration: 'Statuswechsel',
        buildOrderTotvsFood: 'Bestellung erstellen',
        changeStatusOrderFood: 'Statuswechsel',
        sendOrderTotvsFood: 'Bestellung an Totvs senden',
        confirmMenu: 'Menü bestätigt',
        getMenu: 'Totvs-Menü abrufen',

        //Totvs Live
        sendCustomerLive: 'Live-Kundenversand',
        sendOrderLive: 'Live-Bestellversand',

        //Synkar
        updateStatusOrderSynkar: 'Synkar-Bestellaktualisierung',
        sendingOrderMessageSynkar: 'Synkar-Messaging-Versand',
        responseOrderMessageSynkar: 'Synkar-Messaging-Antwort',
        sendingOrderSynkar: 'Synkar-Versand',
        responseOrderSynkar: 'Synkar-Antwort',

        //SDS
        sdsGetOrders: 'SDS-Bestellungen abrufen',
        sdsOrderIn: 'SDS-Bestellversand',
        sdsOrderInResult: 'Bestellversand an SDS',
        sdsSyncCardapio: 'Menü-Synchronisierung mit SDS',
        'sendOrderfood-sdsOrderIn': 'Fehler beim Senden der SDS-Bestellung',

        //S3
        createRoute: 'S3-Route erstellen',
        getStatusfiftythree: 'Status Route 53',
        updateDistribution: 'Verteilung aktualisieren',
        deleteRoute: 'S3-Route löschen',
        deleteDistribution: 'Verteilung löschen',

        //Erede
        refundErede: 'Erede-Rückerstattung',
        paymentErede: 'Erede-Zahlung',

        //Cielo
        refundCielo: 'Cielo-Rückerstattung',
        paymentCielo: 'Cielo-Zahlung',

        //Pagseguro
        refundPagseguro: 'Pagseguro-Rückerstattung',
        getApplicationPagseguro: 'Gateway-Anwendung Pagseguro',

        //Offline-Zahlung
        paymentOffline: 'Zahlung bei Lieferung',

        //Allgemein
        chargeSyncOrderErro: 'Fehler bei der Status-Synchronisierung',
        chargeSyncOrder: 'Status-Synchronisierung',
        chargeProductLive: 'Synchronisierung von Live-Produkten',
        chargeBalanceLive: 'Synchronisierung des Live-Lagerbestands',
        chargePriceLive: 'Synchronisierung von Live-Preisen',
        chargeProductLiveErro: 'Fehler bei der Synchronisierung von Live-Produkten',
        chargeBalanceLiveErro: 'Fehler bei der Synchronisierung des Live-Lagerbestands',
        chargePriceLiveErro: 'Fehler bei der Synchronisierung von Live-Preisen',

        chargeProduct: 'Produktsynchronisierung',
        chargeBalance: 'Lagerbestandssynchronisierung',
        chargePrice: 'Preissynchronisierung',
        chargeProductErro: 'Fehler bei der Produktsynchronisierung',
        chargeBalanceErro: 'Fehler bei der Lagerbestandssynchronisierung',
        chargePriceErro: 'Fehler bei der Preissynchronisierung',

        taskBalanceIntegration: 'Integration der Lagerbestands-Carga',
        taskBalanceCharge: 'Lagerbestands-Carga gestartet',
        SnyOrder: 'Status-Synchronisierung der Bestellung',
        syncronyzePriceInteration: 'Preis-Carga',
        syncronyzePrice: 'Preissynchronisierung',
        chargeClassification: 'Kategorie- und Unterkategorie-Carga',
        chargeGrid: 'Grid-Carga',
        chargeGridItens: 'Grid-Carga-Elemente',
        chargeMeasure: 'Maßeinheiten-Carga',
        deleteAllProducts: 'Alle Produkte löschen',

        chargeGridToken: 'Token für Grid-Carga',
        classificationChargeToken: 'Token für Klassifizierungs-Carga',
        syncronyzeBalanceToken: 'Token für Lagerbestandssynchronisierung',
        syncronyzePriceToken: 'Token für Preissynchronisierung',
        chargeMeasureToken: 'Token für Maßeinheiten-Carga',
        taskClassificationBySpace: 'Klassifizierungs-Carga',
        syncStatusOrderPayload: 'Payload der Status-Synchronisierung der Bestellung',
        syncStatusOrder: 'Status-Synchronisierung der Bestellung',
        syncStatusOrderToken: 'Token der Status-Synchronisierung der Bestellung',
        syncronyzeBalancePayload: 'Payload der Lagerbestandssynchronisierung',
        syncronyzeBalance: 'Lagerbestandssynchronisierung',
        taskBalanceChargeBySpace: 'Lagerbestands-Carga',
        syncronyzePricePayload: 'Payload der Preissynchronisierung',
        priceSkuVariationItens: 'Preis der Variationselemente',
        configSyncOrderBySpace: 'Konfiguration der Bestellsynchronisierung',
        configSyncOrder: 'Konfiguration der Bestellsynchronisierung',
        taskGridChargeBySpace: 'Grid-Carga',
        productChargeInternal: 'Produkt-Carga',
        taskChargeProductBySpace: 'Produkt-Carga',
        skuLocationVariation: 'Variationssynchronisierung nach Standort',
        stockSkuVariation: 'Variationssynchronisierung',
        taskPriceChargeBySpace: 'Preis-Carga pro Pluginspace',

        automaticChargeBalance: 'Autom. Lagerbestandssynchronisierung',
        automaticChargePrice: 'Autom. Preissynchronisierung',
        automaticChargeClassification: 'Autom. Klassifizierungssynchronisierung',
        automaticTaskGridCharge: 'Autom. Grid-Synchronisierung',
        automaticTaskMeassure: 'Autom. Maßeinheiten-Synchronisierung',
        automaticSnyOrder: 'Autom. Bestellstatus-Synchronisierung',
        chargeMeasureItens: 'Maßeinheiten-Carga-Elemente',
        searchMeasurementAll: 'Maßeinheiten-Carga',
        taskGridCharge: 'Grid-Carga',
        taskMeassure: 'Maßeinheiten-Carga',

        getCredential: 'Token abrufen',
        LoadPricePerList: 'Preis-Carga',
        processPriceList: 'Verarbeitung der Preisliste',
        updateProductKit: 'Produktaktualisierung',
        UpdateProductSingle: 'Produktaktualisierung',
        updateProductStatus: 'Aktualisierung des Produktstatus',
        taskBalanceIntegrationLink: 'Link zur Lagerbestandsintegration',
        taskPriceIntegrationLink: 'Link zur Preisintegration',
        taskProductIntegrationLink: 'Link zur Produktintegration',
        token: 'Token-Abruf',
        automaticChargeProduct: 'Automatische Produkt-Carga',

        //Ninegrid Rabatt
        calculateDiscount: 'Rabattberechnung in Ninegrid',
        sendDiscountNinegrid: 'Ninegrid-Rabatt',

        //Kunden-Warenkorb
        updateCustomerCartStatus: 'Aktualisierung des Kunden-Warenkorbs',

        //Kunde
        createCustomer: 'Kundenerstellung',
        validCodeCustomer: 'Validierungscode des Kunden',

        //clearSale
        statusAnalisis: 'Statusanalyse',
        antifraudValidation: 'Anti-Betrugs-Validierung',
        clearSale: 'ClearSale Garantiert',
        searchOrderStatusClearSale: 'ClearSale-Status suchen',

        printLabelFrenet: 'Frenet-Etikett',
        changeStatusFrenet: 'Frenet-Statuswechsel',
        callWaiter: 'Kellner rufen',
        paymentTable: 'Zahlung am Tisch',

        // Generierung der Chefrechnung
        generateNfOrderFood: 'Rechnung der Bestellung generieren',
        getNotaFiscalChef: 'Rechnung des Chefs abrufen',
        finishOrderFood: 'Vorabprüfung vor der Rechnung',

        // Fehlerprotokoll der Chef-Bestellung
        buildCardData: 'Fehler beim Erstellen von Daten für die Bestellung',
        buildTableData: 'Fehler beim Erstellen von Daten für den Tisch',
        buildTablePaymentData: 'Fehler beim Erstellen von Daten für die Tischzahlung',
        buildCounterData: 'Fehler beim Erstellen von Daten für die Theke',
        buildDeliveryData: 'Fehler beim Erstellen von Daten für Lieferung/Abholung',

        generateCustomerWholeSalerByCSV: 'Großhandelskunden per CSV generieren',

        validateStockWholeSaleCart: 'Bestellalarm',
        validateWholeSaleCart: 'Bestellalarm',

        chargeImageService: 'Bild-Carga-Service',

        webhookNisRedis: 'Bereinigung des Store-Redis',

        /* E-Mail-Versand */
        sendEmailWelcome: 'Willkommens-E-Mail senden',
        sendEmailOrderNotification: 'Bestellbenachrichtigung per E-Mail senden',
        sendEmailAccountNotification: 'Kontobenachrichtigung per E-Mail senden',
        createCustomerLogin: 'E-Mail zur Erstellung des Kunden-Logins senden',
      },

      copy: {
        definition: 'Pluginspace-Definition',
        origin: 'Quell-Pluginspace auswählen',
        destination: 'Ziel-Pluginspace auswählen',
        configurations: 'Kopier-Einstellungen',
        store: 'Store-Einstellungen',
        deliveryFee: 'Liefergebühr',
        shifts: 'Schichten',
        paymentPlans: 'Zahlungspläne',
        clientData: 'Kundendaten',
        account: 'Kontoeinstellungen',
        groups: 'Gruppen',
        terms: 'Bedingungen',
        webapp: 'Webapp',
        webappConfig: 'Einstellungen',
        webappPersonalize: 'Personalisierung',
        whatsappweb: 'WhatsApp Web',
        whatsappwebConfig: 'Einstellungen',
        whatsappwebPersonalize: 'Personalisierung',
        integrations: 'Integrationen',
        integrationPayment: 'Zahlungsmethoden',
        integrationPdv: 'POS',
        integrationMessaging: 'Messaging',
        integrationOthers: 'Andere',
        button: 'Pluginspace kopieren',
      },

      payment: {
        methods: 'Zahlungsmethoden',
        method: 'Zahlungsmethode',
        gateway: 'Zahlungs-Gateway',
        card: 'Kreditkarte',
        debit: 'Debitkarte',
        food: 'Lebensmittelgutschein',
        pix: 'Pix',
        others: 'Andere',
        pay_money: 'Bargeld',
        config: 'Einstellungen',
        add: 'Zahlungsmethode konfigurieren',
        back: 'Zurück zu den Zahlungs-Gateways',
        basic_settings: 'Grundeinstellungen',
        modalities: 'Modalitäten, in denen diese Zahlungsmethode verwendet wird',
        add_payment: 'Zahlungsmethode hinzufügen',
        code_erp: 'ERP-Code',
        installments: 'Anzahl Raten',
        edit_payment: 'Zahlungsmethode bearbeiten',
        delete: 'Zahlungsmethode löschen',
        money: 'Barzahlung',
        max_installments: 'Wie ist die maximale Anzahl Raten?',
        min_value_installments: 'Wie ist der Mindestwert für die Raten?',
        confirm: 'Löschung bestätigen',
        delete_payment: 'Möchten Sie die Zahlungsmethode löschen',
        change: 'Möchten Sie diesen Austausch durchführen?',
        inative: 'Möchten Sie diese Zahlungsmethode inaktivieren?',
        inative_change: 'Möchten Sie diese Zahlungsmethode aktivieren und die alte inaktivieren?',
        motive: 'Bitte geben Sie den Grund an',
        /* für Rabatt verwendet */
        config_descount_payment: 'Rabattkonfiguration pro Zahlungsmethode',

        able_discount_pix: 'Rabatt für Pix-Zahlung aktivieren',
        able_discount_card: 'Rabatt für Kartenzahlung aktivieren',
        able_discount: 'Rabatt für Zahlung aktivieren',

        discount_percentage: 'Prozentualer Rabatt',
        discount_monetary: 'Monetärer Rabatt',
        discount_value: 'Wert des Rabatts',
      },

      icon: {
        title: 'Symbole',
        subtitle: 'Hier sind alle Symbole der Bibliothek aufgeführt',
      },
      freight: {
        title: 'Versandmodalitäten',
        map: 'Karte',
        map_text: 'Option für Zahlung bei Lieferung der Bestellung',
        range: 'Radius',
        range_text: 'Option für Zahlung bei Lieferung der Bestellung',
        cep: 'Postleitzahlenliste',
        cep_text: 'Option für Zahlung bei Lieferung der Bestellung',
        config: 'Einstellungen',
        delivery: 'Eigene Lieferung',
        delivery_text: 'Es gibt 3 anpassbare Lieferoptionen:',
        frenet: 'Frenet',
        frenet_text: 'Umfassendes Frachtmanagement mit verschiedenen Speditionen und Versandarten.',
        frenet_text_2: 'Um diese Integration zu aktivieren, ist ein Frenet-Plan erforderlich.',
        site: 'Offizielle Website anzeigen',
        coming_soon: 'Bald verfügbar...',
      },
      frenet: {
        title: 'Integration mit Frenet',
        back: 'Zurück zu den Liefermöglichkeiten',
        integration: 'Integration',
        config: 'Einstellungen',
        dimensions: 'Grundlegende Lieferabmessungen in Zentimetern',
        height: 'Höhe',
        width: 'Breite',
        length: 'Länge',
        value: 'Deklarierter Wert der Produkte',
        use: 'Verwenden',
        dont_use: 'Nicht verwenden',
        price: 'Vereinfachte Quotierung verwenden?',
        yes: 'Ja',
        no: 'Nein',
        branchCode: 'Jadlog-Versandstelle',
        no_balance: 'Kein Guthaben bei Frenet',
        value_balance: 'Sie haben @ Guthaben bei Frenet',
        print_balance:
          'Um das Versandetikett für diese Bestellung zu drucken, müssen Sie Guthaben auf Ihr Frenet-Konto aufladen.',
        click_balance:
          'Klicken Sie auf die Schaltfläche unten, um Frenet in einem anderen Tab zu öffnen.',
        open_balance: 'Frenet-Konto öffnen',
        valid_token: 'Ungültiger Token',
        declared_value:
          'Der deklarierte Wert wird im Falle einer Versicherung durch den Spediteur verwendet.',
        getToken:
          'Um den Token bei Frenet zu finden, müssen Sie zum Bereich "Zugriffsschlüssel" gehen und den Wert des Feldes "TOKEN" kopieren.',
        weight_frenet: 'Standardgewicht (kg)',
        height_frenet: 'Standardhöhe (cm)',
        width_frenet: 'Standardbreite (cm)',
        depth_frenet: 'Standardtiefe (cm)',
        alert_title: 'Referenzabmessungen für die Frachtberechnung',
        alert_warning: 'Achtung!',
        alert_description:
          'Diese Maße werden zur Berechnung der Fracht für Produkte ohne registrierte Volumetrie verwendet.',
        alert_wrong_values: 'Falsche Werte können Folgendes generieren:',
        alert_overpriced: 'Überteuerte Fracht (Kunden abschrecken).',
        alert_additional_costs: 'Zusätzliche Kosten (wenn der Spediteur den Wert später anpasst).',
        alert_recommendation:
          'Wir empfehlen, die tatsächliche Volumetrie jedes Produkts zu registrieren.',
        alert_reference: 'Referenzabmessungen:',
        alert_small_products: 'Kleine Produkte',
        alert_small_examples: '(z. B. Zubehör, Schmuck, Kabel)',
        alert_small_weight: 'Gewicht: 0,1–0,3 kg',
        alert_small_dimensions: 'Abmessungen: 10 × 10 × 5 cm',
        alert_medium_products: 'Mittlere Produkte',
        alert_medium_examples: '(z. B. Kleidung, Bücher, kleine Elektronik)',
        alert_medium_weight: 'Gewicht: 0,5–2 kg',
        alert_medium_dimensions: 'Abmessungen: 25 × 20 × 10 cm',
        alert_large_products: 'Große Produkte',
        alert_large_examples: '(z. B. Haushaltsgeräte, große Kartons)',
        alert_large_weight: 'Gewicht: 5–20 kg oder mehr',
        alert_large_dimensions: 'Abmessungen: 50 × 40 × 30 cm oder größer',
      },
      chat: {
        you: 'Sie',
        now: 'Jetzt gesendet',
        send: 'Senden',
        type_message: 'Senden Sie eine Nachricht...',
        initial_message: 'Willkommen im Ninegrid KI-Chat',
        error_message:
          'Ich konnte keine Antwort auf Ihre Nachricht finden. Seien Sie bitte spezifischer oder versuchen Sie es später erneut.',
        tip_language: 'Bitte antworten Sie auf Deutsch.',
        title_config: 'Einstellungen der Künstlichen Intelligenz',
        config: 'Künstliche Intelligenz konfigurieren',
        fit: 'Training der Künstlichen Intelligenz',
        fit_header: 'Hier sind die Fragen mit den entsprechenden erstellten Antworten aufgeführt',
        add_question: 'Frage hinzufügen',
        edit_question: 'Frage bearbeiten',
        delete_question: 'Möchten Sie die folgende Frage löschen?',
        question: 'Frage',
        answer: 'Antwort',
        date: 'Datum',
        actions: 'Aktionen',
        active: 'Aktiv',
        delete: 'Löschen',
        sync: 'KI synchronisieren',
        upload: 'Datei-Upload',
        about: 'Über',
        chatia: 'Chat',
        about_title: 'Über Ninegrid KI',
        about_description_title: 'Beschreibung',
        about_description:
          'Ninegrid KI ist ein intelligenter virtueller Assistent, der Ihnen bei Support-Aufgaben helfen soll.',
        about_support_title: 'Support',
        about_support_description:
          'Wenn Sie Fragen haben oder Hilfe benötigen, steht Ihnen unser Support-Team zur Verfügung.',
        about_support_contact_1: 'Um mit dem Support zu sprechen, kontaktieren Sie uns per E-Mail',
        about_support_contact_2: 'oder eröffnen Sie ein Ticket in unserem Portal:',
        about_features_title: 'Funktionen',
        tips: 'Tipps zum Erstellen Ihrer Fragen',
        about_tips_1: 'Verwenden Sie klare und objektive Fragen, um bessere Antworten zu erhalten.',
        about_tips_2: 'Vermeiden Sie Slang oder komplexe Fachbegriffe.',
        about_tips_3:
          'Wenn die Antwort nicht zufriedenstellend ist, versuchen Sie, die Frage neu zu formulieren.',
        about_tips_4:
          'Ninegrid KI lernt aus den Interaktionen. Je mehr Sie es verwenden, desto besser wird es.',
        feature_1: 'Konversation in natürlicher Sprache',
        feature_2: 'Unterstützung für Sprachbefehle',
        feature_3: 'Sprachsynthese für Antworten',
        feature_4: 'Intuitive und reaktionsschnelle Benutzeroberfläche',
        about_manuals: 'Handbücher',
        about_manuals_description:
          'Sehen Sie sich unsere Handbücher an, um mehr über die Verwendung der Ninegrid-Umgebung zu erfahren,',
        about_faq: 'Häufig gestellte Fragen',
        about_faq_description:
          'Sehen Sie sich die häufigsten Fragen und deren Antworten an, um allgemeine Zweifel zu klären,',
        about_version_title: 'Systeminformationen',
        version: 'Version',
        last_update: 'Letzte Aktualisierung',
        rights_reserved: 'Alle Rechte vorbehalten',
        access_here: 'hier zugreifen',
        our_faq: 'häufig gestellte Fragen anzeigen',
        or: 'oder',
        and: 'und',
      },
      sumary_access: {
        cart: 'Warenkorb',
        seller: 'Verkäufer-Login',
        category: 'Kategorien',
        pdv: 'Produktdetails',
        subcategory: 'Unterkategorie',
        product: 'Produktliste',
        home: 'Startbildschirm',
        'search-order': 'Bestellungen',
        'store-info': 'Store-Informationen',
        customer: 'Kundenregistrierung',
        receipt: 'Zahlungsbeleg',
        order: 'Zahlung',
        card: 'Kartenzahlung',
        'order-qrcode': 'Pix-Zahlung Kunde',
        'success-order': 'Kauf erfolgreich',
        'filter/pdv': 'Filterergebnis',
        filter: 'Filterauswahl',
        'seller-qrcode': 'Zahlungs-Link',
        'vendor-order ': 'Verkäufer-Warenkorb-Abfrage',
        'finalize-order': 'Kaufzusammenfassung',
      },
      optional: {
        optionals: 'Zusätze',
        list: 'Liste der Zusätze',
        name: 'Name',
        used: 'Verwendet in',
        config: 'Konfigurieren',
        link: 'Produkte zuordnen',
        products_optional: 'Der Liste zugeordnete Produkte',
        edit: 'Liste der Zusätze bearbeiten',
        type: 'Auswahltyp',
        max: 'Maximal',
        mandatory: 'Obligatorisch',
        order: 'Reihenfolge',
        code: 'Code',
        qtd: 'Max. Menge',
        price: 'Preis',
        include: 'Einen Zusatz hinzufügen',
        create: 'Liste der Zusätze erstellen',
        description: 'Webapp-Beschreibung',
        emptyProduct: 'Kein Produkt verwendet diesen Zusatz',
      },

      coupons: {
        title: 'Gutscheine',
        report: 'Gutscheinberichte',
        titleCreate: 'Gutscheine erstellen',
        titleUpdate: 'Gutscheine bearbeiten',
        subTitle: 'Hier sind die Gutscheine zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        create: 'Gutschein erstellen',
        edit: 'Gutschein bearbeiten',
        delete: 'Gutschein löschen',

        //Eingabevariablen
        name: 'Name des Gutscheins',
        name_helper: 'Maximal 15 Zeichen',
        description: 'Beschreibung',
        description_placeholder: 'darf maximal 200 Zeichen akzeptieren',
        seller: 'Verkäufer',
        catalog: 'Katalog',
        discountValue: 'Wert des Rabatts',
        discountPercentage: 'Prozentsatz des Rabatts',
        type: 'Typ',
        dateInit: 'Startdatum',
        dateEnd: 'Enddatum',
        quantitative: 'Anzahl der Nutzungen',
        typeOptions: {
          all: 'Alle Typen',
          classification: 'Klassifizierung',
          product: 'Produkt',
          individuality: 'Individuell',
          exclusive: 'Exklusiv',
          quantitative: 'Quantitativ',
          periodical: 'Periodisch',
          cupomday: 'Coupon-Tag',
        },
        filters: 'Filter',
        status: 'Status',
        selectStatuses: 'Status auswählen',
        actions: {
          filter: 'Filtern',
          export: 'Exportieren',
        },
        quick: {
          today: 'Heute',
          week: 'Diese Woche',
          month: 'Diesen Monat',
          lastMonth: 'Letzten Monat',
          year: 'Dieses Jahr',
        },
        stats: {
          title: 'Allgemeine Statistiken',
          totalCoupons: 'Gesamtanzahl Gutscheine',
          activeCoupons: 'Aktive Gutscheine',
          totalUsages: 'Gesamtnutzungen',
          totalDiscount: 'Insgesamt Rabattiert',
        },
        distribution: {
          title: 'Verteilung nach Typ',
        },
        monthlyUsage: {
          title: 'Monatliche Nutzung',
        },
        series: {
          usageCount: 'Nutzungsanzahl',
          numberOfUses: 'Anzahl der Nutzungen',
          discountValue: 'Rabattwert',
        },
        table: {
          details: 'Gutschein-Details',
        },
        statusLabels: {
          true: 'Aktiv',
          false: 'Inaktiv',
        },
        statusOptions: {
          all: 'Alle',
          active: 'Aktiv',
          inactive: 'Inaktiv',
          expired: 'Abgelaufen',
        },
      },

      order_print: {
        title: 'Überprüfen Sie die Bestellinformationen, bevor Sie den Druck bestätigen',
        print_text: 'Drucken',
        information:
          'Der QZ Tray fordert die Berechtigung zum Aufbau der Verbindung an. Klicken Sie auf "Zulassen", um mit dem Druck fortzufahren.',
        order_details: 'Bestelldetails',
        client: 'Kunde',
        payment: 'Zahlung',
        created: 'Erstellt',
        print: 'Bestellung drucken',
        print_confirm:
          'Möchten Sie diese Bestellung drucken? Stellen Sie sicher, dass der Drucker ordnungsgemäß verbunden und konfiguriert ist, bevor Sie fortfahren',
      },

      whatsappweb: {
        title: 'WhatsApp Web',
        subtitle:
          'Hier sind die WhatsApp-Konfigurationen zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        titleCreate: 'WhatsApp synchronisieren',
        titleDelete: 'WhatsApp-Synchronisierung entfernen',
        create: 'WhatsApp synchronisieren',
        delete: 'WhatsApp-Sitzung löschen',
        active: 'Aktiv',
        welcome: 'Ninegrid WhatsApp Web',
        describe_whatsappweb: 'Hier können Sie WhatsApp WEB mit dem Handy des Stores verknüpfen!',
        config: 'WhatsApp konfigurieren',
        step1: 'Öffnen Sie WhatsApp auf Ihrem Handy.',
        step2:
          'Tippen Sie auf "Weitere Optionen" ⋮ auf Android oder auf "Einstellungen" ⚙️ auf iPhone.',
        step3: 'Tippen Sie auf "Verknüpfte Geräte" und dann auf "Gerät verknüpfen".',
        step4: 'Richten Sie Ihr Handy auf diesen Bildschirm, um den QR-Code zu scannen.',
      },
      fileManagement: {
        title: 'Dateimanager',
        subtitle: 'Hier sind die Dateien zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        create: 'Datei erstellen',
        edit: 'Datei bearbeiten',
        delete: 'Datei löschen',
        download: 'Datei herunterladen',
        upload: 'Datei hochladen',
        file: 'Datei',
        file_name: 'Dateiname',
        file_item: 'Element',
        file_itens: 'Elemente',
        file_type: 'Dateityp',
        file_size: 'Dateigröße',
        file_date: 'Erstellungsdatum',
        file_actions: 'Aktionen',
        file_folder: 'Ordner',
        file_new_folder: 'Neuer Ordner',
        file_folder_name: 'Name des Ordners',
        file_last_modified: 'Zuletzt geändert',
        file_description: 'Beschreibung der Datei',
        file_description_placeholder: 'Beschreibung der Datei',
        file_description_helper: 'Maximal 200 Zeichen',
        file_name_placeholder: 'Dateiname',
        file_name_helper: 'Maximal 15 Zeichen',
        file_page_showing: 'Anzeige',
        file_not_found: 'Keine Datei gefunden',
        file_uploading: 'Datei wird geladen',
        file_upload: 'Datei hochladen',
        file_changing: 'Datei wird geändert',
        file_Loading: 'Dateien werden geladen',
        file_update: 'Aktualisieren',
        file_sync_knowledge_base: 'Wissensdatenbank synchronisieren',
        file_history_sync: 'Synchronisierungsverlauf',
        scanned: 'Gescant',
        indexed: 'Indiziert',
        modified: 'Geändert',
        completed: 'Abgeschlossen',
        deleted: 'Gelöscht',
        failed: 'Fehlgeschlagen',
        available: 'Verfügbar',
        last_update: 'Letzte Aktualisierung',
        status: 'Status',
        status_job: 'Status der Aufgabe',
        data_source: 'Datenquelle',
        knowledge_base: 'Wissensdatenbank',
        history_sync: 'Synchronisierungsverlauf',
        chart_scanned_doc: 'Gescante Dokumente',
        chart_indexed_doc: 'Indizierte Dokumente',
        chart_modified_doc: 'Geänderte Dokumente',
        chart_deleted_doc: 'Gelöschte Dokumente',
        chart_failed_doc: 'Fehlgeschlagene Dokumente',
        chart_docs_processed: 'Verarbeitete Dokumente',
        chart_docs_total: 'Gesamtanzahl Dokumente',
        total_jobs_processed: 'Gesamtanzahl verarbeiteter Aufgaben',
        jobs_info: 'Informationen zu den Aufgaben',
        observation_table_jobs_phase:
          'Die Tabelle der verarbeiteten Aufgaben zeigt die letzten 5 Aufgaben jeder Datenquelle.',
      },
      service_requests: {
        title: 'Service-Formulare',
        subtitle: 'Verwalten Sie die Formulare für Service-Anfragen',
        create: 'Service-Formular erstellen',
        edit: 'Service-Formular bearbeiten',
        delete: 'Service-Formular löschen',
        create_form: 'Formular erstellen',
        edit_form: 'Formular bearbeiten',
        delete_form: 'Formular löschen',
        form_title: 'Titel',
        form_icon: 'Symbol',
        form_status: 'Status',
        form_description: 'Beschreibung',
        form_components: 'Komponenten',
        form_grids: 'Grids',
        priority_label: 'Priorität',
        priority_low: 'Niedrig',
        priority_normal: 'Normal',
        priority_high: 'Hoch',
        priority_critical: 'Kritisch',
        choose_icon: 'Auswählen',
        add_component: 'Hinzufügen',
        sections: 'Abschnitte',
        empty_message:
          'Klicken Sie auf "Hinzufügen", um Komponenten einzufügen, und ziehen Sie, um die Reihenfolge zu ändern.',
        success_created: 'Das Service-Formular wurde erfolgreich erstellt.',
        success_updated: 'Das Service-Formular wurde erfolgreich aktualisiert.',
        success_deleted: 'Service-Formular erfolgreich gelöscht.',
        error_create: 'Beim Erstellen des Service-Formulars ist ein Fehler aufgetreten.',
        error_update: 'Beim Aktualisieren des Service-Formulars ist ein Fehler aufgetreten.',
        error_delete: 'Fehler beim Löschen des Service-Formulars.',
        error_load: 'Fehler beim Laden!',
        validation_title: 'Bitte geben Sie einen Titel für die Sitzung ein',
        validation_icon: 'Bitte wählen Sie ein Symbol für die Sitzung aus',
        validation_components: 'Fügen Sie mindestens eine Komponente hinzu, bevor Sie speichern',
        placeholder_title: 'Beispiel: Reinigung',
        icon_selected: 'Ausgewähltes Symbol (SVG)',
        icon_none: 'Kein Symbol ausgewählt',
        visual_instructions:
          'Erstellen Sie die Sitzung visuell. Ziehen Sie, um die Reihenfolge zu ändern. Die Felder sind nur visuell (nicht interaktiv).',
        component: 'Komponente',
        components_plural: 'Komponenten',
        grid: 'Grid',
        grids_plural: 'Grids',
        grid_services: 'Service-Grids',
        grid_services_title: 'Service-Grids auswählen',
        grid_services_search: 'Grids suchen',
        grid_services_label: 'Grids',
        grid_services_selected: 'Ausgewählte Grids',
        grid_services_error: 'Fehler beim Suchen von Hotel-Grids',
        add_component_modal: 'Komponente hinzufügen',
        validation_grids_required: 'Grids obligatorisch',
        validation_grids_text:
          'Alle Auswahlkomponenten müssen mindestens ein ausgewähltes Service-Grid haben.',
        actions: 'Aktionen',
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_essential_services: 'Essentielle Services',
        // UI Elemente
        drag_title: 'Ziehen',
        drag_action: 'Ziehen Sie',
        remove_title: 'Entfernen',
        remove_aria_label: 'Block entfernen',
        max_quantity_title: 'Maximale Menge:',
        max_prefix: 'Max:',
        description_label: 'Beschreibung',
        sections_label: 'Abschnitte',
        // Modal-Titel und Aktionen
        select_icon_title: 'Auswählen',
        no_icons_available: 'Keine Symbole verfügbar…',
        search_placeholder: 'Zum Suchen tippen...',
        grid_services_selected_label: 'Ausgewählt:',
        no_grid_found: 'Kein Grid gefunden',
        no_grid_available: 'Kein Grid verfügbar',
        grid_status_active: 'Aktiv',
        grid_status_inactive: 'Inaktiv',
        grid_item_name_placeholder: 'Name (z. B.: Entspannungsmassage)',
        grid_item_value_placeholder: 'Wert (z. B.: 50,00)',
        cancel_button: 'Abbrechen',
        save_button: 'Speichern',
        confirm_button: 'Bestätigen',
        // Mengen-Modal
        max_quantity_modal_title: 'Maximale Menge definieren',
        max_quantity_label: 'Maximale Menge',
        max_quantity_placeholder: 'Maximale Menge eingeben',
        max_quantity_helper:
          'Definiert die maximale Anzahl von Elementen, die in diesem Feld ausgewählt werden können.',
        // Breadcrumbs
        breadcrumb_create: 'Erstellen',
        breadcrumb_edit: 'Bearbeiten',
        // Formular-Komponenten
        sample_service_1: 'Service 1',
        sample_service_2: 'Service 2',
        sample_hygiene: 'Hygiene',
        sample_drinks: 'Getränke',
        room_number_label: 'Zimmernummer',
        select_placeholder: 'Auswählen...',
        date_label: 'Datum',
        hour_label: 'Stunde',
        quantity_label: 'Menge',
        between_placeholder: 'Zwischen',
        and_placeholder: 'und',
        select_list_label: 'Auswahl (Liste)',
        select_item_placeholder: 'Ein Element auswählen',
        select_checkbox_label: 'Auswahl (Checkbox)',
        // Visibility
        visible_to_label: 'Sichtbar für',
        visible_to_employees: 'Mitarbeiter',
        visible_to_customers: 'Kunden',
        visible_to_both: 'Beide',
        select_category_placeholder: 'Eine Kategorie auswählen',
        select_quantity_label: 'Auswahl (Menge)',
        qty_label: 'Menge',
        // Katalog-Titel
        catalog_room_number: 'Zimmernummer',
        catalog_date: 'Datum',
        catalog_hour: 'Stunde',
        catalog_date_hour: 'Datum + Stunde',
        catalog_select_list: 'Auswahl (Liste)',
        catalog_select_list_quantity: 'Auswahl (Liste) + Menge',
        catalog_select_checkbox: 'Auswahl (Checkbox)',
        catalog_select_count: 'Auswahl (Menge)',
        catalog_quantity: 'Menge',
      },
      base_modal: {
        attention_title: 'Achtung!',
        unsaved_changes_text:
          'Die vorgenommenen Änderungen gehen verloren. Sind Sie sicher, dass Sie die Seite verlassen möchten?',
        confirm_button: 'Ja',
        cancel_button: 'Nein',
      },
      summarize_ia: {
        title: 'Zusammenfassung der KI-Nutzung',
        subtitle: 'Hier sind die Zusammenfassungs-Informationen der KI aufgeführt.',
        create: 'KI-Zusammenfassung erstellen',
        edit: 'KI-Zusammenfassung bearbeiten',
        delete: 'KI-Zusammenfassung löschen',
        summarize: 'Zusammenfassen',
      },
      hospitality: {
        add_room: 'Zimmer hinzufügen',
        create_multiples: 'Mehrere erstellen',
        add_activity: 'Aktivität hinzufügen',
        add_experience: 'Erlebnis hinzufügen',
        experiences: 'Erlebnisse',
        experience_type: 'Erlebnis-Typ',
        experience_duration: 'Dauer',
        experience_price: 'Preis',
        experience_rating: 'Bewertung',
        experience_includes: 'Inklusive',
        create_experience: 'Erlebnis erstellen',
        edit_experience: 'Erlebnis bearbeiten',
        experience_created: 'Erlebnis erfolgreich erstellt!',
        experience_updated: 'Erlebnis erfolgreich aktualisiert!',
        experience_deleted: 'Erlebnis erfolgreich gelöscht!',
      },
      hospitality_content: {
        page_title: 'Schaltflächen',
        page_subtitle: 'Die Schaltflächen für die Bereiche sind hier aufgelistet.',
        add_button: 'Schaltfläche hinzufügen',
        filters: {
          sections: 'Bereiche',
        },
        table: {
          headers: {
            title: 'Titel',
            order: 'Reihenfolge',
            formTitle: 'Formulartitel',
            type: 'Typ',
            visibility: 'Sichtbarkeit',
            actions: 'Aktionen',
          },
        },
        tabs: {
          buttons: 'Schaltflächen',
          native_buttons: 'Native Schaltflächen',
        },
        actions: {
          edit: 'Schaltfläche bearbeiten',
          delete: 'Schaltfläche löschen',
          delete_confirm: 'Sind Sie sicher, dass Sie diese Schaltfläche löschen möchten?',
        },
        type_labels: {
          service_form: 'Service-Formulare',
          feedback: 'Ihr Feedback',
          service: 'Dienstleistungen',
          information: 'Informationen',
          activities_leisure: 'Aktivitäten und Freizeit',
          bars_restaurants: 'Bars und Restaurants',
          schedule: 'Programm',
          experience: 'Erfahrung',
          booking: 'Terminplanung',
          check_in: 'Check-in',
          check_out: 'Check-out',
          tours: 'Touren',
          page_dynamic: 'Dynamische Seite',
        },
        no_category: 'Keine Kategorie',
        messages: {
          filter_error_title: 'Fehler',
          filter_error_text: 'Fehler beim Filtern der Bereiche',
          load_error_title: 'Ladefehler',
          load_error_text: 'Bereiche konnten nicht geladen werden!',
          section_not_found_title: 'Fehler',
          section_not_found_text: 'Bereich nicht gefunden!',
          deleted_title: 'Bereich gelöscht',
          deleted_text: 'Löschung erfolgreich durchgeführt!',
          delete_error: 'Fehler beim Löschen des Bereichs!',
          visibility_updated_title: 'Sichtbarkeit Aktualisiert',
          visibility_updated_text:
            'Die Sichtbarkeit der Schaltfläche wurde erfolgreich aktualisiert!',
          visibility_error_title: 'Aktualisierungsfehler',
          visibility_error_text: 'Fehler beim Aktualisieren der Sichtbarkeit der Schaltfläche!',
          form: 'Formular',
          page: 'Seite',
        },
        create_modal: {
          modal_title: 'Inhalt hinzufügen',
          alert_title: 'Auswahl von Bereich und Inhalt',
          alert_subtitle: 'Wählen Sie den entsprechenden Bereich und Inhalt aus.',
          label_section: 'Bereich',
          label_content: 'Inhalt',
          placeholder_select: 'Auswählen',
          placeholder_select_section: 'Bereich auswählen',
          placeholder_select_content: 'Inhalt auswählen',
          order_label: 'Reihenfolge',
          selection_summary: 'Zusammenfassung der Auswahl:',
          badge_section: 'Bereich',
          badge_content: 'Inhalt',
          select_form_label: 'Formular auswählen (Room Service)',
          tips_title: 'Tipps',
          tips: {
            item1: 'Der Bereich kann mehrere Inhalte haben',
            item2: 'Der Inhalt kann zu mehreren Bereichen gehören',
            item3: 'Die Reihenfolge bestimmt die Position in der Liste',
          },
          buttons: {
            cancel: 'Abbrechen',
            create: 'Erstellen',
          },
          swal: {
            missing_field_title: 'Feld fehlt',
            missing_section: 'Wählen Sie einen Bereich, um fortzufahren',
            missing_content: 'Wählen Sie einen Inhalt, um fortzufahren',
            invalid_field_title: 'Ungültiges Feld',
            invalid_order: 'Die Reihenfolge muss eine positive Zahl oder Null sein',
            created_title: 'Inhalt registriert',
            created_text: 'Registrierung erfolgreich durchgeführt!',
            create_error: 'Fehler bei der Registrierung des Inhalts!',
          },
        },
        edit_modal: {
          modal_title: 'Inhalt bearbeiten',
          alert_title: 'Inhaltsbearbeitung',
          alert_subtitle:
            'Ändern Sie bei Bedarf den Bereich und die Reihenfolge. Der aktuelle Inhalt kann nicht geändert werden.',
          label_section: 'Bereich',
          label_content: 'Inhalt',
          placeholder_select: 'Auswählen',
          placeholder_select_section: 'Bereich auswählen',
          placeholder_select_content: 'Inhalt auswählen',
          order_label: 'Reihenfolge',
          selection_summary: 'Zusammenfassung der Auswahl:',
          badge_section: 'Bereich',
          badge_content: 'Inhalt',
          tips_title: 'Tipps',
          tips: {
            item1: 'Sie können nur den Bereich ändern',
            item2: 'Die Reihenfolge bestimmt die Position in der Liste',
          },
          buttons: {
            cancel: 'Abbrechen',
            save: 'Speichern',
          },
          swal: {
            missing_field_title: 'Feld fehlt',
            missing_section: 'Wählen Sie einen Bereich, um fortzufahren',
            missing_content: 'Wählen Sie einen Inhalt, um fortzufahren',
            invalid_field_title: 'Ungültiges Feld',
            invalid_order: 'Die Reihenfolge muss eine positive Zahl oder Null sein',
            updated_title: 'Inhalt aktualisiert',
            updated_text: 'Aktualisierung erfolgreich durchgeführt!',
            update_error: 'Fehler beim Aktualisieren des Inhalts!',
          },
        },
        category: {
          page_title: 'Bereiche',
          page_subtitle:
            'Hier sind die Inhaltsbereiche zusammen mit ihren jeweiligen Aktionen aufgelistet.',
          add_button: 'Hinzufügen',
          breadcrumbs: {
            dashboard: 'Dashboard',
            categories: 'Kategorien',
          },
          table: {
            headers: {
              section: 'Bereich',
              order: 'Reihenfolge',
              status: 'Status',
              actions: 'Aktionen',
            },
          },
          options: {
            edit_category: 'Kategorie bearbeiten',
            delete_section: 'Bereich löschen',
            delete_confirm: 'Bereich löschen',
          },
          swal: {
            deleted_title: 'Bereich gelöscht',
            deleted_text: 'Löschung erfolgreich durchgeführt!',
            delete_error: 'Fehler beim Löschen des Bereichs!',
          },
          create: {
            missing_fields_title: 'Fehlende Felder',
            missing_fields_text: 'Überprüfen Sie, ob Sie alle Felder korrekt ausgefüllt haben!',
            created_title: 'Kategorie registriert',
            created_text: 'Registrierung erfolgreich durchgeführt!',
            create_error: 'Fehler bei der Registrierung der Kategorie!',
          },
          update: {
            missing_fields_title: 'Fehlende Felder',
            missing_fields_text: 'Überprüfen Sie, ob Sie alle Felder korrekt ausgefüllt haben!',
            updated_title: 'Kategorie aktualisiert',
            updated_text: 'Bearbeitung erfolgreich durchgeführt!',
            update_error: 'Fehler beim Aktualisieren der Kategorie!',
          },
          type: {
            default: 'Standard',
            banner: 'Banner',
          },
        },
      },
      clean_safe: {
        title: 'Clean & Safe',
        subtitle: 'Verwalten Sie Sicherheitsmaßnahmen, Reinigungsprotokolle und Zertifizierungen',
        security_measures: 'Sicherheitsmaßnahmen',
        cleaning_protocols: 'Reinigungsprotokolle',
        certifications: 'Zertifizierungen',
        add_security_measure: 'Maßnahme hinzufügen',
        add_cleaning_protocol: 'Protokoll hinzufügen',
        add_certification: 'Zertifizierung hinzufügen',
        add_new_security_measure: 'Neue Maßnahme hinzufügen',
        add_new_cleaning_protocol: 'Neues Protokoll hinzufügen',
        add_new_certification: 'Neue Zertifizierung hinzufügen',
        security_measure: 'Sicherheitsmaßnahme',
        cleaning_protocol: 'Reinigungsprotokoll',
        certification: 'Zertifizierung',
        icon: 'Symbol',
        choose_icon: 'Symbol auswählen',
        title_field: 'Titel',
        description: 'Beschreibung',
        status: 'Status',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        remove: 'Entfernen',
        save: 'Speichern',
        required_title: 'Titel ist obligatorisch',
        required_icon: 'Symbol ist obligatorisch',
        required_fields: 'Obligatorische Felder',
        required_fields_message: 'Bitte füllen Sie alle obligatorischen Felder aus.',
        confirmation: 'Bestätigung',
        delete_security_measure_confirm:
          'Sind Sie sicher, dass Sie diese Sicherheitsmaßnahme löschen möchten?',
        delete_cleaning_protocol_confirm:
          'Sind Sie sicher, dass Sie dieses Reinigungsprotokoll löschen möchten?',
        delete_certification_confirm:
          'Sind Sie sicher, dass Sie diese Zertifizierung löschen möchten?',
        yes: 'Ja',
        no: 'Nein',
        error: 'Fehler',
        error_delete: 'Fehler beim Löschen des Elements.',
        success: 'Erfolg',
        success_save: 'Hygiene- und Sicherheitsdaten erfolgreich gespeichert!',
        error_save: 'Beim Speichern der Daten ist ein Fehler aufgetreten.',
        empty_security_measures: 'Noch keine Sicherheitsmaßnahmen hinzugefügt.',
        empty_cleaning_protocols: 'Noch keine Reinigungsprotokolle hinzugefügt.',
        empty_certifications: 'Noch keine Zertifizierungen hinzugefügt.',
        empty_start_message: 'Klicken Sie auf "Hinzufügen", um zu beginnen.',
        placeholder_security_title: 'Titel der Sicherheitsmaßnahme eingeben',
        placeholder_protocol_title: 'Titel des Protokolls eingeben',
        placeholder_certification_title: 'Titel der Zertifizierung eingeben',
        placeholder_security_description: 'Kurze Beschreibung eingeben (maximal 100 Zeichen)',
        placeholder_protocol_description:
          'Detaillierte Beschreibung des Reinigungsprotokolls eingeben',
      },
      orders_room_service: {
        title: 'Zimmerbestellungen',
        subtitle: 'Verwaltung von Hotel-Serviceanfragen',

        // Filter
        status: 'Status',
        start_date: 'Startdatum',
        end_date: 'Enddatum',
        reservation_id: 'Buchungscode',
        post_id: 'Post-ID',
        service_type: 'Service-Typ',
        search: 'Suchen',
        clear_filters: 'Filter löschen',

        // Status
        status_pending: 'Ausstehend',
        status_confirmed: 'Bestätigt',
        status_in_progress: 'Im Gange',
        status_cancelled: 'Storniert',
        status_concluded: 'Abgeschlossen',
        status_completed: 'Abgeschlossen',

        // Filteroptionen
        all_status: 'Alle Status',
        all_types: 'Alle Typen',
        service_forms: 'Service-Formulare',
        services: 'Services',

        // Tabellen-Header
        service: 'Service',
        room: 'Zimmer',
        price: 'Preis',
        people_qty: 'Anzahl Personen',
        reservation: 'Buchung',
        date: 'Datum',
        time: 'Uhrzeit',
        priority: 'Priorität',
        created_at: 'Erstellt am',
        actions: 'Aktionen',

        // Tooltip-Aktionen
        view_details: 'Details anzeigen',
        change_status: 'Status ändern',

        // Detail-Modal
        order_details: 'Bestelldetails',
        close: 'Schließen',
        loading_details: 'Bestelldetails werden geladen...',
        loading: 'Wird geladen...',

        // Bestellinformationen
        order: 'Bestellung',
        room_service: 'Zimmerservice',
        location: 'Standort',
        room_number: 'Zimmernummer',
        scheduled_date: 'Geplantes Datum',
        no_time: 'Ohne Uhrzeit',
        reservation_id_label: 'Buchungscode',

        // Kundeninformationen
        customer_info: 'Kundeninformationen',
        full_name: 'Vollständiger Name',
        email: 'E-Mail',
        phone: 'Telefon',

        // Anforderungsdetails
        request_summary: 'Zusammenfassung der Anfrage',
        service_details: 'Service-Details',
        request_details: 'Details der Anfrage',
        no_items_selected: 'Keine Elemente ausgewählt',
        not_informed: 'Nicht informiert',
        units: 'Einheiten',

        // Technische Informationen
        technical_info: 'Technische Informationen',
        post: 'Post',
        booking_type: 'Buchungstyp',
        hotel_info: 'Hotelinformationen',
        hotel_name: 'Hotelname',
        subdomain: 'Subdomain',
        type: 'Typ',
        service_form: 'Service-Formular',
        last_update: 'Letzte Aktualisierung',
        additional_notes: 'Zusätzliche Anmerkungen',

        // Modal zur Statusänderung
        change_status_title: 'Status ändern',
        current_status: 'Aktueller Status',
        new_status: 'Neuer Status',
        select_status: 'Einen Status auswählen',

        // Platzhalter
        select_status_placeholder: 'Status auswählen',
        select_service_type_placeholder: 'Service-Typ auswählen',
        start_date_placeholder: 'Startdatum',
        end_date_placeholder: 'Enddatum',
        reservation_id_placeholder: 'Buchungs-ID eingeben',
        post_id_placeholder: 'Post-ID eingeben',
        new_status_placeholder: 'Neuen Status auswählen',

        // Fehler- und Erfolgsmeldungen
        error: 'Fehler',
        success: 'Erfolg',
        warning: 'Achtung',
        error_loading_orders: 'Fehler beim Laden der Bestellungen!',
        error_loading_details: 'Fehler beim Laden der Bestelldetails!',
        error_changing_status: 'Fehler beim Ändern des Bestellstatus!',
        success_status_changed: 'Status erfolgreich geändert!',
        select_status_warning: 'Bitte wählen Sie einen Status aus.',

        // Kundenbewertung
        customer_review: 'Kundenbewertung',
        rating: 'Bewertung',
        review_comment: 'Kommentar',
      },
      s3Analytics: {
        title: 'S3-Analyse',
        startDate: 'Startdatum',
        endDate: 'Enddatum',
        pluginspaceId: 'Pluginspace-ID',
        pluginspaceIdPlaceholder: 'Pluginspace-ID eingeben',
        method: 'Methode',
        methodPlaceholder: 'Methode eingeben (GET, POST, etc.)',
        loadData: 'Daten laden',
        generateAIAnalysis: 'KI-Analyse generieren',
        chatWithAI: 'Mit KI chatten',
        showRanking: 'Ranking anzeigen',
        analyzeWithAI: 'Mit KI analysieren',
        close: 'Schließen',
        totalRequests: 'Gesamtanzahl Anfragen',
        totalCost: 'Gesamtkosten',
        averageCostPerRequest: 'Durchschnittliche Kosten pro Anfrage',
        consumptionByPluginspace: 'Verbrauch pro Pluginspace',
        consumptionByMethod: 'Verbrauch pro Methode',
        consumptionByDate: 'Verbrauch pro Datum',
        costAnalysis: 'Kostenanalyse',
        aiAnalysis: 'KI-Analyse',
        chatMessage: 'Geben Sie Ihre Frage zu den Daten ein...',
        speakAnalysis: 'Analyse anhören',
        filterData: 'Daten filtern',
        noDataFound: 'Keine Daten für die ausgewählten Filter gefunden',
        errorLoadingData: 'Fehler beim Laden der Daten',
        errorGeneratingAnalysis: 'Fehler beim Generieren der KI-Analyse',
        analysisGenerated: 'Analyse erfolgreich generiert!',
        dataLoaded: 'Daten erfolgreich geladen!',
        rankingData: 'Ranking-Daten',
        aiChatResponse: 'KI-Antwort',
        s3Analytics: 'S3-Analyse',
        filters: 'Filter',
        totalConsumption: 'Gesamtverbrauch',
        totalRecords: 'Gesamtanzahl Datensätze',
        error: 'Fehler',
        fetchError: 'Fehler beim Abrufen der S3-Daten',
        aiAnalysisError: 'Fehler beim Generieren der KI-Analyse',
        aiChatError: 'Fehler beim Chatten mit KI',
        askQuestion: 'Geben Sie Ihre Frage zu den Daten ein...',
        ask: 'Fragen',
        cancel: 'Abbrechen',
        ok: 'OK',
        aiResponse: 'KI-Antwort',
        aiAnalysisTitle: 'KI-Analyse',
        account: 'Konto',
        pluginspace: 'Store',
        uniquePluginspaces: 'Eindeutige Stores',
        methodDistribution: 'Verteilung nach Methode',
        timeAnalysis: 'Zeitanalyse',
        dataTable: 'Datentabelle',
        showingFirst10: 'Anzeige der ersten 10',
        of: 'von',
        records: 'Einträgen',
        consumption: 'Verbrauch',
        cost: 'Kosten',
        date: 'Datum',
        allMethods: 'Alle Methoden',
        exportData: 'Daten exportieren',
      },
      hospitality_store: {
        establishment: 'Einrichtung',
        select_establishment: 'Auswählen...',
        link: 'Link',
        status: 'Status',
        payment_integrated: 'Integrierte Zahlung',
        order: 'Reihenfolge',
        store_image: 'Bild des Stores',
        store_image_hint: 'Wählen Sie ein repräsentatives Bild des Stores aus',
        description: 'Beschreibung',
        cnpj: 'CNPJ',
        code: 'Code',
        store_id_placeholder: 'Store-ID',
        type: 'Typ',
        store_type_placeholder: 'Typ der Einrichtung',
        no_store_found: 'Keine Einrichtung gefunden.',
        edit_store: 'Einrichtung bearbeiten',
        edit_store_subtitle: 'Daten der Einrichtung bearbeiten.',
      },
      stores_pages: {
        title: 'Einrichtungen',
        subtitle:
          'Hier sind die Einrichtungen des Hotels zusammen mit ihren jeweiligen Aktionen aufgeführt.',
        create: 'Einrichtung erstellen',
        no_results: 'Keine Einrichtung gefunden.',
        table: {
          code: 'Code',
          image: 'Bild',
          name: 'Store',
          cnpj: 'CNPJ',
          vinculation: 'Verknüpfung',
          vinculation_default: 'Standard',
          vinculation_dynamic: 'Dynamisch',
          type: 'Typ',
          order: 'Reihenfolge',
          status: 'Status',
          status_active: 'Aktiv',
          status_inactive: 'Inaktiv',
          payment_integrated: 'Integrierte Zahlung',
          actions: 'Aktionen',
        },
        actions: {
          edit: 'Einrichtung bearbeiten',
          delete_confirm: 'Sind Sie sicher, dass Sie löschen möchten?',
          delete: 'Einrichtung löschen',
        },
        delete_success: 'Einrichtung erfolgreich gelöscht.',
        delete_error: 'Fehler beim Löschen der Einrichtung. Bitte versuchen Sie es erneut.',
        success: 'Erfolg!',
        error: 'Fehler!',
      },
      stores_pages_create: {
        title: 'Einrichtung erstellen',
        subtitle: 'Erstellen Sie eine neue Einrichtung für das Hotel.',
        form: {
          establishment: 'Einrichtung',
          select_placeholder: 'Auswählen...',
          link: 'Link',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: 'Status',
          status_options: {active: 'Aktiv', inactive: 'Inaktiv'},
          payment_integrated: 'Integrierte Zahlung',
          payment_options: {active: 'Aktiv', inactive: 'Inaktiv'},
          order: 'Reihenfolge',
          image_label: 'Bild der Einrichtung',
          image_smalltext: 'Wählen Sie ein repräsentatives Bild der Einrichtung aus',
          description: 'Beschreibung',
          info_title: 'Informationen zur Einrichtung',
          cnpj: 'CNPJ',
          code: 'Code',
          type: 'Typ',
          vinculation_label: 'Art der Verknüpfung',
          vinculation_options: {default: 'Standard', dynamic: 'Dynamisch'},
          empty_message: 'Keine Einrichtung gefunden.',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: 'Store-ID',
        },
        console_messages: {
          image_upload_error: 'Fehler beim Hochladen des Bildes',
        },
        messages: {
          warning_title: 'Achtung',
          select_store_warning:
            'Bitte wählen Sie eine gültige Einrichtung aus, bevor Sie speichern.',
          error_saving:
            'Beim Speichern der Einrichtung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
          success_saved: 'Einrichtung erfolgreich gespeichert.',
        },
      },
      feedback_reviews: {
        title: 'Such- und Zufriedenheitsbewertungen',
        subtitle:
          'Alle Bewertungen und Antworten aus den Feedback-Formularen anzeigen und verwalten',
        breadcrumb_feedback: 'Zufriedenheits-Feedback',
        error: 'Fehler',
        success: 'Erfolg',
        loading: 'Wird geladen...',
        loading_details: 'Details der Bewertung werden geladen...',
        close: 'Schließen',
        error_loading_reviews: 'Fehler beim Laden der Bewertungen',
        error_loading_details: 'Fehler beim Laden der Bewertungsdetails',
        error_changing_status: 'Fehler beim Ändern des Bewertungsstatus',
        success_status_changed: 'Status erfolgreich geändert',
        confirm_status_change: 'Statusänderung bestätigen',
        confirm_status_change_text:
          'Sind Sie sicher, dass Sie den Status dieser Bewertung ändern möchten?',

        // Status
        status_pending: 'Ausstehend',
        status_approved: 'Genehmigt',
        status_rejected: 'Abgelehnt',

        // Feldtypen, die in Antworten angezeigt werden
        types: {
          title: 'Titel',
          text: 'Text',
          textarea: 'Textbereich',
          stars: 'Bewertung',
          checkbox: 'Kontrollkästchen',
          radio: 'Einzelauswahl',
          select: 'Auswahl',
          number: 'Zahl',
          date: 'Datum',
          time: 'Uhrzeit',
          image: 'Bild',
          link: 'Link',
        },

        anonymous_active: 'Aktiv',
        anonymous_inactive: 'Inaktiv',

        // Filter
        filters: {
          feedback_form: 'Formular',
          status: 'Status',
          anonymous: 'Anonym',
          select_anonymous_placeholder: 'Alle',
          rating: 'Bewertung',
          reservation_id: 'Reservierungs-ID',
          start_date: 'Startdatum',
          end_date: 'Enddatum',
          date: 'Datum',
          all_forms: 'Alle Formulare',
          all_status: 'Alle Status',
          all_ratings: 'Alle Bewertungen',
          select_form_placeholder: 'Formular auswählen',
          select_status_placeholder: 'Status auswählen',
          select_rating_placeholder: 'Bewertung auswählen',
          reservation_id_placeholder: 'Reservierungs-ID eingeben',
          start_date_placeholder: 'Startdatum auswählen',
          end_date_placeholder: 'Enddatum auswählen',
          filter_button: 'Filtern',
          clear_filters: 'Filter löschen',
        },

        // Tabelle
        table: {
          feedback_form: 'Formular',
          customer: 'Kunde',
          room: 'Zimmer',
          reservation: 'Reservierung',
          rating: 'Bewertung',
          status: 'Status',
          date: 'Datum',
          time: 'Uhrzeit',
          actions: 'Aktionen',
        },

        // Aktionen
        actions: {
          view_details: 'Details anzeigen',
          approve: 'Genehmigen',
          reject: 'Ablehnen',
        },

        // Details der Bewertung
        review_details: 'Details der Bewertung',
        room: 'Zimmer',
        reservation: 'Reservierung',
        feedback_form: 'Formular',
        responses: 'Antworten',
        technical_info: 'Technische Informationen',
        created_at: 'Erstellt am',
        updated_at: 'Aktualisiert am',
        review_id: 'Bewertungs-ID',
        plugin_space_id: 'Plugin Space ID',
        anonymous_response: 'Anonyme Antwort',
        no_reservation_linked: 'Diese Antwort ist keiner spezifischen Reservierung zugeordnet',
        no_detailed_responses: 'Keine detaillierten Antworten für diese Bewertung verfügbar',
        anonymous_label: 'Anonym',
        email_anonymous: 'E-Mail nicht verfügbar (anonyme Antwort)',
        email_not_informed: 'E-Mail nicht angegeben',
        response_title: 'Titel',
        no_rating_provided: 'Keine Bewertung angegeben',
        no_items_selected: 'Keine Elemente ausgewählt',
        no_option_selected: 'Keine Option ausgewählt',
        no_answer_provided: 'Keine Antwort gegeben',
        form_label: 'Formular:',
        client_not_identified: 'Kunde nicht identifiziert',
      },
      stores_pages_edit: {
        title: 'Einrichtung bearbeiten',
        subtitle: 'Daten der Einrichtung bearbeiten.',
        form: {
          establishment: 'Einrichtung',
          select_placeholder: 'Auswählen...',
          link: 'Link',
          link_placeholder: 'https://webapp.ninegrid.com.br/...',
          status: 'Status',
          status_options: {active: 'Aktiv', inactive: 'Inaktiv'},
          payment_integrated: 'Integrierte Zahlung',
          payment_options: {active: 'Aktiv', inactive: 'Inaktiv'},
          order: 'Reihenfolge',
          image_label: 'Bild der Einrichtung',
          image_smalltext: 'Wählen Sie ein repräsentatives Bild der Einrichtung aus',
          description: 'Beschreibung',
          info_title: 'Informationen zur Einrichtung',
          cnpj: 'CNPJ',
          code: 'Code',
          type: 'Typ',
          vinculation_label: 'Art der Verknüpfung',
          vinculation_options: {default: 'Standard', dynamic: 'Dynamisch'},
          empty_message: 'Keine Einrichtung gefunden.',
        },
        placeholders: {
          order: '0',
          cnpj: '00.000.000/0000-00',
          store_id: 'Store-ID',
        },
        console_messages: {
          image_upload_error: 'Fehler beim Hochladen des Bildes',
          image_remove_error: 'Fehler beim Entfernen des Bildes beim Speichern',
        },
        messages: {
          success_updated: 'Einrichtung erfolgreich aktualisiert.',
          error_updating:
            'Beim Aktualisieren der Einrichtung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
          payment_change_warning_title: 'Achtung',
          payment_change_warning_text:
            'Diese Änderung kann den Wert laufender Buchungen beim Check-out ändern.',
          payment_confirm: 'Ja, fortfahren',
          cancel: 'Abbrechen',
        },
      },
      hospitality_section: {
        index: {
          page_title: 'Veröffentlichungsseiten',
          page_subtitle:
            'Hier sind die Inhaltsveröffentlichungsseiten mit ihren jeweiligen Aktionen aufgelistet.',
          add_button: 'Veröffentlichungsseite hinzufügen',
          filters: {
            sections: 'Veröffentlichungsseite',
          },
          table: {
            headers: {
              title: 'Titel',
              order: 'Reihenfolge',
              formTitle: 'Formulartitel',
              type: 'Typ',
              actions: 'Aktionen',
            },
          },
          actions: {
            edit: 'Veröffentlichungsseiten bearbeiten',
            delete: 'Veröffentlichungsseiten löschen',
          },
        },
        create: {
          page_title: 'Veröffentlichungsseiten erstellen',
          page_subtitle: 'Erstellen Sie eine neue Inhaltsveröffentlichungsseite für das Hotel.',
          add_button: 'Veröffentlichungsseiten hinzufügen',
          filters: {
            sections: 'Bereiche',
          },
        },
        edit: {
          page_title: 'Veröffentlichungsseiten bearbeiten',
          page_subtitle: 'Bearbeiten Sie die Daten der Inhaltsveröffentlichungsseite.',
        },
        // Dynamische Übersetzungen für Bereiche
        types: {
          category: 'Kategorie',
          content: 'Inhalt',
          simple: 'Einfach',
          form: 'Formular',
          page: 'Restaurant und Geschäft',
        },
        status: {
          active: 'Aktiv',
          inactive: 'Inaktiv',
        },
        actions: {
          create: 'Erstellen',
          edit: 'Bearbeiten',
          delete: 'Löschen',
          save: 'Speichern',
          cancel: 'Abbrechen',
          update: 'Aktualisieren',
          remove_icon: 'Symbol entfernen',
          select_icon: 'Symbol auswählen',
        },
        fields: {
          title: 'Button-Titel',
          type: 'Veröffentlichungsseiten-Typ',
          category: 'Kategorie',
          order: 'Reihenfolge',
          status: 'Status',
          icon: 'Symbol',
          icon_selected: 'Symbol ausgewählt',
          icon_not_selected: 'Kein Symbol ausgewählt',
          icon_description: 'Wählen Sie ein Symbol aus der Liste rechts für den Bereich',
          icon_change_description:
            'Wählen Sie ein anderes Symbol aus der Liste rechts oder entfernen Sie das aktuelle',
        },
        placeholders: {
          title: 'Geben Sie den Titel des Buttons ein',
          type: 'Typ auswählen',
          category: 'Kategorie auswählen',
          order: '0',
          search_icon: 'Symbol suchen...',
          all_categories: 'Alle Kategorien',
        },
        warnings: {
          stores:
            "Kein Geschäft vom Typ 'Dynamisch' wurde gefunden.\nUm fortzufahren, gehen Sie zu Einstellungen → Geschäfte und Einrichtungen und konfigurieren Sie ein Geschäft mit dem Typ 'Dynamisch'.",
        },
        messages: {
          validation: {
            title_required: 'Titel ist erforderlich!',
            category_required: 'Wählen Sie eine Kategorie!',
            icon_required: 'Wählen Sie ein Symbol!',
          },
          success: {
            created: 'Veröffentlichungsseiten erfolgreich erstellt!',
            updated: 'Veröffentlichungsseiten erfolgreich aktualisiert!',
            deleted: 'Veröffentlichungsseiten erfolgreich gelöscht!',
          },
          error: {
            create: 'Fehler beim Erstellen der Veröffentlichungsseiten!',
            update: 'Fehler beim Aktualisieren der Veröffentlichungsseiten!',
            delete: 'Fehler beim Löschen der Veröffentlichungsseiten!',
            load: 'Fehler beim Laden der Veröffentlichungsseiten-Daten!',
          },
          confirm: {
            delete_title: 'Sind Sie sicher?',
            delete_text: 'Diese Aktion kann nicht rückgängig gemacht werden!',
            delete_confirm: 'Ja, löschen',
            delete_cancel: 'Abbrechen',
          },
          delete: {
            deleted_title: 'Publikationsseiten gelöscht',
            deleted_text: 'Löschung erfolgreich durchgeführt!',
            error_title: 'Fehler beim Löschen der Publikationsseiten!',
            error_text:
              'Beim Löschen der Publikationsseiten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
          },
        },
      },
      hospitality_classification_post: {
        index: {
          page_title: 'Veröffentlichungskategorien',
          page_subtitle:
            'Hier sind die Veröffentlichungskategorien mit ihren jeweiligen Aktionen aufgelistet.',
          add_button: 'Veröffentlichungskategorie hinzufügen',
          filter_all: 'Alle',
          table: {
            headers: {
              title: 'Titel',
              image: 'Bild',
              summary: 'Zusammenfassung',
              status: 'Status',
              classification: 'Klassifizierung',
              code: 'Code',
              actions: 'Aktionen',
            },
            actions: {
              edit: 'Veröffentlichungskategorie bearbeiten',
              delete: 'Veröffentlichungskategorie löschen',
            },
          },
        },
        create: {
          page_title: 'Veröffentlichungskategorie erstellen',
          page_subtitle: 'Erstellen Sie eine neue Veröffentlichungskategorie für das Hotel.',
          add_button: 'Veröffentlichungskategorie hinzufügen',
          success: {
            created_title: 'Veröffentlichungskategorie erstellt',
            created_text: 'Registrierung erfolgreich abgeschlossen!',
          },
          error: {
            created_title: 'Fehler beim Erstellen der Veröffentlichungskategorie!',
            created_text:
              'Bei der Erstellung der Kategorie ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
          },
        },
        edit: {
          page_title: 'Veröffentlichungskategorie bearbeiten',
          page_subtitle: 'Bearbeiten Sie die Daten der Veröffentlichungskategorie.',
          error: {
            created_title: 'Fehler beim Bearbeiten der Veröffentlichungskategorie!',
            created_text:
              'Bei der Bearbeitung der Kategorie ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
          },
          success: {
            created_title: 'Veröffentlichungskategorie erstellt',
            created_text: 'Registrierung erfolgreich abgeschlossen!',
          },
        },
      },
      hospitality_post: {
        posts: 'Veröffentlichungen',
        index: {
          page_title: 'Veröffentlichungen',
          page_subtitle:
            'Hier sind die Hotelveröffentlichungen mit ihren jeweiligen Aktionen aufgelistet.',
          add_button: 'Veröffentlichung hinzufügen',
          filter_all: 'Alle',
          filter: 'Kategorien',
          table: {
            headers: {
              title: 'Titel',
              image: 'Bild',
              summary: 'Zusammenfassung',
              order: 'Reihenfolge',
              status: 'Status',
              classification: 'Klassifikation',
              actions: 'Aktionen',
            },
            actions: {
              edit: 'Veröffentlichung bearbeiten',
              delete: 'Veröffentlichung löschen',
            },
          },
        },
        create: {
          page_title: 'Veröffentlichung erstellen',
          page_subtitle: 'Erstellen Sie eine neue Veröffentlichung für das Hotel.',
          success: {
            created_title: 'Veröffentlichung erstellt',
            created_text: 'Registrierung erfolgreich abgeschlossen!',
          },
          error: {
            created_title: 'Fehler beim Erstellen der Veröffentlichung!',
            created_text:
              'Bei der Erstellung der Veröffentlichung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
          },
        },
        edit: {
          page_title: 'Veröffentlichung bearbeiten',
          page_subtitle: 'Bearbeiten Sie die Veröffentlichungsdaten.',
          success: {
            created_title: 'Veröffentlichung bearbeitet',
            created_text: 'Registrierung erfolgreich abgeschlossen!',
          },
          error: {
            created_title: 'Fehler beim Bearbeiten der Veröffentlichung!',
            created_text:
              'Bei der Bearbeitung der Veröffentlichung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
          },
        },
        form_validate: {
          title_required: 'Titel ist erforderlich!',
          summary_required: 'Zusammenfassung ist erforderlich!',
          classification_required: 'Klassifikation ist erforderlich!',
          content_required: 'Inhalt ist erforderlich!',
          fields_missing: 'Bitte überprüfen Sie, ob Sie alle Felder ausgefüllt haben!',
        },
      },
      hospitality_post_page: {
        types: {
          simple: 'Einfach',
          section: 'Bereich',
          form: 'Formular',
          category: 'Kategorie',
        },
        index: {
          page_title: 'Veröffentlichungsseiten',
          page_subtitle:
            'Hier sind die Inhaltsveröffentlichungsseiten mit ihren jeweiligen Aktionen aufgelistet.',
          add_button: 'Veröffentlichungsseite hinzufügen',
          edit_button: 'Veröffentlichungsseite bearbeiten',
          delete_button: 'Veröffentlichungsseite löschen',
        },
        create: {
          page_title: 'Veröffentlichungsseite erstellen',
          page_subtitle: 'Erstellen Sie eine neue Inhaltsveröffentlichungsseite für das Hotel.',
          form: {
            title: 'Titel der Veröffentlichungsseite',
            type: 'Typ der Veröffentlichungsseite',
            status: 'Status',
          },
          icon: {
            icon: 'SVG-Symbol',
            lib: 'SVG-Symbol-Bibliothek',
            search: 'Symbol suchen...',
            category: 'Symbol-Kategorie',
            description:
              'Wählen Sie ein Symbol aus der Liste auf der Seite für die Veröffentlichungsseite',
            selected: 'Ausgewähltes Symbol',
            no_selected: 'Kein Symbol ausgewählt',
            selected_description:
              'Wählen Sie ein Symbol aus der Liste auf der Seite für die Veröffentlichungsseite',
            no_selected_description:
              'Kein Symbol ausgewählt. Wählen Sie ein Symbol aus der Liste auf der Seite für die Veröffentlichungsseite',
            change_description:
              'Wählen Sie ein anderes Symbol aus der Liste auf der Seite oder entfernen Sie das aktuelle',
          },
          success: {
            created_title: 'Veröffentlichungsseite erstellt',
            created_text: 'Registrierung erfolgreich abgeschlossen!',
          },
          error: {
            created_title: 'Fehler beim Erstellen der Veröffentlichungsseite!',
            created_text:
              'Bei der Erstellung der Seite ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
          },
        },
        edit: {
          page_title: 'Veröffentlichungsseite bearbeiten',
          page_subtitle: 'Bearbeiten Sie die Daten der Inhaltsveröffentlichungsseite.',
          form: {
            title: 'Titel der Veröffentlichungsseite',
            type: 'Typ der Veröffentlichungsseite',
            status: 'Status',
          },
          icon: {
            icon: 'SVG-Symbol',
            lib: 'SVG-Symbol-Bibliothek',
            search: 'Symbol suchen...',
            category: 'Symbol-Kategorie',
            description:
              'Wählen Sie ein Symbol aus der Liste auf der Seite für die Veröffentlichungsseite',
            selected: 'Ausgewähltes Symbol',
            no_selected: 'Kein Symbol ausgewählt',
            selected_description:
              'Wählen Sie ein Symbol aus der Liste auf der Seite für die Veröffentlichungsseite',
            no_selected_description:
              'Kein Symbol ausgewählt. Wählen Sie ein Symbol aus der Liste auf der Seite für die Veröffentlichungsseite',
            change_description:
              'Wählen Sie ein anderes Symbol aus der Liste auf der Seite oder entfernen Sie das aktuelle',
          },
          success: {
            created_title: 'Veröffentlichungsseite bearbeitet',
            created_text: 'Bearbeitung erfolgreich abgeschlossen!',
          },
          error: {
            created_title: 'Fehler beim Bearbeiten der Veröffentlichungsseite!',
            created_text:
              'Bei der Bearbeitung der Seite ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
          },
        },
      },
      // Translations for Booking Hotel Services
      booking_hotel_services: {
        // Index page
        page_title: 'Service-Reservierungen',
        page_subtitle: 'Service-Reservierungen verwalten',
        breadcrumb_services: 'Buchungs-Services',
        breadcrumb_booking: 'Buchungs-Services',
        create_button: 'Service-Reservierung erstellen',

        // Table headers
        table_image: 'Bild',
        table_title: 'Titel',
        table_order: 'Reihenfolge',
        table_status: 'Status',
        table_actions: 'Aktionen',

        // Table actions
        action_edit: 'Bearbeiten',
        action_delete: 'Löschen',

        // Status
        status_active: 'Aktiv',
        status_inactive: 'Inaktiv',

        // Messages
        delete_success: 'Reservierung gelöscht',
        delete_error: 'Fehler beim Löschen der Reservierung',
        delete_confirm: 'Löschung bestätigen?',

        // Create page
        create_title: 'Service-Reservierung erstellen',
        create_subtitle:
          'Füllen Sie die Informationen aus, um eine neue Service-Reservierung zu erstellen',

        // Edit page
        edit_title: 'Hotel-Reservierung bearbeiten',
        edit_subtitle: 'Reservierungsinformationen bearbeiten',

        // Form fields
        field_title_label: 'Titel',
        field_title_placeholder: 'Z.B.: Spa-Reservierung',
        field_status_label: 'Status',
        field_description_label: 'Beschreibung',
        field_image_label: 'Bild',
        field_icon_label: 'Symbol',

        // Icon picker
        icon_choose: 'Symbol auswählen',
        icon_choose_modal: 'Symbol auswählen',

        // Day configuration
        day_config_title: 'Tag-Konfiguration',
        day_configure: 'Konfigurieren',
        day_periods_title: 'Zeitperioden',
        day_period_add: 'Periode hinzufügen',
        day_period_max: 'Maximum 3 Perioden',
        day_period_none: 'Keine Periode konfiguriert. Fügen Sie mindestens eine Periode hinzu.',
        day_period_overlap:
          'Zeiträume dürfen sich nicht überlappen. Bitte passen Sie die konfigurierten Zeiten an.',
        day_period_label: 'Periode',
        day_period_remove: 'Entfernen',
        day_interval_label: 'Intervall (min)',
        day_start_time_label: 'Startzeit',
        day_end_time_label: 'Endzeit',

        // Day names
        day_sunday: 'Sonntag',
        day_monday: 'Montag',
        day_tuesday: 'Dienstag',
        day_wednesday: 'Mittwoch',
        day_thursday: 'Donnerstag',
        day_friday: 'Freitag',
        day_saturday: 'Samstag',

        // Grid selection
        grid_title: 'Verknüpfte Grids',
        grid_select: 'Grids auswählen',
        grid_selected: 'Grid(s) ausgewählt',
        grid_capacity: 'Kapazität',
        grid_multiple: 'Mehrfach',
        grid_multiple_yes: 'Ja',
        grid_multiple_no: 'Nein',
        grid_status_active: 'Aktiv',
        grid_status_inactive: 'Inaktiv',

        // Action buttons
        button_back: 'Zurück',
        button_save: 'Speichern',
        button_update: 'Aktualisieren',
        button_create: 'Erstellen',
        button_cancel: 'Abbrechen',
        button_confirm: 'Bestätigen',

        // Validation messages
        validation_title_required: 'Pflichtfeld',
        validation_title_text: 'Titel ist erforderlich.',
        validation_icon_required: 'Pflichtfeld',
        validation_icon_text: 'Wählen Sie ein Symbol aus.',
        validation_day_required: 'Konfiguration erforderlich',
        validation_day_text: 'Konfigurieren Sie mindestens einen Wochentag.',

        // Success messages
        success_created: 'Reservierung erstellt',
        success_created_text: 'Die Reservierung wurde erfolgreich erstellt!',
        success_updated: 'Reservierung aktualisiert',
        success_updated_text: 'Die Reservierung wurde erfolgreich aktualisiert!',

        // Error messages
        error_create: 'Fehler beim Erstellen',
        error_create_text: 'Beim Erstellen der Reservierung ist ein Fehler aufgetreten.',
        error_update: 'Fehler beim Aktualisieren',
        error_update_text: 'Beim Aktualisieren der Reservierung ist ein Fehler aufgetreten.',
        error_save: 'Fehler',
        error_save_text: 'Beim Speichern der Reservierung ist ein Fehler aufgetreten.',
        error_load: 'Fehler',
        error_load_text: 'Fehler beim Laden der Reservierungsdaten.',

        // Breadcrumbs
        breadcrumb_dashboard: 'Dashboard',
        breadcrumb_hospitality: 'Gastgewerbe',
        breadcrumb_hotel_reservations: 'Hotel-Reservierungen',
        breadcrumb_create: 'Erstellen',
        breadcrumb_edit: 'Bearbeiten',
      },
    },
    users: {
      houserkeeping: 'Housekeeping',
      maintenancetechnician: 'Wartungstechniker',
      receptionist: 'Rezeptionist',
      manager: 'Manager',
      administrator: 'Administrator',
      waiter: 'Kellner',
      kitchenchief: 'Küchenchef',
      warehouse: 'Lagerleiter',
      concierge: 'Concierge',
      messenger: 'Bote',
      receptionsupervisor: 'Empfangsleiter',
      telephonist: 'Telefonist',
      cook: 'Koch',
      barman: 'Barkeeper',
      roomserviceattendant: 'Zimmerservice-Mitarbeiter',
      steward: 'Steward',
      sommelier: 'Sommelier',
      plumber: 'Klempner',
      airconditiontechnician: 'Klimaanlagen-Techniker',
      maintenancesupervisor: 'Wartungsleiter',
      reservationagent: 'Reservierungsmitarbeiter',
      reservationcoordinator: 'Reservierungskoordinator',
      salesexecutive: 'Vertriebsleiter',
      revenuemanager: 'Revenue Manager',
      commercialmanager: 'Handelsleiter',
      administrativeassistant: 'Verwaltungsassistent',
      financeaccountspayable: 'Finanzen - Kreditorenbuchhaltung',
      accountant: 'Buchhalter',
      humanresources: 'Personalwesen',
      purchasingwarehouse: 'Einkauf und Lager',
      recreator: 'Animateur',
      activityinstructor: 'Aktivitätsleiter',
      experiencecoordinator: 'Erlebniskoordinator',
      tourguide: 'Reiseleiter',
      childmonitor: 'Kinderbetreuer',
      securityguard: 'Sicherheitsdienst',
      doorman: 'Pförtner',
      accesscontroller: 'Zugangskontrolleur',
      securitysupervisor: 'Sicherheitsleiter',
      generalmanager: 'Geschäftsführer',
      assistantmanager: 'Stellvertretender Geschäftsführer',
      operationalmanager: 'Betriebsleiter',
      departmentsupervisorscoordinators: 'Abteilungsleiter und Koordinatoren',
      floormanager: 'Etagenleiter',
      governancesupervisor: 'Housekeeping-Leiter',
      generalservicesassistant: 'Assistent für allgemeine Dienste',
      laundryattendant: 'Wäscherei-Mitarbeiter',
      laundrymanager: 'Wäscheleiter',
      machinist: 'Maschinenführer',
      ironer: 'Bügler',
      electrician: 'Elektriker',
      carpenter: 'Schreiner',
    },
  },
}

export {messages}
